import React__default, { useEffect, forwardRef, createElement, useRef, Children, useState, memo, cloneElement, useCallback, useMemo } from 'react';
import { Flex, Box } from 'reflexbox';
export { Box, BoxProps, Flex, FlexProps } from 'reflexbox';
import styled from '@emotion/styled';
import { createPortal } from 'react-dom';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { animated, useTransition, config, useSpring, useChain } from 'react-spring';
import { border, width, height, space, flexbox, position, maxHeight, overflow, variant, flex, typography, layout, color, shadow, background, compose, alignItems, justifyContent, boxShadow, textStyle, padding, fontSize, margin, fontWeight, fontStyle, fontFamily as fontFamily$1 } from 'styled-system';
export { variant } from 'styled-system';
import { keyframes, Global, css as css$1, CacheProvider } from '@emotion/core';
import { useOnClickOutside, useMedia, useMeasure, useEffectOnce, useBreakpoints, useInView } from '@mafc/hooks';
import { useTheme as useTheme$2, ThemeProvider as ThemeProvider$1 } from 'emotion-theming';
import { rgba } from 'polished';
import reactIs, { Memo, ForwardRef } from 'react-is';
import { Cross, ArrowDark, ArrowDown as ArrowDown$1, Minus, Plus, RightArrow, TopArrow } from '@mafc/icon';
import createCache from '@emotion/cache';
import stylisRtl from 'stylis-plugin-rtl';
import Img from 'react-cool-img';
import InputMask from 'react-input-mask';
import useComponentSize from '@rehooks/component-size';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { useInView as useInView$1 } from 'react-intersection-observer';

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var BreadcrumbList = styled.ol(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style: none;\n  display: flex;\n  align-items: center;\n"], ["\n  list-style: none;\n  display: flex;\n  align-items: center;\n"])));
var BreadcrumbContainer = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  & a {\n    text-decoration: none;\n    color: ", ";\n    font-weight: ", ";\n  }\n  & a :hover {\n    color: ", ";\n  }\n"], ["\n  & a {\n    text-decoration: none;\n    color: ",
    ";\n    font-weight: ",
    ";\n  }\n  & a :hover {\n    color: ",
    ";\n  }\n"])), function (_a) {
    var isItemInTheEnd = _a.isItemInTheEnd, theme = _a.theme;
    var currentTheme = theme;
    return isItemInTheEnd ? currentTheme.colors.copy : currentTheme.colors.blue;
}, function (_a) {
    var theme = _a.theme;
    var currentTheme = theme;
    return currentTheme.fontWeights[4];
}, function (_a) {
    var theme = _a.theme;
    var currentTheme = theme;
    return currentTheme.colors.blue;
});
var BreadcrumbSeparator = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: auto 4px;\n  user-select: none;\n  height: 14px;\n"], ["\n  margin: auto 4px;\n  user-select: none;\n  height: 14px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;

var BreadcrumbItem = function (_a) {
    var label = _a.label, to = _a.to, isItemInTheEnd = _a.isItemInTheEnd, renderItem = _a.renderItem, redirect = _a.redirect;
    return (React__default.createElement(BreadcrumbContainer, { isItemInTheEnd: isItemInTheEnd }, renderItem({ isItemInTheEnd: isItemInTheEnd, to: to, label: label, redirect: redirect })));
};

var BreadcrumbConstants;
(function (BreadcrumbConstants) {
    BreadcrumbConstants["ItemKeyPrefix"] = "breadcrumb_item";
    BreadcrumbConstants["SeparatorKeyPrefix"] = "breadcrumb_separator";
    BreadcrumbConstants["DefaultSeparator"] = "/";
})(BreadcrumbConstants || (BreadcrumbConstants = {}));
var Breadcrumb = function (_a) {
    var routes = _a.routes, separator = _a.separator, renderItem = _a.renderItem, containerStyling = _a.containerStyling;
    var lastIndex = routes.length - 1;
    var children = routes.map(function (route, index) {
        var to = route.to, label = route.label, redirect = route.redirect;
        var isItemNotInTheEnd = index < lastIndex;
        return (React__default.createElement(BreadcrumbItem, { key: BreadcrumbConstants.ItemKeyPrefix + "_" + index, to: to, isItemInTheEnd: !isItemNotInTheEnd, renderItem: renderItem, label: label, redirect: redirect }));
    });
    var breadcrumbRow = children.reduce(function (acc, child, index) {
        var isItemNotInTheEnd = index < lastIndex;
        acc.push(child);
        // since the last element would not need a separator after that
        if (isItemNotInTheEnd) {
            acc.push(React__default.createElement(BreadcrumbSeparator, { key: BreadcrumbConstants.SeparatorKeyPrefix + "_" + index }, separator || BreadcrumbConstants.DefaultSeparator));
        }
        return acc;
    }, []);
    return (React__default.createElement(Flex, __assign({ flexDirection: ['column'], alignItems: ['flex-start'], mx: "auto" }, containerStyling),
        React__default.createElement(BreadcrumbList, null, breadcrumbRow)));
};

/**
 * Modal Overlay
 */
var BackdropAnimated = styled(animated.div)({
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1040,
});

var scrollTargetClassName = 'scroll-target';
var scrollTargetSelector = ".backdrop ." + scrollTargetClassName;
var ModalBackdrop = function (props) {
    var isOpen = props.isOpen, children = props.children, _a = props.testid, testid = _a === void 0 ? 'trolly-backdrop' : _a, _b = props.verticalalignment, verticalalignment = _b === void 0 ? 'center' : _b, _c = props.backgroundColor, backgroundColor = _c === void 0 ? 'rgba(0, 0, 0, 0.5)' : _c, rest = __rest(props, ["isOpen", "children", "testid", "verticalalignment", "backgroundColor"]);
    var transitionsConfig = {
        from: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
        },
        enter: function () {
            return { backgroundColor: backgroundColor };
        },
        leave: function () {
            return {
                backgroundColor: 'rgba(0, 0, 0, 0)',
                pointerEvents: 'none',
            };
        },
        trail: 100,
        duration: 100,
    };
    var transitions = useTransition(isOpen, null, transitionsConfig);
    useEffect(function () {
        if (isOpen) {
            document.querySelectorAll(scrollTargetSelector).forEach(function (elem) {
                return disableBodyScroll(elem, {
                    reserveScrollBarGap: true,
                    allowTouchMove: function (el) { return el.classList.contains(scrollTargetClassName); },
                });
            });
        }
        else {
            document.querySelectorAll(scrollTargetSelector).forEach(function (elem) { return enableBodyScroll(elem); });
        }
        return function () { return clearAllBodyScrollLocks(); };
    }, [isOpen]);
    return transitions.map(function (_a) {
        var item = _a.item, key = _a.key, style = _a.props;
        return (item && (React__default.createElement(BackdropAnimated, __assign({ className: "backdrop", key: key, style: style, "data-testid": testid, verticalalignment: verticalalignment }, rest), children)));
    });
};

var CardWrapper = styled.section(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n"], ["\n  background-color: ", ";\n  box-shadow: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n"])), function (props) { return (props.backgroundColor ? props.backgroundColor : props.theme.colors.white); }, function (props) { return props.theme.elevation(props.elevation); }, border, width, height, space, flexbox, position, maxHeight, overflow);
var templateObject_1$1;

var setProps = function (props) {
    var elevation = props.elevation, width = props.width, rest = __rest(props, ["elevation", "width"]);
    return __assign({ p: 3, m: 3, elevation: elevation, borderRadius: 1, width: width }, rest);
};
// @ts-ignore
var Card = forwardRef(function (props, ref) {
    var children = props.children, testid = props.testid;
    return (React__default.createElement(CardWrapper, __assign({ ref: ref, "data-testid": testid }, setProps(props)), children));
});
Card.defaultProps = {
    testid: 'trolly-card',
    m: 3,
    elevation: 1,
};

var baseTheme = {
    breakpoints: ['576px', '767px', '992px', '1200px'],
    space: [0, 4, 8, 16, 24, 32, 64, 128, 256, 512],
    fontSizes: [10, 12, 14, 16, 18, 20, 24, 36, 48, 80, 96],
    fontWeights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    lineHeights: {
        solid: 1,
        title: 1.25,
        copy: 1.5,
    },
    letterSpacings: {
        normal: 'normal',
        tracked: '0.1em',
        tight: '-0.05em',
        mega: '0.25em',
    },
    fonts: {
        serif: 'athelas, georgia, times, serif',
        sansSerif: '"Roboto", sans-serif',
        montserrat: 'Montserrat',
        teshrin: 'Teshrin AR+LT',
    },
    borders: [0, '1px solid', '2px solid', '4px solid', '8px solid', '16px solid', '32px solid'],
    radii: [0, 2, 4, 8, 16, 9999, '100%'],
    width: [16, 24, 32, 64, 128, 256],
    heights: [16, 24, 32, 64, 128, 256],
    maxWidths: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
    colors: {
        // Copy Typography
        copy: ' #4D4D4D',
        /**
         * From this point down,
         * review color naming in a more generic way:
         * this way we can replace theme.
         * E.g: Primary: '#0E5AA7', cta: '#EE2527',
         */
        babyBlue: 'rgba(14, 90, 167, 0.1)',
        blue: '#0E5AA7',
        veniceBlue: '#0C4E91',
        darkBlue: '#0a437c',
        brown: '#31261d',
        red: '#EE2527',
        redCta: '#DD2326',
        yellow: '#FFDF28',
        purple: '#6F1C60',
        alabaster: '#FAFAFA',
        wildSand: '#F5F5F5',
        isabelline: '#F0F0F0',
        lightBlue: '#b7cee5',
        deepRed: '#8A0C0C',
        // Greys
        mineShaft: ' #252525',
        doveGrey: ' #666666',
        silverChalice: '#B2B2B2',
        alto: '#CFCFCF',
        mercury: '#E6E6E6',
        thundora: '#4d4d4d',
        misty: '#8248E7',
        antiFlash: '#F3F3F3',
        cobaltBlue: '#0053AE',
        ashGray: '#F9F7F7',
        lightGray: '#EAEAEA',
        darkGray: '#2D2D2D',
        white: '#fff',
        whiteSmoke: '#EFEFEF',
        transparent: 'transparent',
        black: '#000',
        blacks: [
            'rgba(0,0,0,.0125)',
            'rgba(0,0,0,.025)',
            'rgba(0,0,0,.05)',
            'rgba(0,0,0,.1)',
            'rgba(0,0,0,.2)',
            'rgba(0,0,0,.3)',
            'rgba(0,0,0,.4)',
            'rgba(0,0,0,.5)',
            'rgba(0,0,0,.6)',
            'rgba(0,0,0,.7)',
            'rgba(0,0,0,.8)',
            'rgba(0,0,0,.9)',
        ],
        whites: [
            'rgba(255,255,255,.0125)',
            'rgba(255,255,255,.025)',
            'rgba(255,255,255,.05)',
            'rgba(255,255,255,.1)',
            'rgba(255,255,255,.2)',
            'rgba(255,255,255,.3)',
            'rgba(255,255,255,.4)',
            'rgba(255,255,255,.5)',
            'rgba(255,255,255,.6)',
            'rgba(255,255,255,.7)',
            'rgba(255,255,255,.8)',
            'rgba(255,255,255,.9)',
        ],
        silver: '#C4C4C4',
        // ... and so on
        // Stickers color
        magenta: '#3B3B98',
        deepazure: '#0A437C',
        persiangreen: '#009688',
        poloBlue: '#80A6CD',
        cashbackGreen: '#019840',
        // Notification color
        goldenBell: '#E3870F',
        error: '#FEF4F4',
        warning: '#FCF6E7',
        information: '#ECF3FA',
        success: '#F1FAF9',
        expressBg: '#F3F7FA',
        expressBorder: 'rgba(14,90,167,0.1)',
        claret: '#8A1538',
        ctaRed: '#DD2326',
        ctaRedHover: '#BC1E1F',
        // Product card
        darkLiver: '#4D4D4D',
    },
};
var maxLayoutWidth = baseTheme.space[3] * 2 + parseFloat(baseTheme.breakpoints[3]); // = 1232px

/*tslint:disable no-bitwise*/
function hexToRgba(hex, opacity) {
    if (opacity === void 0) { opacity = 1; }
    var c;
    // For 8 digit hex values
    if (/^#([A-Fa-f0-9]){8}$/.test(hex)) {
        c = hex.substring(1).split('');
        c = "0x" + c.join('');
        var a = Number(c.substring(c.length - 2)) / 100;
        var rgb = Number(c.substring(0, c.length - 2));
        return "rgba(" + [(rgb >> 16) & 255, (rgb >> 8) & 255, rgb & 255].join(',') + ", " + a + ")";
    }
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = Number("0x" + c.join(''));
        return "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + "," + opacity + ")";
    }
    throw new Error('Bad Hex');
}

var elevations = {
    umbra: {
        opacity: 0.2,
        0: '0px 0px 0px 0px',
        1: '0px 2px 1px -1px',
        2: '0px 3px 1px -2px',
        3: '0px 3px 3px -2px',
        4: '0px 2px 4px -1px',
        5: '0px 3px 5px -1px',
        6: '0px 3px 5px -1px',
        7: '0px 4px 5px -2px',
        8: '0px 5px 5px -3px',
        9: '0px 5px 6px -3px',
        10: '0px 6px 6px -3px',
        11: '0px 6px 7px -4px',
        12: '0px 7px 8px -4px',
        13: '0px 7px 8px -4px',
        14: '0px 7px 9px -4px',
        15: '0px 8px 9px -5px',
        16: '0px 8px 10px -5px',
        17: '0px 8px 11px -5px',
        18: '0px 9px 11px -5px',
        19: '0px 9px 12px -6px',
        20: '0px 10px 13px -6px',
        21: '0px 10px 13px -6px',
        22: '0px 10px 14px -6px',
        23: '0px 11px 14px -7px',
        24: '0px 11px 15px -7px',
    },
    penumbra: {
        opacity: 0.14,
        0: '0px 0px 0px 0px',
        1: '0px 1px 1px 0px',
        2: '0px 2px 2px 0px',
        3: '0px 3px 4px 0px',
        4: '0px 4px 5px 0px',
        5: '0px 5px 8px 0px',
        6: '0px 6px 10px 0px',
        7: '0px 7px 10px 1px',
        8: '0px 8px 10px 1px',
        9: '0px 9px 12px 1px',
        10: '0px 10px 14px 1px',
        11: '0px 11px 15px 1px',
        12: '0px 12px 17px 2px',
        13: '0px 13px 19px 2px',
        14: '0px 14px 21px 2px',
        15: '0px 15px 22px 2px',
        16: '0px 16px 24px 2px',
        17: '0px 17px 26px 2px',
        18: '0px 18px 28px 2px',
        19: '0px 19px 29px 2px',
        20: '0px 20px 31px 3px',
        21: '0px 21px 33px 3px',
        22: '0px 22px 35px 3px',
        23: '0px 23px 36px 3px',
        24: '0px 24px 38px 3px',
    },
    ambient: {
        opacity: 0.12,
        0: '0px 0px 0px 0px',
        1: '0px 1px 3px 0px',
        2: '0px 1px 5px 0px',
        3: '0px 1px 8px 0px',
        4: '0px 1px 10px 0px',
        5: '0px 1px 14px 0px',
        6: '0px 1px 18px 0px',
        7: '0px 2px 16px 1px',
        8: '0px 3px 14px 2px',
        9: '0px 3px 16px 2px',
        10: '0px 4px 18px 3px',
        11: '0px 4px 20px 3px',
        12: '0px 5px 22px 4px',
        13: '0px 5px 24px 4px',
        14: '0px 5px 26px 4px',
        15: '0px 6px 28px 5px',
        16: '0px 6px 30px 5px',
        17: '0px 6px 32px 5px',
        18: '0px 7px 34px 6px',
        19: '0px 7px 36px 6px',
        20: '0px 8px 38px 7px',
        21: '0px 8px 40px 7px',
        22: '0px 8px 42px 7px',
        23: '0px 9px 44px 8px',
        24: '0px 9px 46px 8px',
    },
};
/**
 * elevation - Based on Material Design
 * @param {*} z - Z Elevation
 * @param {*} color - Shadow Color
 * @param {*} ob - Opacity Boost 0 - 1
 *
 * inspiration:
 * https://github.com/material-components/material-components-web/blob/master/packages/mdc-elevation/_mixins.scss
 */
function elevation(z, color, ob) {
    if (color === void 0) { color = '#000000'; }
    if (ob === void 0) { ob = 0; }
    var umbra = elevations.umbra, penumbra = elevations.penumbra, ambient = elevations.ambient;
    var umbraZvalue = umbra[z];
    var penumbraZvalue = penumbra[z];
    var ambientZvalue = ambient[z];
    return "\n    " + umbraZvalue + " " + hexToRgba(color, umbra.opacity + ob) + ",\n    " + penumbraZvalue + " " + hexToRgba(color, penumbra.opacity + ob) + ",\n    " + ambientZvalue + " " + hexToRgba(color, ambient.opacity + ob) + "\n  ";
}

var animations = {
    easing: {
        standard: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
        decelerate: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
        accelerate: 'cubic-bezier(0.4, 0.0, 1, 1)',
    },
};

var skeleton = keyframes(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  0% {\n    background-position:-200px 0;\n  }\n  100% {\n    background-position:calc(200px + 100%) 0;\n  }\n"], ["\n  0% {\n    background-position:-200px 0;\n  }\n  100% {\n    background-position:calc(200px + 100%) 0;\n  }\n"])));
var skeleton$1 = {
    variants: {
        skeleton: {
            animation: skeleton + " 1.2s ease-in-out infinite",
            bg: '#EBF0F3',
            backgroundImage: 'linear-gradient(90deg,#EBF0F3,#f5f5f5,#EBF0F3)',
            backgroundSize: '200px 100%',
            backgroundRepeat: 'no-repeat',
            borderRadius: 3,
            flexShrink: 0,
        },
        skeletonSquare: {
            animation: skeleton + " 1.2s ease-in-out infinite",
            bg: '#EBF0F3',
            backgroundImage: 'linear-gradient(90deg,#EBF0F3,#f5f5f5,#EBF0F3)',
            backgroundSize: '200px 100%',
            backgroundRepeat: 'no-repeat',
            borderRadius: 1,
            flexShrink: 0,
        },
        skeletonBox: {
            border: 1,
            borderColor: 'mercury',
            borderStyle: 'dashed',
            borderRadius: 3,
        },
        skeletonBoxSquare: {
            border: 1,
            borderColor: 'mercury',
            borderStyle: 'dashed',
            borderRadius: 1,
        },
    },
};
var templateObject_1$2;

var theme = __assign(__assign(__assign({}, baseTheme), skeleton$1), { elevation: elevation,
    animations: animations,
    maxLayoutWidth: maxLayoutWidth });

function lighten(color, amount) {
    var hex = color;
    var lum = amount / 100;
    // validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    lum = lum || 0;
    // convert to decimal and change luminosity
    var rgb = '#';
    var c;
    var i;
    for (i = 0; i < 3; i += 1) {
        c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
        rgb += ("00" + c).substr(c.length);
    }
    return rgb;
}
function darken(color, amount) {
    return lighten(color, -amount);
}
function lightOrDark(color) {
    // Variables for red, green, blue values
    var r, g, b;
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
        // If RGB --> store the red, green, blue values in separate variables
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        r = color[1];
        g = color[2];
        b = color[3];
    }
    else {
        // If hex --> Convert it to RGB: http://gist.github.com/983661
        color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
        r = color >> 16;
        g = (color >> 8) & 255;
        b = color & 255;
    }
    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    var hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) {
        return '#333';
    }
    else {
        return '#fff';
    }
}

var _a = theme.colors, red = _a.red, white = _a.white, blue = _a.blue, mercury = _a.mercury, doveGrey = _a.doveGrey, persiangreen = _a.persiangreen;
var getButtonUiState = function (col) { return ({
    '&:hover': {
        backgroundColor: darken(col, 15),
    },
    '&:active': {
        backgroundColor: lighten(col, 15),
    },
}); };
var getButtonSize = function (size) {
    switch (size) {
        case 'L':
            return '48px';
        case 'M':
            return '40px';
        case 'S':
            return '32px';
        case 'CUSTOM':
            return 'auto';
        default:
            return '48px';
    }
};
var commonCss = {
    px: 4,
    textTransform: 'uppercase',
};
var ButtonWrapper = styled.button(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  ", ";\n  outline: none;\n  transition-property: box-shadow, background-color;\n  transition-duration: 300ms;\n  transition-timing-function: ", ";\n  border-radius: ", ";\n  font-size: ", ";\n  width: ", ";\n  height: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n"], ["\n  ",
    ";\n  outline: none;\n  transition-property: box-shadow, background-color;\n  transition-duration: 300ms;\n  transition-timing-function: ", ";\n  border-radius: ", ";\n  font-size: ",
    ";\n  width: ", ";\n  height: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ",
    "\n"])), variant({
    variants: {
        naked: {
            color: 'unset',
            boxShadow: 'none',
            backgroundColor: 'transparent',
            border: 0,
            py: 'unset',
            px: 'unset',
        },
        primary: {
            color: white,
            backgroundColor: red,
            border: 0,
            ...commonCss,
            ...getButtonUiState(red),
        },
        secondary: {
            ...commonCss,
            color: white,
            border: 0,
            backgroundColor: blue,
            ...getButtonUiState(blue),
        },
        outlined: {
            ...commonCss,
            color: blue,
            backgroundColor: white,
            border: 1,
            borderColor: blue,
            '&:hover': {
                borderColor: darken(blue, 15),
            },
            '&:active': {
                borderColor: lighten(blue, 15),
            },
        },
        disabled: {
            ...commonCss,
            border: 0,
            color: doveGrey,
            backgroundColor: mercury,
            cursor: 'not-allowed',
        },
        link: {
            color: blue,
            fontSize: 2,
            textTransform: 'unset',
            boxShadow: 'unset',
            textDecoration: 'none',
            cursor: 'pointer',
        },
        text: {
            color: blue,
            fontSize: 2,
            textTransform: 'unset',
            boxShadow: 'unset',
            textDecoration: 'none',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
        },
        success: {
            ...commonCss,
            color: white,
            border: 0,
            backgroundColor: persiangreen,
            ...getButtonUiState(persiangreen),
        },
    },
}), function (props) { return props.theme.animations.easing.standard; }, function (props) { return (props.round ? '50%' : props.theme.radii[2] + "px"); }, function (props) {
    return props.size === 'S' ? props.theme.fontSizes[1] + "px" : props.theme.fontSizes[2] + "px";
}, function (props) { return (props.round ? getButtonSize(props.size) : 'auto'); }, function (props) { return getButtonSize(props.size); }, function (props) { return (props.preventTextTransform ? 'text-transform: unset' : ''); }, flex, space, typography, layout, color, border, shadow, function (props) {
    return props.disabledNew
        ? "\n    opacity: 0.5;\n    pointer-events: none;\n  "
        : '';
});
var templateObject_1$3;

var setVariant = function (_a) {
    var variant = _a.variant, disabled = _a.disabled, href = _a.href, accessibilityLabel = _a.accessibilityLabel;
    var variantProps = {};
    if (variant === 'link') {
        variantProps = {
            as: 'a',
            href: href,
            role: 'link',
            'aria-label': accessibilityLabel,
        };
    }
    if (disabled) {
        variantProps = {
            variant: 'disabled',
        };
    }
    return variantProps;
};
var setType = function (_a) {
    var type = _a.type, variant = _a.variant;
    return variant === 'link' ? {} : { type: type === 'submit' ? 'submit' : 'button' };
};
var Button = function (props) {
    var variant = props.variant, children = props.children, size = props.size, testid = props.testid, role = props.role, disabled = props.disabled, onClick = props.onClick, onFocus = props.onFocus, onBlur = props.onBlur, onKeyPress = props.onKeyPress, onKeyUp = props.onKeyUp, onKeyDown = props.onKeyDown, _a = props.preventTextTransform, preventTextTransform = _a === void 0 ? false : _a, rest = __rest(props, ["variant", "children", "size", "testid", "role", "disabled", "onClick", "onFocus", "onBlur", "onKeyPress", "onKeyUp", "onKeyDown", "preventTextTransform"]);
    return (React__default.createElement(ButtonWrapper, __assign({ variant: variant, "data-testid": testid, size: size, role: role, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onKeyUp: onKeyUp, onKeyDown: onKeyDown, disabled: disabled, preventTextTransform: preventTextTransform }, setVariant(props), setType(props), rest), children));
};
Button.defaultProps = {
    variant: 'primary',
    testid: 'trolly-button',
};

var customStyled = styled;

var DrawerCloseIcon = function (props) { return (React__default.createElement("svg", __assign({ "data-name": "Layer 1", viewBox: "0 0 24 24" }, props),
    React__default.createElement("g", { fill: "#fff", stroke: "#4d4d4d", strokeMiterlimit: 10 },
        React__default.createElement("path", { d: "M22.203 2.009l-20 20M2.203 2.009l20 20" })),
    React__default.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }))); };

var DrawerWrapper = styled(animated(Card))(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  max-height: 100%;\n\n  @media (max-width: ", ") {\n    max-height: ", ";\n  }\n  /* @noflip */\n  ", "\n\n  ", "\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  max-height: 100%;\n\n  @media (max-width: ", ") {\n    max-height: ", ";\n  }\n  /* @noflip */\n  ",
    "\n\n  ", "\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) { return props.theme.breakpoints[1]; }, function (props) { return (props.variant === 'float' ? '85%' : '100%'); }, variant({
    prop: 'anchor',
    variants: {
        left: {
            left: 0,
            right: 'auto',
            top: 0,
            bottom: 0,
        },
        right: {
            right: 0,
            left: 'auto',
            top: 0,
            bottom: 0,
        },
        top: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 'auto',
        },
        bottom: {
            bottom: 0,
            left: 0,
            right: 0,
            top: 'auto',
        },
    },
}), background, layout, flexbox, space);
DrawerWrapper.defaultProps = {
    borderRadius: 0,
    as: 'div',
    p: 0,
};
var DrawerContent = styled(Box)(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  scroll-behavior: scroll;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  overflow-x: hidden;\n  &::-webkit-scrollbar {\n    height: 6px;\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: ", ";\n    cursor: grab;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: 0;\n  }\n"], ["\n  scroll-behavior: scroll;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  overflow-x: hidden;\n  &::-webkit-scrollbar {\n    height: 6px;\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: ", ";\n    cursor: grab;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: 0;\n  }\n"])), function (props) { return props.theme.colors.mercury; });
DrawerContent.defaultProps = {
    flexGrow: 1,
    p: [3, null, 4],
    pb: '0!important',
};
var DrawCloseButton = customStyled(Button)(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  position: absolute;\n  left: -19px;\n  height: 38px;\n  width: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n  border-radius: 50%;\n  top: 50%;\n  transform: translateY(-50%);\n\n  @media (max-width: ", ") {\n    left: unset;\n    right: 20px;\n    top: -2px;\n  }\n\n"], ["\n  position: absolute;\n  left: -19px;\n  height: 38px;\n  width: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n  border-radius: 50%;\n  top: 50%;\n  transform: translateY(-50%);\n\n  @media (max-width: ", ") {\n    left: unset;\n    right: 20px;\n    top: -2px;\n  }\n\n"])), function (props) { return props.theme.colors.white; }, function (props) { return props.theme.breakpoints[1]; });
var handleSize = function (variant) {
    switch (variant) {
        case 'float':
            return '14px';
        case 'compact':
            return '18px';
        default:
            return '20px';
    }
};
var DrawerCloseStyledIcon = customStyled(DrawerCloseIcon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n"], ["\n  height: ", ";\n  width: ", ";\n"])), function (props) { return handleSize(props.variant); }, function (props) { return handleSize(props.variant); });
var TitleStyle = customStyled(Box)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), function (props) { return (props.variant !== 'float' ? 'auto' : '100%'); });
var DrawerHeaderStyle = customStyled(Flex)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: ", ";\n"], ["\n  position: ", ";\n"])), function (props) { return (props.variant !== 'float' ? 'auto' : 'relative'); });
var templateObject_1$4, templateObject_2$1, templateObject_3$1, templateObject_4, templateObject_5, templateObject_6;

var DrawerHeader = function (_a) {
    var onClose = _a.onClose, title = _a.title, _b = _a.variant, variant = _b === void 0 ? '' : _b, _c = _a.isTitleBorder, isTitleBorder = _c === void 0 ? true : _c;
    var variantObj = {
        compact: 'compact',
        float: 'float',
    };
    var variantAry = [variantObj.compact, variantObj.float];
    var colors = theme.colors;
    return (React__default.createElement(DrawerHeaderStyle, { alignItems: "center", justifyContent: "space-between", p: [3, null, 4], pb: "12px!important", sx: {
            border: "" + (isTitleBorder ? 1 : 0),
            borderColor: colors.mercury,
            borderWidth: '0 0 1px 0',
        }, variant: variant },
        title && (React__default.createElement(TitleStyle, { fontSize: 3, color: colors.black, fontWeight: 4, variant: variant }, title)),
        !variantAry.includes(variant) ? React__default.createElement(Box, { flexGrow: 1 }) : '',
        onClose && (React__default.createElement(React__default.Fragment, null, variant === variantObj.float ? (React__default.createElement(DrawCloseButton, { onClick: onClose, variant: "naked" },
            React__default.createElement(DrawerCloseStyledIcon, { variant: variant }))) : (
        // this will be removed once all the page use the float variant
        React__default.createElement(Button, { variant: "naked", onClick: onClose, height: variant === variantObj.compact ? '24px' : '48px' },
            React__default.createElement(DrawerCloseStyledIcon, { variant: variant })))))));
};

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }
  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function isPlainObject(item) {
  return item && _typeof(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? _extends({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (key === '__proto__') {
        return;
      }
      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}
	return Object(val);
}
function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}
		var test1 = new String('abc');
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}
		return true;
	} catch (err) {
		return false;
	}
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;
	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);
		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}
		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}
	return to;
};

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {  }
  };
}
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  module.exports = factoryWithThrowingShims();
}
});

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }
  return _extends({}, propTypes, _defineProperty({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });
    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }
    return null;
  }));
}

function formatMuiErrorMessage(code) {
  var url = 'https://mui.com/production-error/?code=' + code;
  for (var i = 1; i < arguments.length; i += 1) {
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }
  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
}

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }
  if (typeof Component === 'string') {
    return Component;
  }
  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }
  if (_typeof(Component) === 'object') {
    switch (Component.$$typeof) {
      case ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');
      case Memo:
        return getWrappedName(Component, Component.type, 'memo');
      default:
        return undefined;
    }
  }
  return undefined;
}

function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  if (process.env.NODE_ENV !== 'production') {
    if (value < min || value > max) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }
  return Math.min(Math.max(min, value), max);
}
function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }
  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}
function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);
  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };
  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }
  return recomposeColor({
    type: type,
    values: rgb
  });
}
function decomposeColor(color) {
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }
  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : formatMuiErrorMessage(3, color));
  }
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
function recomposeColor(color) {
  var type = color.type;
  var values = color.values;
  if (type.indexOf('rgb') !== -1) {
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }
  return "".concat(type, "(").concat(values.join(', '), ")");
}
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255;
    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  });
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function darken$1(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}
function lighten$1(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }
  return recomposeColor(color);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var keys = ['xs', 'sm', 'md', 'lg', 'xl'];
function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = _objectWithoutProperties(breakpoints, ["values", "unit", "step"]);
  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }
  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];
    if (endIndex === keys.length) {
      return up('xs');
    }
    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }
  function between(start, end) {
    var endIndex = keys.indexOf(end);
    if (endIndex === keys.length - 1) {
      return up(start);
    }
    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }
  function only(key) {
    return between(key, key);
  }
  var warnedOnce = false;
  function width(key) {
    if (process.env.NODE_ENV !== 'production') {
      if (!warnedOnce) {
        warnedOnce = true;
        console.warn(["Material-UI: The `theme.breakpoints.width` utility is deprecated because it's redundant.", 'Use the `theme.breakpoints.values` instead.'].join('\n'));
      }
    }
    return values[key];
  }
  return _extends({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;
  return _extends({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.warn(['Material-UI: theme.mixins.gutters() is deprecated.', 'You can use the source of the mixin directly:', "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "].join('\n'));
      return _extends({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, _defineProperty({}, breakpoints.up('sm'), _extends({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, _defineProperty(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), _defineProperty(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

var common = {
  black: '#000',
  white: '#fff'
};

var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};

var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};

var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};

var red$1 = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};

var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};

var blue$1 = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};

var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};

var light = {
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.54)',
    disabled: 'rgba(0, 0, 0, 0.38)',
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    paper: common.white,
    default: grey[50]
  },
  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: grey[800],
    default: '#303030'
  },
  action: {
    active: common.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten$1(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken$1(intent.main, tonalOffsetDark);
    }
  }
}
function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: indigo[300],
    main: indigo[500],
    dark: indigo[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: pink.A200,
    main: pink.A400,
    dark: pink.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: red$1[300],
    main: red$1[500],
    dark: red$1[700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: orange[300],
    main: orange[500],
    dark: orange[700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: blue$1[300],
    main: blue$1[500],
    dark: blue$1[700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: green[300],
    main: green[500],
    dark: green[700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = _objectWithoutProperties(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);
  function getContrastText(background) {
    var contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    if (process.env.NODE_ENV !== 'production') {
      var contrast = getContrastRatio(background, contrastText);
      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }
    return contrastText;
  }
  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = _extends({}, color);
    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }
    if (!color.main) {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : formatMuiErrorMessage(4, mainShade));
    }
    if (typeof color.main !== 'string') {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createTheme({ palette: {\n  primary: { main: green[500] },\n} });") : formatMuiErrorMessage(5, JSON.stringify(color.main)));
    }
    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);
    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
    return color;
  };
  var types = {
    dark: dark,
    light: light
  };
  if (process.env.NODE_ENV !== 'production') {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }
  var paletteOutput = deepmerge(_extends({
    common: common,
    type: type,
    primary: augmentColor(primary),
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    error: augmentColor(error),
    warning: augmentColor(warning),
    info: augmentColor(info),
    success: augmentColor(success),
    grey: grey,
    contrastThreshold: contrastThreshold,
    getContrastText: getContrastText,
    augmentColor: augmentColor,
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}
var warnedOnce = false;
function roundWithDeprecationWarning(value) {
  if (process.env.NODE_ENV !== 'production') {
    if (!warnedOnce) {
      console.warn(['Material-UI: The `theme.typography.round` helper is deprecated.', 'Head to https://mui.com/r/migration-v4/#theme for a migration path.'].join('\n'));
      warnedOnce = true;
    }
  }
  return round(value);
}
var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = _objectWithoutProperties(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
  if (process.env.NODE_ENV !== 'production') {
    if (typeof fontSize !== 'number') {
      console.error('Material-UI: `fontSize` is required to be a number.');
    }
    if (typeof htmlFontSize !== 'number') {
      console.error('Material-UI: `htmlFontSize` is required to be a number.');
    }
  }
  var coef = fontSize / 14;
  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };
  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return _extends({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };
  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge(_extends({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: roundWithDeprecationWarning,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false
  });
}

var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;
function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
}
var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];

var shape = {
  borderRadius: 4
};

var responsivePropType = process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.number, propTypes.string, propTypes.object, propTypes.array]) : {};

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge(acc, item, {
    clone: false
  });
}

var values = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (process.env.NODE_ENV !== 'production') {
    if (!props.theme) {
      console.error('Material-UI: You are calling a style function without a theme value.');
    }
  }
  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (_typeof(propValue) === 'object') {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }
  var output = styleFromPropValue(propValue);
  return output;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}

var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
};
var getCssProperties = memoize(function (prop) {
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  var _prop$split = prop.split(''),
      _prop$split2 = _slicedToArray(_prop$split, 2),
      a = _prop$split2[0],
      b = _prop$split2[1];
  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;
  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== 'production') {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }
  return function () {
    return undefined;
  };
}
function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }
  var abs = Math.abs(propValue);
  var transformed = transformer(abs);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === 'number') {
    return -transformed;
  }
  return "-".concat(transformed);
}
function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}
function spacing(props) {
  var theme = props.theme;
  var transformer = createUnarySpacing(theme);
  return Object.keys(props).map(function (prop) {
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }
    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return handleBreakpoints(props, propValue, styleFromPropValue);
  }).reduce(merge, {});
}
spacing.propTypes = process.env.NODE_ENV !== 'production' ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
spacing.filterProps = spacingKeys;

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
  if (spacingInput.mui) {
    return spacingInput;
  }
  var transform = createUnarySpacing({
    spacing: spacingInput
  });
  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (process.env.NODE_ENV !== 'production') {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }
    if (args.length === 0) {
      return transform(1);
    }
    if (args.length === 1) {
      return transform(args[0]);
    }
    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }
      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  };
  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (process.env.NODE_ENV !== 'production') {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }
        warnOnce = true;
      }
      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

var easing = {
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  standard: 300,
  complex: 375,
  enteringScreen: 225,
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
var transitions = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = _objectWithoutProperties(options, ["duration", "easing", "delay"]);
    if (process.env.NODE_ENV !== 'production') {
      var isString = function isString(value) {
        return typeof value === 'string';
      };
      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };
      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }
      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }
      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }
      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }
      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }
    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }
    var constant = height / 36;
    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};

var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

function createTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = _objectWithoutProperties(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);
  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = deepmerge({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    palette: palette,
    props: {},
    shadows: shadows,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: shape,
    transitions: transitions,
    zIndex: zIndex
  }, other);
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  muiTheme = args.reduce(function (acc, argument) {
    return deepmerge(acc, argument);
  }, muiTheme);
  if (process.env.NODE_ENV !== 'production') {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];
    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key;
      for (key in node) {
        var child = node[key];
        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty({}, "&$".concat(key), child)
            }, null, 2), '', 'https://mui.com/r/pseudo-classes-guide'].join('\n'));
          }
          node[key] = {};
        }
      }
    };
    traverse(muiTheme.overrides);
  }
  return muiTheme;
}

var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];
function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;
  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;
    if (process.env.NODE_ENV !== 'production') {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }
    return ruleCounter;
  };
  return function (rule, styleSheet) {
    var name = styleSheet.options.name;
    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }
      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
      if (!styleSheet.options.theme[nested] || seed !== '') {
        return prefix;
      }
      return "".concat(prefix, "-").concat(getNextCounterId());
    }
    if (process.env.NODE_ENV === 'production') {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }
    var suffix = "".concat(rule.key, "-").concat(getNextCounterId());
    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }
    return "".concat(seedPrefix).concat(suffix);
  };
}

function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;
  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  }
  var defaultProps = theme.props[name];
  var propName;
  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }
  return props;
}

var isProduction = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }
    var text = "Warning: " + message;
    if (typeof console !== 'undefined') {
      console.warn(text);
    }
    try {
      throw Error(text);
    } catch (x) {}
  }
}

var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof$1(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof$1(document)) === 'object' && document.nodeType === 9;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};
  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }
  return newStyle;
}
function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }
  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;
  if (name[0] === '@') {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }
  return null;
}
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};
var toCssValue = function toCssValue(value) {
  if (!Array.isArray(value)) return value;
  var cssValue = '';
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', ');
  if (value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }
  return cssValue;
};
function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: '',
      space: ''
    };
  }
  return {
    linebreak: '\n',
    space: ' '
  };
}
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }
  return result + str;
}
function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }
  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;
  if (options.format === false) {
    indent = -Infinity;
  }
  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak,
      space = _getWhitespaceSymbols.space;
  if (selector) indent++;
  if (fallbacks) {
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }
  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  }
  if (!result && !options.allowEmpty) return result;
  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});
var BaseStyleRule =
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  var _proto = BaseStyleRule.prototype;
  _proto.prop = function prop(name, value, options) {
    if (value === undefined) return this.style[name];
    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;
    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }
    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style;
    if (isEmpty && !isDefined && !force) return this;
    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue;
    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }
    var sheet = this.options.sheet;
    if (sheet && sheet.attached) {
      process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }
    return this;
  };
  return BaseStyleRule;
}();
var StyleRule =
function (_BaseStyleRule) {
  _inheritsLoose(StyleRule, _BaseStyleRule);
  function StyleRule(key, style, options) {
    var _this;
    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(_assertThisInitialized(_assertThisInitialized(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }
    return _this;
  }
  var _proto2 = StyleRule.prototype;
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;
    if (renderer) {
      var json = this.toJSON();
      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }
    return this;
  }
  ;
  _proto2.toJSON = function toJSON() {
    var json = {};
    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }
    return json;
  }
  ;
  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };
  _createClass(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector);
      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);
  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }
    return new StyleRule(key, style, options);
  }
};
var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
var ConditionalRule =
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown';
    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));
    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }
    this.rules.process();
  }
  var _proto = ConditionalRule.prototype;
  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  ;
  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  ;
  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  ;
  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  ;
  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;
    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;
    if (options.children === false) {
      return this.query + " {}";
    }
    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
  };
  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};
var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
var KeyframesRule =
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);
    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }
    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));
    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, options, {
        parent: this
      }));
    }
    this.rules.process();
  }
  var _proto = KeyframesRule.prototype;
  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;
    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;
    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }
    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };
  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }
  return val;
};
var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);
  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};
var pluginKeyframesRule = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;
    if (!sheet) {
      return val;
    }
    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);
      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);
      default:
        return val;
    }
  }
};
var KeyframeRule =
function (_BaseStyleRule) {
  _inheritsLoose(KeyframeRule, _BaseStyleRule);
  function KeyframeRule() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }
  var _proto = KeyframeRule.prototype;
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };
  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }
    return null;
  }
};
var FontFaceRule =
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  var _proto = FontFaceRule.prototype;
  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;
    if (Array.isArray(this.style)) {
      var str = '';
      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += linebreak;
      }
      return str;
    }
    return toCss(this.at, this.style, options);
  };
  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};
var ViewportRule =
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  var _proto = ViewportRule.prototype;
  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };
  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};
var SimpleRule =
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  var _proto = SimpleRule.prototype;
  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';
      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }
      return str;
    }
    return this.key + " " + this.value + ";";
  };
  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};
var plugins = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];
var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
};
var RuleList =
function () {
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  var _proto = RuleList.prototype;
  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;
    var options = _extends({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions);
    var key = name;
    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    }
    this.raw[key] = decl;
    if (key in this.classes) {
      options.selector = "." + escape(this.classes[key]);
    }
    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  ;
  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);
    if (oldRule) {
      this.remove(oldRule);
    }
    var options = ruleOptions;
    if (oldIndex !== -1) options = _extends({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  }
  ;
  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  }
  ;
  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  ;
  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  ;
  _proto.process = function process() {
    var plugins = this.options.jss.plugins;
    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  ;
  _proto.register = function register(rule) {
    this.map[rule.key] = rule;
    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  ;
  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];
    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  ;
  _proto.update = function update() {
    var name;
    var data;
    var options;
    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0];
      data = arguments.length <= 1 ? undefined : arguments[1];
      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }
    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  ;
  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }
    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet;
    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }
    var style = rule.style;
    plugins.onUpdate(data, rule, sheet, options);
    if (options.process && style && style !== rule.style) {
      plugins.onProcessStyle(rule.style, rule, sheet);
      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop];
        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      }
      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop];
        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  ;
  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;
    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options);
      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }
    return str;
  };
  return RuleList;
}();
var StyleSheet =
function () {
  function StyleSheet(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });
    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }
    this.rules = new RuleList(this.options);
    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }
    this.rules.process();
  }
  var _proto = StyleSheet.prototype;
  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true;
    if (!this.deployed) this.deploy();
    return this;
  }
  ;
  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  ;
  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue;
    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    if (this.attached) {
      if (!this.deployed) return rule;
      if (queue) queue.push(rule);else {
        this.insertRule(rule);
        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    }
    this.deployed = false;
    return rule;
  }
  ;
  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);
    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }
    if (this.attached) {
      if (!this.deployed) return newRule;
      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }
      return newRule;
    }
    this.deployed = false;
    return newRule;
  }
  ;
  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  ;
  _proto.addRules = function addRules(styles, options) {
    var added = [];
    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }
    return added;
  }
  ;
  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  }
  ;
  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);
    if (!rule ||
    this.attached && !rule.renderable) {
      return false;
    }
    this.rules.remove(rule);
    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }
    return true;
  }
  ;
  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  ;
  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  ;
  _proto.update = function update() {
    var _this$rules;
    (_this$rules = this.rules).update.apply(_this$rules, arguments);
    return this;
  }
  ;
  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  ;
  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };
  return StyleSheet;
}();
var PluginsRegistry =
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }
  var _proto = PluginsRegistry.prototype;
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }
    return null;
  }
  ;
  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;
    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }
    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  ;
  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  ;
  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  ;
  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  ;
  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;
    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }
    return processedValue;
  }
  ;
  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }
    var plugins = this.plugins[options.queue];
    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }
    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
          process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }
      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };
  return PluginsRegistry;
}();
var SheetsRegistry =
function () {
  function SheetsRegistry() {
    this.registry = [];
  }
  var _proto = SheetsRegistry.prototype;
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;
    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    }
    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  ;
  _proto.reset = function reset() {
    this.registry = [];
  }
  ;
  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  ;
  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = _objectWithoutPropertiesLoose(_ref, ["attached"]);
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;
    var css = '';
    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];
      if (attached != null && sheet.attached !== attached) {
        continue;
      }
      if (css) css += linebreak;
      css += sheet.toString(options);
    }
    return css;
  };
  _createClass(SheetsRegistry, [{
    key: "index",
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);
  return SheetsRegistry;
}();
var sheets = new SheetsRegistry();
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0;
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }
  var ruleCounter = 0;
  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;
    if (ruleCounter > maxRules) {
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }
    var jssId = '';
    var prefix = '';
    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }
      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }
    if (options.minify) {
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }
    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };
  return generateId;
};
var memoize$1 = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    return '';
  }
};
var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;
    if (Array.isArray(value)) {
      cssValue = toCssValue(value);
    }
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
      var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
      cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
    }
  } catch (err) {
    return false;
  }
  return true;
};
var removeProperty = function removeProperty(cssRule, prop) {
  try {
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};
var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText;
  return cssRule.selectorText === selectorText;
};
var getHead = memoize$1(function () {
  return document.querySelector('head');
});
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}
function findPrevNode(options) {
  var registry = sheets.registry;
  if (registry.length > 0) {
    var sheet = findHigherSheet(registry, options);
    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    }
    sheet = findHighestSheet(registry, options);
    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  }
  var insertionPoint = options.insertionPoint;
  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    }
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }
  return false;
}
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);
  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  }
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }
  getHead().appendChild(style);
}
var getNonce = memoize$1(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      container.insertRule(rule, index);
    }
    else if ('appendRule' in container) {
        container.appendRule(rule);
      }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }
  return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length;
  if (index === undefined || index > maxIndex) {
    return maxIndex;
  }
  return index;
};
var createStyle = function createStyle() {
  var el = document.createElement('style');
  el.textContent = '\n';
  return el;
};
var DomRenderer =
function () {
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;
    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;
    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  var _proto = DomRenderer.prototype;
  _proto.attach = function attach() {
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options);
    var deployed = Boolean(this.sheet && this.sheet.deployed);
    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  ;
  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element);
    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  ;
  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;
    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }
    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  ;
  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  ;
  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }
    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;
      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);
        if (latestNativeParent === false) {
          return false;
        }
        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }
      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }
    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
    if (nativeRule === false) {
      return false;
    }
    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };
  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule;
    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  }
  ;
  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  ;
  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  ;
  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  ;
  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };
  return DomRenderer;
}();
var instanceCounter = 0;
var Jss =
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.9.2";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: isBrowser ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });
    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }
    this.setup(options);
  }
  var _proto = Jss.prototype;
  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }
    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }
    if (options.id) {
      this.options.id = _extends({}, this.options.id, options.id);
    }
    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }
    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    }
    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  ;
  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options,
        index = _options.index;
    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }
    var sheet = new StyleSheet(styles, _extends({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  ;
  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  ;
  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }
    if (options === void 0) {
      options = {};
    }
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }
    var ruleOptions = _extends({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });
    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
    var rule = createRule(name, style, ruleOptions);
    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  ;
  _proto.use = function use() {
    var _this = this;
    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }
    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };
  return Jss;
}();
var createJss = function createJss(options) {
  return new Jss(options);
};
var SheetsManager =
function () {
  function SheetsManager() {
    this.length = 0;
    this.sheets = new WeakMap();
  }
  var _proto = SheetsManager.prototype;
  _proto.get = function get(key) {
    var entry = this.sheets.get(key);
    return entry && entry.sheet;
  };
  _proto.add = function add(key, sheet) {
    if (this.sheets.has(key)) return;
    this.length++;
    this.sheets.set(key, {
      sheet: sheet,
      refs: 0
    });
  };
  _proto.manage = function manage(key) {
    var entry = this.sheets.get(key);
    if (entry) {
      if (entry.refs === 0) {
        entry.sheet.attach();
      }
      entry.refs++;
      return entry.sheet;
    }
    warning(false, "[JSS] SheetsManager: can't find sheet to manage");
    return undefined;
  };
  _proto.unmanage = function unmanage(key) {
    var entry = this.sheets.get(key);
    if (entry) {
      if (entry.refs > 0) {
        entry.refs--;
        if (entry.refs === 0) entry.sheet.detach();
      }
    } else {
      warning(false, "SheetsManager: can't find sheet to unmanage");
    }
  };
  _createClass(SheetsManager, [{
    key: "size",
    get: function get() {
      return this.length;
    }
  }]);
  return SheetsManager;
}();
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
function getDynamicStyles(styles) {
  var to = null;
  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;
    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }
  return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
var index = createJss();

var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;
var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};
      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }
      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs];
      if (fnRule) {
        styleRule.style = fnRule(data) || {};
        if (process.env.NODE_ENV === 'development') {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      }
      var fnValues = styleRule[fnValuesNs];
      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

var at = '@global';
var atPrefix = '@global ';
var GlobalContainerRule =
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));
    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }
    this.rules.process();
  }
  var _proto = GlobalContainerRule.prototype;
  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  ;
  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  ;
  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  ;
  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  ;
  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };
  return GlobalContainerRule;
}();
var GlobalPrefixedRule =
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this
    }));
  }
  var _proto2 = GlobalPrefixedRule.prototype;
  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };
  return GlobalPrefixedRule;
}();
var separatorRegExp = /\s*,\s*/g;
function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}
function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;
  for (var name in rules) {
    sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }
  delete style[at];
}
function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;
    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }
    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }
    var parent = options.parent;
    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }
    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }
    return null;
  }
  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }
  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

var separatorRegExp$1 = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp$1 = /\$([\w-]+)/g;
function jssNested() {
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);
      if (rule) {
        return rule.selector;
      }
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }
  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp$1);
    var nestedSelectors = nestedProp.split(separatorRegExp$1);
    var result = '';
    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];
      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }
    return result;
  }
  function getOptions(rule, container, prevOptions) {
    if (prevOptions) return _extends({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
    var options = _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
    delete options.name;
    return options;
  }
  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;
    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);
      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector);
        if (!replaceRef) replaceRef = getReplaceRef(container, sheet);
        selector = selector.replace(refRegExp$1, replaceRef);
        var name = styleRule.key + "-" + prop;
        if ('replaceRule' in container) {
          container.replaceRule(name, style[prop], _extends({}, options, {
            selector: selector
          }));
        } else {
          container.addRule(name, style[prop], _extends({}, options, {
            selector: selector
          }));
        }
      } else if (isNestedConditional) {
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }
      delete style[prop];
    }
    return style;
  }
  return {
    onProcessStyle: onProcessStyle
  };
}

var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};
function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}
function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }
  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

function convertCase(style) {
  var converted = {};
  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenateStyleName(prop);
    converted[key] = style[prop];
  }
  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }
  return converted;
}
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }
    return convertCase(style);
  }
  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }
    var hyphenatedProp = hyphenateStyleName(prop);
    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value);
    return null;
  }
  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
var defaultUnits = {
  'animation-delay': ms,
  'animation-duration': ms,
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  'box-shadow': px,
  'text-shadow': px,
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  motion: px,
  'motion-offset': px,
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  'transition-delay': ms,
  'transition-duration': ms,
  'vertical-align': px,
  'flex-basis': px,
  'shape-margin': px,
  size: px,
  gap: px,
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}
var units = addCamelCasedVersion(defaultUnits);
function iterate(prop, value, options) {
  if (value == null) return value;
  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    }
  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop];
    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }
    return value.toString();
  }
  return value;
}
function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }
  var camelCasedOptions = addCamelCasedVersion(options);
  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }
    return style;
  }
  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }
  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = isBrowser && 'ontouchstart' in document.documentElement;
if (isBrowser) {
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  }
  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};
function supportedKeyframes(key) {
  if (key[1] === '-') return key;
  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}
var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};
var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};
var regExp = /[-\s]+(.)?/g;
function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
function camelize(str) {
  return str.replace(regExp, toUpper);
}
function pascalize(str) {
  return camelize("-" + str);
}
var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;
    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';
      if (camelize(longhand) in style) {
        return prop;
      }
      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }
    return prop;
  }
};
var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;
    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }
    return prop;
  }
};
var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;
    if (options.transform) {
      return prop;
    }
    return prefix.css + prop;
  }
};
var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;
    if (options.transition) {
      return prop;
    }
    return prefix.css + prop;
  }
};
var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;
    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }
    return prop;
  }
};
var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;
    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }
    return prop;
  }
};
var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;
    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }
    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);
      return _jsProp in style ? "page-" + prop : false;
    }
    return false;
  }
};
var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};
var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};
var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop);
    if (prop[0] === '-') return prop;
    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop;
    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};
var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;
    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }
    return prop;
  }
};
var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;
    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }
    return prop;
  }
};
var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack'
};
var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};
var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);
var prefixCss = function prefixCss(p) {
  return prefix.css + p;
};
var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;
    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];
      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }
      if (!multiple) return false;
      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }
      return newProp.map(prefixCss);
    }
    return false;
  }
};
var plugins$1 = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins$1.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins$1.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, _toConsumableArray(p.noPrefill));
  return a;
}, []);
var el;
var cache$1 = {};
if (isBrowser) {
  el = document.createElement('p');
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key$1 in computed) {
    if (!isNaN(key$1)) cache$1[computed[key$1]] = computed[key$1];
  }
  noPrefill.forEach(function (x) {
    return delete cache$1[x];
  });
}
function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }
  if (!el) return prop;
  if (process.env.NODE_ENV !== 'benchmark' && cache$1[prop] != null) {
    return cache$1[prop];
  }
  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  }
  for (var i = 0; i < propertyDetectors.length; i++) {
    cache$1[prop] = propertyDetectors[i](prop, el.style, options);
    if (cache$1[prop]) break;
  }
  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }
  return cache$1[prop];
}
var cache$1$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}
if (isBrowser) el$1 = document.createElement('p');
function supportedValue(property, value) {
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value;
  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  }
  var cacheKey = property + prefixedValue;
  if (process.env.NODE_ENV !== 'benchmark' && cache$1$1[cacheKey] != null) {
    return cache$1$1[cacheKey];
  }
  try {
    el$1.style[property] = prefixedValue;
  } catch (err) {
    cache$1$1[cacheKey] = false;
    return false;
  }
  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    prefixedValue = prefix.css + prefixedValue;
    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox';
    el$1.style[property] = prefixedValue;
    if (el$1.style[property] === '') {
      cache$1$1[cacheKey] = false;
      return false;
    }
  }
  el$1.style[property] = '';
  cache$1$1[cacheKey] = prefixedValue;
  return cache$1$1[cacheKey];
}

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }
  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];
      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }
      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }
    return style;
  }
  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }
  function onChangeValue(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }
  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }
    return prop0.length - prop1.length;
  };
  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);
      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }
      return newStyle;
    }
  };
}

function jssPreset() {
  return {
    plugins: [functionPlugin(), jssGlobal(), jssNested(), camelCase(), defaultUnit(),
    typeof window === 'undefined' ? null : jssVendorPrefixer(), jssPropsSort()]
  };
}

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;
  if (!newClasses) {
    return baseClasses;
  }
  var nextClasses = _extends({}, baseClasses);
  if (process.env.NODE_ENV !== 'production') {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }
  Object.keys(newClasses).forEach(function (key) {
    if (process.env.NODE_ENV !== 'production') {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }
      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }
    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);
    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }
    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};

var ThemeContext = React__default.createContext(null);
if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}

function useTheme() {
  var theme = React__default.useContext(ThemeContext);
  if (process.env.NODE_ENV !== 'production') {
    React__default.useDebugValue(theme);
  }
  return theme;
}

var jss = createJss(jssPreset());
var generateClassName = createGenerateClassName();
var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = React__default.createContext(defaultOptions);
if (process.env.NODE_ENV !== 'production') {
  StylesContext.displayName = 'StylesContext';
}
var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = _objectWithoutProperties(props, ["children", "injectFirst", "disableGeneration"]);
  var outerOptions = React__default.useContext(StylesContext);
  var context = _extends({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);
  if (process.env.NODE_ENV !== 'production') {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }
  if (process.env.NODE_ENV !== 'production') {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }
  if (process.env.NODE_ENV !== 'production') {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }
  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }
    context.jss = createJss({
      plugins: jssPreset().plugins,
      insertionPoint: injectFirstNode
    });
  }
  return React__default.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = {
  children: propTypes.node.isRequired,
  disableGeneration: propTypes.bool,
  generateClassName: propTypes.func,
  injectFirst: propTypes.bool,
  jss: propTypes.object,
  serverGenerateClassName: propTypes.func,
  sheetsCache: propTypes.object,
  sheetsManager: propTypes.object,
  sheetsRegistry: propTypes.object
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

var indexCounter = -1e9;
function increment() {
  indexCounter += 1;
  if (process.env.NODE_ENV !== 'production') {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }
  return indexCounter;
}

var noopTheme = {};

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';
  if (process.env.NODE_ENV !== 'production') {
    if (_typeof(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }
  return {
    create: function create(theme, name) {
      var styles;
      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          if (themingEnabled === true && theme === noopTheme) {
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }
        throw err;
      }
      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }
      var overrides = theme.overrides[name];
      var stylesWithOverrides = _extends({}, styles);
      Object.keys(overrides).forEach(function (key) {
        if (process.env.NODE_ENV !== 'production') {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }
        stylesWithOverrides[key] = deepmerge(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;
  if (stylesOptions.disableGeneration) {
    return classes || {};
  }
  if (!state.cacheClasses) {
    state.cacheClasses = {
      value: null,
      lastProp: null,
      lastJSS: {}
    };
  }
  var generate = false;
  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }
  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }
  if (generate) {
    state.cacheClasses.value = mergeClasses({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }
  return state.cacheClasses.value;
}
function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;
  if (stylesOptions.disableGeneration) {
    return;
  }
  var sheetManager = multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    multiKeyStore.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }
  var options = _extends({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });
  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;
  if (sheetManager.refs === 0) {
    var staticSheet;
    if (stylesOptions.sheetsCache) {
      staticSheet = multiKeyStore.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }
    var styles = stylesCreator.create(theme, name);
    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, _extends({
        link: false
      }, options));
      staticSheet.attach();
      if (stylesOptions.sheetsCache) {
        multiKeyStore.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }
    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }
    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles);
  }
  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, _extends({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = mergeClasses({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });
    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }
  sheetManager.refs += 1;
}
function update(_ref3, props) {
  var state = _ref3.state;
  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}
function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;
  if (stylesOptions.disableGeneration) {
    return;
  }
  var sheetManager = multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;
  if (sheetManager.refs === 0) {
    multiKeyStore.delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }
  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}
function useSynchronousEffect(func, values) {
  var key = React__default.useRef([]);
  var output;
  var currentKey = React__default.useMemo(function () {
    return {};
  }, values);
  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }
  React__default.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey]
  );
}
function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? noopTheme : _options$defaultTheme,
      stylesOptions2 = _objectWithoutProperties(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);
  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };
  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = useTheme() || defaultTheme;
    var stylesOptions = _extends({}, React__default.useContext(StylesContext), stylesOptions2);
    var instance = React__default.useRef();
    var shouldUpdate = React__default.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    React__default.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }
      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);
    if (process.env.NODE_ENV !== 'production') {
      React__default.useDebugValue(classes);
    }
    return classes;
  };
  return useStyles;
}

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }
  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }
    var keys = getOwnPropertyNames(sourceComponent);
    if (getOwnPropertySymbols$1) {
      keys = keys.concat(getOwnPropertySymbols$1(sourceComponent));
    }
    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);
    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];
      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
        try {
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }
  return targetComponent;
}
var hoistNonReactStatics_cjs = hoistNonReactStatics;

var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = _objectWithoutProperties(options, ["defaultTheme", "withTheme", "name"]);
    if (process.env.NODE_ENV !== 'production') {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }
    var classNamePrefix = name;
    if (process.env.NODE_ENV !== 'production') {
      if (!name) {
        var displayName = getDisplayName(Component);
        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }
    var useStyles = makeStyles(stylesOrCreator, _extends({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = React__default.forwardRef(function WithStyles(props, ref) {
      var classesProp = props.classes,
          innerRef = props.innerRef,
          other = _objectWithoutProperties(props, ["classes", "innerRef"]);
      var classes = useStyles(_extends({}, Component.defaultProps, props));
      var theme;
      var more = other;
      if (typeof name === 'string' || withTheme) {
        theme = useTheme() || defaultTheme;
        if (name) {
          more = getThemeProps({
            theme: theme,
            name: name,
            props: other
          });
        }
        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }
      return React__default.createElement(Component, _extends({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
    process.env.NODE_ENV !== "production" ? WithStyles.propTypes = {
      classes: propTypes.object,
      innerRef: chainPropTypes(propTypes.oneOfType([propTypes.func, propTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }
        return null;
      })
    } : void 0;
    if (process.env.NODE_ENV !== 'production') {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }
    hoistNonReactStatics_cjs(WithStyles, Component);
    if (process.env.NODE_ENV !== 'production') {
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }
    return WithStyles;
  };
};

var defaultTheme = createTheme();

function useTheme$1() {
  var theme = useTheme() || defaultTheme;
  if (process.env.NODE_ENV !== 'production') {
    React__default.useDebugValue(theme);
  }
  return theme;
}

function withStyles$1(stylesOrCreator, options) {
  return withStyles(stylesOrCreator, _extends({
    defaultTheme: defaultTheme
  }, options));
}

function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: capitalize(string) expects a string argument." : formatMuiErrorMessage(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var TRANSITION_DURATION = 4;
var styles = function styles(theme) {
  var getColor = function getColor(color) {
    return theme.palette.type === 'light' ? lighten$1(color, 0.62) : darken$1(color, 0.5);
  };
  var backgroundPrimary = getColor(theme.palette.primary.main);
  var backgroundSecondary = getColor(theme.palette.secondary.main);
  return {
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 4,
      '@media print': {
        colorAdjust: 'exact'
      }
    },
    colorPrimary: {
      backgroundColor: backgroundPrimary
    },
    colorSecondary: {
      backgroundColor: backgroundSecondary
    },
    determinate: {},
    indeterminate: {},
    buffer: {
      backgroundColor: 'transparent'
    },
    query: {
      transform: 'rotate(180deg)'
    },
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      animation: '$buffer 3s infinite linear'
    },
    dashedColorPrimary: {
      backgroundImage: "radial-gradient(".concat(backgroundPrimary, " 0%, ").concat(backgroundPrimary, " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0 -23px'
    },
    dashedColorSecondary: {
      backgroundImage: "radial-gradient(".concat(backgroundSecondary, " 0%, ").concat(backgroundSecondary, " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0 -23px'
    },
    bar: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      transformOrigin: 'left'
    },
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main
    },
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },
    bar1Indeterminate: {
      width: 'auto',
      animation: '$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
    },
    bar1Determinate: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    bar1Buffer: {
      zIndex: 1,
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    bar2Indeterminate: {
      width: 'auto',
      animation: '$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite'
    },
    bar2Buffer: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    '@keyframes indeterminate1': {
      '0%': {
        left: '-35%',
        right: '100%'
      },
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes indeterminate2': {
      '0%': {
        left: '-200%',
        right: '100%'
      },
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0 -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0 -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    }
  };
};
var LinearProgress = forwardRef(function LinearProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = _objectWithoutProperties(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
  var theme = useTheme$1();
  var rootProps = {};
  var inlineStyles = {
    bar1: {},
    bar2: {}
  };
  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      rootProps['aria-valuemin'] = 0;
      rootProps['aria-valuemax'] = 100;
      var transform = value - 100;
      if (theme.direction === 'rtl') {
        transform = -transform;
      }
      inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
    } else if (process.env.NODE_ENV !== 'production') {
      console.error('Material-UI: You need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
    }
  }
  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      var _transform = (valueBuffer || 0) - 100;
      if (theme.direction === 'rtl') {
        _transform = -_transform;
      }
      inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
    } else if (process.env.NODE_ENV !== 'production') {
      console.error('Material-UI: You need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
    }
  }
  return createElement("div", _extends({
    className: clsx(classes.root, classes["color".concat(capitalize(color))], className, {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'buffer': classes.buffer,
      'query': classes.query
    }[variant]),
    role: "progressbar"
  }, rootProps, {
    ref: ref
  }, other), variant === 'buffer' ? createElement("div", {
    className: clsx(classes.dashed, classes["dashedColor".concat(capitalize(color))])
  }) : null, createElement("div", {
    className: clsx(classes.bar, classes["barColor".concat(capitalize(color))], (variant === 'indeterminate' || variant === 'query') && classes.bar1Indeterminate, {
      'determinate': classes.bar1Determinate,
      'buffer': classes.bar1Buffer
    }[variant]),
    style: inlineStyles.bar1
  }), variant === 'determinate' ? null : createElement("div", {
    className: clsx(classes.bar, (variant === 'indeterminate' || variant === 'query') && classes.bar2Indeterminate, variant === 'buffer' ? [classes["color".concat(capitalize(color))], classes.bar2Buffer] : classes["barColor".concat(capitalize(color))]),
    style: inlineStyles.bar2
  }));
});
process.env.NODE_ENV !== "production" ? LinearProgress.propTypes = {
  classes: propTypes.object,
  className: propTypes.string,
  color: propTypes.oneOf(['primary', 'secondary']),
  value: propTypes.number,
  valueBuffer: propTypes.number,
  variant: propTypes.oneOf(['buffer', 'determinate', 'indeterminate', 'query'])
} : void 0;
var LinearProgress$1 = withStyles$1(styles, {
  name: 'MuiLinearProgress'
})(LinearProgress);

var Block = styled.div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: ", ";\n  z-index: 1;\n"], ["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: ", ";\n  z-index: 1;\n"])), rgba(theme.colors.white, 0.6));
var LinearProgressBox = styled.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  ", ": 0;\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  ", ": 0;\n"])), function (_a) {
    var position = _a.position;
    return position;
});
var GlobalCSS = withStyles$1({
    '@global': {
        '.MuiLinearProgress-colorPrimary': {
            background: rgba(theme.colors.blue, 0.4),
            height: 3,
        },
        '.MuiLinearProgress-barColorPrimary': {
            background: theme.colors.blue,
        },
    },
})(function () { return null; });
var LinearProgressStyled = function (_a) {
    var _b = _a.position, position = _b === void 0 ? 'top' : _b, rest = __rest(_a, ["position"]);
    return (React__default.createElement(LinearProgressBox, { position: position },
        React__default.createElement(GlobalCSS, null),
        React__default.createElement(LinearProgress$1, __assign({}, rest))));
};
var templateObject_1$5, templateObject_2$2;

var LinearProgress$2 = function (_a) {
    var _b = _a.withBlock, withBlock = _b === void 0 ? true : _b, rest = __rest(_a, ["withBlock"]);
    return (React__default.createElement(React__default.Fragment, null, withBlock ? (React__default.createElement(Block, null,
        React__default.createElement(LinearProgressStyled, __assign({}, rest)))) : (React__default.createElement(LinearProgressStyled, __assign({}, rest)))));
};

var TRANSITION_CONFIG_JSON = {
    left: {
        from: { transform: 'translate3d(-100vw, 0, 0)' },
        leave: { transform: 'translate3d(-100vw, 0, 0)', pointerEvents: 'none' },
    },
    right: {
        from: { transform: 'translate3d(100vw, 0, 0)' },
        leave: { transform: 'translate3d(100vw, 0, 0)', pointerEvents: 'none' },
    },
    top: {
        from: { transform: 'translate3d(0, -100vh, 0)' },
        leave: { transform: 'translate3d(0, -100vh, 0)', pointerEvents: 'none' },
    },
    bottom: {
        from: { transform: 'translate3d(0, 100vh, 0)' },
        leave: { transform: 'translate3d(0, 100vh, 0)', pointerEvents: 'none' },
    },
};
var getTransitionConfig = function (theme, anchor, onDestroy) {
    var side = anchor === Object(anchor)
        ? useMedia(__spreadArrays(['(min-width: 0px)'], theme.breakpoints.map(function (breakpoint) { return "(min-width: " + breakpoint + ")"; })), anchor, 'left', true)
        : anchor;
    return __assign(__assign(__assign({}, TRANSITION_CONFIG_JSON[side]), { enter: { transform: 'translate3d(0, 0, 0)' } }), (onDestroy && {
        onDestroyed: function () {
            onDestroy();
        },
    }));
};
var DrawerContent$1 = function (props) {
    var children = props.children, isOpen = props.isOpen, onClose = props.onClose, onDestroy = props.onDestroy, ariaLabel = props.ariaLabel, role = props.role, anchor = props.anchor, title = props.title, width = props.width, _a = props.contentStyles, contentStyles = _a === void 0 ? {} : _a, _b = props.containerStyles, containerStyles = _b === void 0 ? {} : _b, _c = props.isTitleBorder, isTitleBorder = _c === void 0 ? true : _c, _d = props.showLoader, showLoader = _d === void 0 ? false : _d, _e = props.variant, variant = _e === void 0 ? '' : _e, rest = __rest(props, ["children", "isOpen", "onClose", "onDestroy", "ariaLabel", "role", "anchor", "title", "width", "contentStyles", "containerStyles", "isTitleBorder", "showLoader", "variant"]);
    var theme = useTheme$2();
    var drawerRef = useRef();
    useOnClickOutside(drawerRef, onClose);
    var transitions = useTransition(isOpen, null, getTransitionConfig(theme, anchor, onDestroy));
    var existyChildren = Children.toArray(children);
    return transitions.map(function (_a) {
        var item = _a.item, key = _a.key, sytle = _a.props;
        return item && (React__default.createElement(DrawerWrapper, __assign({ ref: drawerRef, key: key, style: sytle, "aria-label": ariaLabel, role: role, anchor: anchor, width: width, variant: variant }, containerStyles, rest),
            (onClose || title) && (React__default.createElement(DrawerHeader, { onClose: onClose, title: title, variant: variant, isTitleBorder: isTitleBorder })),
            React__default.createElement(DrawerContent, __assign({ className: "scroll-target" }, contentStyles), Children.map(existyChildren, function (_a) {
                var Child = _a.type, childProps = _a.props;
                return Child && Child.displayName !== 'DrawerFooter' ? React__default.createElement(Child, __assign({}, childProps)) : null;
            })),
            Children.map(existyChildren, function (_a) {
                var Child = _a.type, childProps = _a.props;
                return Child && Child.displayName === 'DrawerFooter' ? React__default.createElement(Child, __assign({}, childProps)) : null;
            }),
            showLoader && React__default.createElement(LinearProgress$2, null)));
    });
};

var DrawerFooter = function (props) { return (React__default.createElement(Box, __assign({ bg: "white", sx: { boxShadow: '0 1px 12px 0 rgba(0,0,0,0.2)', button: { fontWeight: 4 } }, p: 3, px: [null, null, 4] }, props))); };
DrawerFooter.displayName = 'DrawerFooter';

var Drawer = function (props) {
    var children = props.children, isOpen = props.isOpen, propsDrawerRoot = props.drawerRoot, _a = props.testid, testid = _a === void 0 ? 'trolly-drawer' : _a, _b = props.ariaLabel, ariaLabel = _b === void 0 ? 'main' : _b, _c = props.role, role = _c === void 0 ? 'navigation' : _c, _d = props.anchor, anchor = _d === void 0 ? 'left' : _d, rest = __rest(props, ["children", "isOpen", "drawerRoot", "testid", "ariaLabel", "role", "anchor"]);
    var customRoot = propsDrawerRoot && document.getElementById(propsDrawerRoot);
    var drawerRoot = customRoot ? customRoot : document.body;
    return createPortal(React__default.createElement(ModalBackdrop, { isOpen: isOpen },
        React__default.createElement(DrawerContent$1, __assign({ isOpen: isOpen, "data-testid": testid, ariaLabel: ariaLabel, role: role, anchor: anchor }, rest), children)), drawerRoot);
};
Drawer.DrawerFooter = DrawerFooter;

var _a$1 = theme.colors, red$2 = _a$1.red, persiangreen$1 = _a$1.persiangreen, blue$2 = _a$1.blue, goldenBell = _a$1.goldenBell, copy = _a$1.copy, error = _a$1.error, warning$1 = _a$1.warning, information = _a$1.information, success = _a$1.success;
var fadein = keyframes(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  from {top: -100px;}\n  to {top: 30px;}\n"], ["\n  from {top: -100px;}\n  to {top: 30px;}\n"])));
var fadeout = keyframes(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  from {top: 30px;}\n  to {top: -100px; display: none}\n"], ["\n  from {top: 30px;}\n  to {top: -100px; display: none}\n"])));
var NotificationWrapper = styled.div(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  align-items: start;\n  z-index: 1041;\n  visibility: ", ";\n  animation: ", " 0.6s linear;\n  transition: ", ";\n  display: ", ";\n  border-radius: ", "px;\n  padding: ", "px;\n  ", "\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  align-items: start;\n  z-index: 1041;\n  visibility: ", ";\n  animation: ", " 0.6s linear;\n  transition: ", ";\n  display: ", ";\n  border-radius: ", "px;\n  padding: ", "px;\n  ",
    "\n  ",
    "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (_a) {
    var closed = _a.closed;
    return (closed && ['floating'] ? 'hidden' : 'visible');
}, function (_a) {
    var closed = _a.closed;
    return (closed && ['floating'] ? fadeout : fadein);
}, function (_a) {
    var type = _a.type;
    return (type === 'floating' ? 'visibility 0.6s linear' : '');
}, function (_a) {
    var closed = _a.closed, type = _a.type;
    return (closed && type === 'sticky' ? 'none' : 'flex');
}, function (props) { return props.theme.radii[1]; }, function (props) { return props.theme.space[3]; }, variant({
    prop: 'type',
    variants: {
        floating: {
            position: 'fixed',
            top: '30px',
            left: '50%',
            borderTop: 3,
            width: 500,
            marginLeft: '-250px',
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2)',
        },
        sticky: {
            border: 1,
            borderInlineStartWidth: 3,
        },
    },
}), variant({
    variants: {
        error: {
            backgroundColor: error,
            borderColor: red$2,
        },
        warning: {
            backgroundColor: warning$1,
            borderColor: goldenBell,
        },
        info: {
            backgroundColor: information,
            borderColor: blue$2,
        },
        success: {
            backgroundColor: success,
            borderColor: persiangreen$1,
        },
    },
}), space, typography, layout, color, border);
var Title = styled.h5(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: ", ";\n"], ["\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: ", ";\n"])), function (_a) {
    var title = _a.title;
    return (title ? '8px' : 0);
});
var Icon = styled.img(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  padding-right: 16px;\n"], ["\n  padding-right: 16px;\n"])));
// flex-basis for text wrap support in IE11
var Content = styled.div(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  flex-grow: 1;\n  flex-basis: 100%;\n"], ["\n  flex-grow: 1;\n  flex-basis: 100%;\n"])));
var CloseButton = styled(Button)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  all: unset;\n  color: ", ";\n  background: transparent !important;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 0;\n"], ["\n  all: unset;\n  color: ", ";\n  background: transparent !important;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 0;\n"])), copy);
// storybook css to be removed
var Separator = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  background: rgba(165, 100, 100, 0.09);\n  width: 100%;\n  height: 1px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n"], ["\n  background: rgba(165, 100, 100, 0.09);\n  width: 100%;\n  height: 1px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n"])));
var templateObject_1$6, templateObject_2$3, templateObject_3$2, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7, templateObject_8;

var useNotification = function (type, timeout, notificationState, onClick) {
    var _a = useState(notificationState), closed = _a[0], setClosed = _a[1];
    var onCloseHandle = function () {
        setClosed(true);
        if (onClick) {
            onClick();
        }
    };
    useEffect(function () {
        if (type === 'floating') {
            setTimeout(function () {
                setClosed(true);
                if (onClick) {
                    onClick();
                }
            }, timeout);
        }
    });
    return [closed, onCloseHandle];
};

var Notification = function (_a) {
    var testid = _a.testid, children = _a.children, title = _a.title, iconUrl = _a.iconUrl, onClick = _a.onClick, timeout = _a.timeout, type = _a.type, _b = _a.closed, notificationState = _b === void 0 ? false : _b, _c = _a.nonClosable, nonClosable = _c === void 0 ? false : _c, rest = __rest(_a, ["testid", "children", "title", "iconUrl", "onClick", "timeout", "type", "closed", "nonClosable"]);
    var _d = useNotification(type, timeout, notificationState, onClick), closed = _d[0], onCloseHandle = _d[1];
    return (React__default.createElement(NotificationWrapper, __assign({ "data-testid": testid, closed: closed, className: closed ? 'closed' : '', type: type }, rest),
        iconUrl && React__default.createElement(Icon, { src: iconUrl, alt: "Notification Icon" }),
        React__default.createElement(Content, null,
            title && React__default.createElement(Title, { title: title }, title),
            children),
        !nonClosable && React__default.createElement(CloseButton, { onClick: onCloseHandle }, "\u2715")));
};
Notification.defaultProps = {
    timeout: 4000,
    title: '',
    type: 'sticky',
    variant: 'error',
    testid: 'trolly-notification',
};

/**
 * Modal Header
 */
var ModalHeader = customStyled(Flex)(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  width: 100%;\n  height: 50px;\n\n  button {\n    font-size: ", "px;\n  }\n\n  ", ";\n"], ["\n  width: 100%;\n  height: 50px;\n\n  button {\n    font-size: ", "px;\n  }\n\n  ", ";\n"])), function (props) { return props.theme.fontSizes[6]; }, space);
ModalHeader.defaultProps = {
    as: 'header',
    justifyContent: 'space-between',
    alignItems: 'center',
};
/**
 * Modal Content
 */
var ModalContent = styled(Flex)(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  overflow: auto;\n  flex-direction: column;\n  width: 100%;\n  flex: 1;\n  ", ";\n"], ["\n  position: relative;\n  display: flex;\n  overflow: auto;\n  flex-direction: column;\n  width: 100%;\n  flex: 1;\n  ", ";\n"])), space);
ModalContent.defaultProps = {
    as: 'section',
};
/**
 * Modal Frame
 */
var ModalFrame = styled(Box)(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  z-index: 1050;\n  position: fixed;\n  max-height: 100%;\n  left: 50%;\n  overflow-y: auto;\n  transform: translateX(-50%) translateY(-50%);\n  ", "\n"], ["\n  z-index: 1050;\n  position: fixed;\n  max-height: 100%;\n  left: 50%;\n  overflow-y: auto;\n  transform: translateX(-50%) translateY(-50%);\n  ",
    "\n"])), variant({
    variants: {
        basic: {
            top: '50%',
        },
        bottomSticky: {
            top: ['85%', null, '50%'],
            bottom: '0',
        },
        bottomStickyMobile: {
            top: ['unset', 'unset', '50%'],
            bottom: '0',
            left: ['unset', 'unset', '50%'],
            transform: 'none',
            borderRadius: ['8px 8px 0 0', '8px'],
        },
    },
}));
/**
 * Modal AnimatedWrapper
 */
var ModalAnimatedWrapper = styled(animated(Card))(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject([""], [""])));
ModalAnimatedWrapper.defaultProps = {
    as: 'div',
};
var templateObject_1$7, templateObject_2$4, templateObject_3$3, templateObject_4$2;

var ModalWrapper = function (props) {
    var children = props.children, isOpen = props.isOpen, onClose = props.onClose, p = props.p, height = props.height, width = props.width, variant = props.variant, rest = __rest(props, ["children", "isOpen", "onClose", "p", "height", "width", "variant"]);
    var _a = useState(false), block = _a[0], setBlock = _a[1];
    var ref = useRef(null);
    useOnClickOutside(ref, function () {
        if (!block && onClose) {
            onClose();
        }
    }, true);
    /* removing this calculation and using translation for centering modal item */
    // const posFromTop = `calc(50%  - ${measurements.height}px)`;
    useEffect(function () {
        return function () { return setBlock(false); };
    }, []);
    var transitionsConfig = {
        from: {
            transform: 'translate3d(0 ,100px,0)',
            opacity: 0,
        },
        enter: function () {
            setBlock(true);
            return { opacity: 1, transform: 'translate3d(0,0,0)' };
        },
        leave: function () {
            setBlock(true);
            return {
                opacity: 0,
                transform: 'translate3d(0,100px,0)',
                pointerEvents: 'none',
            };
        },
        onRest: function () { return setBlock(false); },
        config: config.gentle,
    };
    var transitions = useTransition(isOpen, null, transitionsConfig);
    return (React__default.createElement(ModalFrame, __assign({ ref: ref, height: height, width: width, mt: [0], variant: variant }, rest), transitions.map(function (_a) {
        var item = _a.item, key = _a.key, style = _a.props;
        return (item && (React__default.createElement(ModalAnimatedWrapper, { p: p, key: key, style: style }, children)));
    })));
};

function memoize$2(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var index$1 = memoize$2(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  && prop.charCodeAt(1) === 110
  && prop.charCodeAt(2) < 91;
}
);

var TextBase = styled('p', {
    shouldForwardProp: function (prop) { return index$1(prop); },
})(compose(color, space, typography, background, layout));

var Text = function (props) {
    var testid = props.testid, children = props.children, rest = __rest(props, ["testid", "children"]);
    return (React__default.createElement(TextBase, __assign({ "data-testid": testid }, rest), children));
};
Text.displayName = 'Text';
Text.defaultProps = {
    testid: 'trolly-text',
    color: 'copy',
};
/**
 * Headings
 * TODO: add lineheights
 */
Text.H1 = Text.bind(null);
Text.H1.displayName = 'h1';
Text.H1.defaultProps = __assign(__assign({}, Text.defaultProps), { as: 'h1', fontSize: [4, 5] });
Text.H2 = Text.bind(null);
Text.H2.displayName = 'h2';
Text.H2.defaultProps = __assign(__assign({}, Text.defaultProps), { as: 'h2', fontSize: [3, 4] });
Text.H3 = Text.bind(null);
Text.H3.displayName = 'h3';
Text.H3.defaultProps = __assign(__assign({}, Text.defaultProps), { as: 'h3', fontSize: [2, 3] });
/**
 * Body Text
 */
Text.Paragraph = Text.bind(null);
Text.Paragraph.displayName = 'p';
Text.Paragraph.defaultProps = __assign(__assign({}, Text.defaultProps), { as: 'p', fontSize: 2 });
/**
 * Caption
 */
Text.Caption = Text.bind(null);
Text.Caption.displayName = 'span';
Text.Caption.defaultProps = __assign(__assign({}, Text.defaultProps), { as: 'span', fontSize: 1 });

var Modal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, title = _a.title, children = _a.children, modalRoot = _a.modalRoot, _b = _a.width, width = _b === void 0 ? [1, 1 / 3] : _b, _c = _a.height, height = _c === void 0 ? ['100vh', 'auto'] : _c, _d = _a.p, p = _d === void 0 ? 4 : _d, _e = _a.testid, testid = _e === void 0 ? 'trolly-modal' : _e, _f = _a.verticalalignment, verticalalignment = _f === void 0 ? 'center' : _f, titleStyles = _a.titleStyles, headerStyles = _a.headerStyles, contentStyles = _a.contentStyles, _g = _a.variant, variant = _g === void 0 ? 'basic' : _g, showLoader = _a.showLoader, backgroundColor = _a.backgroundColor, _h = _a.showClose, showClose = _h === void 0 ? true : _h;
    var propsPortal = modalRoot && document.getElementById(modalRoot);
    var portal = propsPortal ? propsPortal : document.body;
    useEffect(function () {
        document.body.style.overflow = isOpen ? 'hidden' : 'auto';
    }, [isOpen]);
    return createPortal(React__default.createElement(ModalBackdrop, { isOpen: isOpen, testid: testid, verticalalignment: verticalalignment, backgroundColor: backgroundColor },
        React__default.createElement(ModalWrapper, { "aria-modal": true, "aria-hidden": true, tabIndex: -1, role: "dialog", isOpen: isOpen, onClose: onClose, width: width, height: height, p: p, variant: variant },
            title && (React__default.createElement(ModalHeader, __assign({}, headerStyles),
                React__default.createElement(Text.H3, __assign({}, titleStyles), title),
                showClose && (React__default.createElement(Button, { variant: "naked", "aria-label": "Close", onClick: onClose },
                    React__default.createElement(Cross, { size: "M" }))))),
            React__default.createElement(ModalContent, __assign({}, contentStyles), children),
            showLoader && React__default.createElement(LinearProgress$2, null))), portal);
};

var RadioGroupWrapper = styled(Flex)(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  ", "\n  border-radius: ", "px;\n\n  ", "\n"], ["\n  ",
    "\n  border-radius: ", "px;\n\n  ",
    "\n"])), function (props) {
    var variant = props.variant, noCollapse = props.noCollapse;
    if (noCollapse) {
        return '';
    }
    if (variant === 'success') {
        return "\n        background: rgba(242, 249, 248, 0.95);\n        border-radius: 4px;\n      ";
    }
    return "background: #f5f5f5;";
}, function (props) { return props.theme.radii[2]; }, function (props) {
    var isOpen = props.isOpen, theme = props.theme, noCollapse = props.noCollapse;
    if (isOpen && !noCollapse) {
        return "\n        border: " + theme.borders[1] + ";\n        border-color: " + theme.colors.mercury + ";\n      ";
    }
});
var RadioGroupHeader = styled(Flex)(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  padding: ", "px;\n  border-radius: 4px;\n  transition-property: box-shadow, background-color;\n  transition-duration: 300ms;\n  transition-timing-function: ", ";\n  ", "\n"], ["\n  padding: ", "px;\n  border-radius: 4px;\n  transition-property: box-shadow, background-color;\n  transition-duration: 300ms;\n  transition-timing-function: ", ";\n  ",
    "\n"])), function (props) { return props.theme.space[3]; }, function (props) { return props.theme.animations.easing.standard; }, function (props) {
    var isOpen = props.isOpen, selected = props.selected, theme = props.theme, variant = props.variant;
    if (isOpen) {
        if (variant === 'success') {
            return "\n          background: rgba(242, 249, 248, 0.95);\n          border-bottom-right-radius: 0px;\n          border-bottom-left-radius: 0px;\n        ";
        }
        return "\n        border-bottom-right-radius: 0px;\n        border-bottom-left-radius: 0px;\n        border-bottom: " + theme.borders[1] + ";\n        border-color: " + theme.colors.mercury + ";\n        background-color: " + theme.colors.white + ";\n      ";
    }
    if (variant === 'success') {
        return "\n        background: rgba(242, 249, 248, 0.95);\n      ";
    }
    if (!isOpen && selected) {
        return "\n        background-color: rgba(14,90,167,0.2)\n      ";
    }
    return "\n      color: " + theme.colors.copy + ";\n      background-color: " + theme.colors.mercury + ";\n    ";
});
var RadioIconWrapper = styled(animated.i)(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  position: relative;\n  height: 24px;\n  width: 24px;\n  border-radius: ", "px;\n  border: ", ";\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: ", "px;\n\n  ", "\n"], ["\n  position: relative;\n  height: 24px;\n  width: 24px;\n  border-radius: ", "px;\n  border: ", ";\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: ", "px;\n\n  ",
    "\n"])), function (props) { return props.theme.radii[4]; }, function (props) { return props.theme.borders[2]; }, function (props) { return props.theme.space[2]; }, function (props) {
    var checked = props.checked;
    if (checked) {
        return "background-color: rgba(14, 90, 167, 0.1)";
    }
});
var RadioIconBullet = styled(animated.span)(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  position: absolute;\n  background: rgba(14, 90, 167, 0.1);\n  opacity: 0.1;\n  border-radius: ", "px;\n  z-index: 0;\n"], ["\n  position: absolute;\n  background: rgba(14, 90, 167, 0.1);\n  opacity: 0.1;\n  border-radius: ", "px;\n  z-index: 0;\n"])), function (props) { return props.theme.radii[4]; });
/**
 * Radio Button
 * - RadioButtonWrapper
 */
var RadioButtonWrapper = styled(Flex)(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  ", "\n  flex: 1 1 auto;\n  font-size: ", "px;\n  transition-property: box-shadow, background-color;\n  transition-duration: 300ms;\n  transition-timing-function: ", ";\n  ", "\n"], ["\n  ",
    "\n  flex: 1 1 auto;\n  font-size: ", "px;\n  transition-property: box-shadow, background-color;\n  transition-duration: 300ms;\n  transition-timing-function: ", ";\n  ", "\n"])), function (props) {
    var checked = props.checked, page = props.page;
    return variant({
        variants: {
            radio: {},
            card: {
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 8,
                p: 4,
                backgroundColor: checked && page !== 'pdp' ? 'blue' : checked && page === 'pdp' ? 'rgba(14,90,167,.1)' : 'white',
                color: checked && page !== 'pdp' ? 'white' : 'copy',
            },
        },
    });
}, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.animations.easing.standard; }, space);
/**
 * Radio Label
 */
var RadioLabel = styled(Flex)(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) {
    var isRadio = props.isRadio;
    if (isRadio) {
        return "\n        display: flex;\n        align-items: center;\n      ";
    }
});
RadioLabel.defaultProps = { as: 'label' };
/**
 * RadioDrawer.tsx
 * - AnimatedContent
 * - Content
 * - RadioDrawerWrapper
 */
var Content$1 = styled(animated.div)(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  will-change: padding, transform, opacity, height;\n  box-sizing: content-box;\n  overflow: hidden;\n"], ["\n  will-change: padding, transform, opacity, height;\n  box-sizing: content-box;\n  overflow: hidden;\n"])));
var AnimatedContent = styled(animated(Flex))(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject([""], [""])));
var RadioDrawerWrapper = styled(Flex)(templateObject_9 || (templateObject_9 = __makeTemplateObject([""], [""])));
/**
 * Input
 */
var RadioInput = styled.input(templateObject_10 || (templateObject_10 = __makeTemplateObject([""], [""])));
var templateObject_1$8, templateObject_2$5, templateObject_3$4, templateObject_4$3, templateObject_5$2, templateObject_6$2, templateObject_7$1, templateObject_8$1, templateObject_9, templateObject_10;

// flexDirection = { getDirection(stacked); };
var getDirection = function (stacked) {
    if (stacked) {
        return 'column';
    }
    return ['column', 'column', 'row'];
};
var RadioDrawer = memo(function (props) {
    var children = props.children, isOpen = props.isOpen, _a = props.defaultOpen, defaultOpen = _a === void 0 ? true : _a, _b = props.stacked, stacked = _b === void 0 ? false : _b, drawerTitle = props.drawerTitle, noCollapse = props.noCollapse, variant = props.variant, rest = __rest(props, ["children", "isOpen", "defaultOpen", "stacked", "drawerTitle", "noCollapse", "variant"]);
    var _c = useState(defaultOpen), isDrawerOpen = _c[0], setDrawerOpen = _c[1];
    var drawer = useRef(null);
    var measurements = useMeasure(drawer);
    var viewHeight = measurements.height;
    var _d = useSpring({
        from: { padding: 0, height: 0, opacity: 0, transform: 'translate3d(20px,0,0)' },
        to: {
            height: isDrawerOpen ? viewHeight : 0,
            opacity: isDrawerOpen ? 1 : 0,
            padding: isDrawerOpen && !noCollapse ? 16 : 0,
            transform: "translate3d(" + (isDrawerOpen ? 0 : 20) + "px,0,0)",
        },
    }), height = _d.height, opacity = _d.opacity, transform = _d.transform, padding = _d.padding;
    var fontSize = variant === 'success' ? [1, 2] : [1];
    useEffect(function () {
        setDrawerOpen(isOpen);
    }, [isOpen]);
    return (React__default.createElement(Content$1, __assign({ style: {
            padding: padding,
            opacity: opacity,
            height: height,
            fontSize: fontSize,
        } }, rest),
        React__default.createElement(RadioDrawerWrapper, { flexDirection: "column", ref: drawer },
            drawerTitle && (React__default.createElement(Text.H3, { ml: variant === 'success' ? 0 : 2, mt: variant === 'success' ? 0 : 3, mb: 3, fontSize: fontSize, fontWeight: variant === 'success' ? 'normal' : 'bold' }, drawerTitle)),
            React__default.createElement(AnimatedContent, { ref: drawer, style: { transform: transform }, flexDirection: "" + getDirection(stacked) }, children))));
});

var RadioGroup = function (props) {
    var children = props.children, stacked = props.stacked, onChange = props.onChange, _a = props.defaultOpen, defaultOpen = _a === void 0 ? false : _a, drawerTitle = props.title, prefix = props.prefix, _b = props.testid, testid = _b === void 0 ? 'trolly-radio-group' : _b, _c = props.addText, addText = _c === void 0 ? 'ADD' : _c, _d = props.cancelText, cancelText = _d === void 0 ? 'CANCEL' : _d, _e = props.changeText, changeText = _e === void 0 ? 'CHANGE' : _e, page = props.page, _f = props.autoClose, autoClose = _f === void 0 ? true : _f, noCollapse = props.noCollapse, _g = props.variant, variant = _g === void 0 ? 'default' : _g;
    var ref = useRef(null);
    var _h = useState(''), checked = _h[0], setChecked = _h[1];
    var _j = useState(), title = _j[0], setTitle = _j[1];
    var _k = useState(defaultOpen), openDrawer = _k[0], setOpenDrawer = _k[1];
    useOnClickOutside(ref, function () {
        if (autoClose) {
            setOpenDrawer(false);
        }
        if (noCollapse) {
            setOpenDrawer(true);
        }
    });
    var onClickOpenDrawer = function () {
        setOpenDrawer(!openDrawer);
    };
    // @ts-ignore
    var noCheckedRadios = Children.map(children, function (child) {
        return child.props.hasOwnProperty('checked') ? child.props.checked : false;
    }).every(function (radioChecked) {
        return !radioChecked;
    });
    var hasValueSelected = !noCheckedRadios;
    useEffect(function () {
        Children.map(children, function (child) {
            var childProps = child.props;
            if (childProps.checked) {
                setChecked(childProps.value);
            }
        });
        if (noCollapse) {
            setOpenDrawer(true);
        }
    }, [children, noCollapse]);
    return (React__default.createElement(RadioGroupWrapper, { flexDirection: "column", ref: ref, isOpen: openDrawer, "data-testid": testid, noCollapse: noCollapse, variant: variant },
        !noCollapse && (React__default.createElement(RadioGroupHeader, { justifyContent: "space-between", isOpen: openDrawer, selected: hasValueSelected, variant: variant },
            React__default.createElement(Text.H3, { fontSize: variant === 'success' ? 2 : 1, fontWeight: "bold", color: variant === 'success' ? '#252525' : '' },
                prefix && (React__default.createElement(Text.Caption, { fontWeight: "bold", fontSize: variant === 'success' ? 2 : 1, color: variant === 'success' ? '#252525' : '' },
                    prefix,
                    ' ')),
                ' ',
                title),
            React__default.createElement(Button, { variant: "link", fontWeight: "bold", onClick: onClickOpenDrawer, size: variant === 'success' ? 'CUSTOM' : '' }, page !== 'pdp'
                ? !openDrawer
                    ? hasValueSelected
                        ? changeText
                        : addText
                    : cancelText
                : !openDrawer
                    ? changeText
                    : cancelText))),
        React__default.createElement(RadioDrawer, { isOpen: openDrawer, stacked: stacked, drawerTitle: drawerTitle, noCollapse: noCollapse, variant: variant }, Children.map(children, function (child, index) {
            return cloneElement(child, __assign(__assign({}, child.props), { checked: checked === child.props.value, index: index,
                onChange: onChange,
                onClickOpenDrawer: onClickOpenDrawer, key: "radio-" + index, setTitle: setTitle,
                setChecked: setChecked,
                noCheckedRadios: noCheckedRadios,
                page: page }));
        }))));
};

var SelectBox = styled(Flex)(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  flex-direction: column;\n  align-items: space-between;\n  justify-content: center;\n  height: 50px;\n  width: 100%;\n  color: #4d4d4d;\n  background: ", ";\n  padding: 10px 12px 9px;\n  border-radius: 2px;\n\n  &::after {\n    background: grey;\n    position: absolute;\n    top: 12px;\n    left: 8px;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #ffffff;\n    width: 0;\n    height: 0;\n  }\n"], ["\n  flex-direction: column;\n  align-items: space-between;\n  justify-content: center;\n  height: 50px;\n  width: 100%;\n  color: #4d4d4d;\n  background: ", ";\n  padding: 10px 12px 9px;\n  border-radius: 2px;\n\n  &::after {\n    background: grey;\n    position: absolute;\n    top: 12px;\n    left: 8px;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #ffffff;\n    width: 0;\n    height: 0;\n  }\n"])), function (props) { return props.background; });
var Wrapper = styled(Flex)(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  justify-content: ", ";\n  align-items: ", ";\n"], ["\n  justify-content: ", ";\n  align-items: ", ";\n"])), function (props) { return (props.variant === 'secondary' ? 'center' : 'space-between'); }, function (props) { return (props.variant === 'secondary' ? 'center' : 'auto'); });
var SelectBoxLabel = styled(Box)(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n  margin-inline-end: ", ";\n  ", ";\n"], ["\n  color: ", ";\n  font-size: ", ";\n  margin-inline-end: ", ";\n  ", ";\n"])), function (props) { return (props.variant === 'secondary' ? '#000' : '#4d4d4d'); }, function (props) { return (props.variant === 'secondary' ? '12px' : '14px'); }, function (props) { return (props.variant === 'secondary' ? '4px' : '16px'); }, function (props) { return (props.variant === 'secondary' ? 'font-weight:700' : ''); });
/**
 * Select Options
 */
Card.defaultProps = { elevation: 2, p: 2, m: 0, as: 'ul' };
var SelectOptions = styled(animated(Card))(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  padding: ", ";\n  z-index: 1;\n  position: absolute;\n  width: 100%;\n  max-height: 200px;\n  scroll-behavior: auto;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  text-align: ", ";\n\n  &::-webkit-scrollbar {\n    height: 6px;\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: ", ";\n    cursor: grab;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: 0;\n  }\n"], ["\n  padding: ", ";\n  z-index: 1;\n  position: absolute;\n  width: 100%;\n  max-height: 200px;\n  scroll-behavior: auto;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  text-align: ", ";\n\n  &::-webkit-scrollbar {\n    height: 6px;\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: ", ";\n    cursor: grab;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: 0;\n  }\n"])), function (props) { return (props.variant === 'default' ? 2 : 0); }, function (props) { return props.listTextAlign; }, function (props) { return props.theme.colors.mercury; });
var SelectOption = styled.li(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  color: ", ";\n  padding: ", "px;\n  border-radius: 4px;\n  cursor: pointer;\n\n  ", "\n\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  color: ", ";\n  padding: ", "px;\n  border-radius: 4px;\n  cursor: pointer;\n\n  ",
    "\n\n  &:hover {\n    background: ",
    ";\n  }\n"])), function (props) { return props.theme.colors.copy; }, function (props) { return props.theme.space[2]; }, function (props) {
    var selected = props.selected;
    if (selected) {
        var color = '';
        switch (props.variant) {
            case 'secondary':
                color = 'rgba(236, 244, 253, 0.7)';
                break;
            default:
                color = darken('#f5f5f5', 2);
                break;
        }
        return "\n      color: #0E5AA7;\n      font-weight: bold;\n      background: " + color + ";\n      ";
    }
}, function (props) {
    switch (props.variant) {
        case 'secondary':
            return 'rgba(236, 244, 253, 0.7)';
        default:
            return darken('#f5f5f5', 2);
    }
});
var SelectWrapper = styled.div(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  cursor: pointer;\n  position: relative;\n  width: 100%;\n  display: inline-block;\n  ", "\n"], ["\n  cursor: pointer;\n  position: relative;\n  width: 100%;\n  display: inline-block;\n  ", "\n"])), space);
var SelectArrow = styled.i(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), space);
var Title$1 = styled(Box)(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
Title$1.defaultProps = {
    as: 'span',
    fontSize: 1,
    fontWeight: 4,
    color: 'copy',
    mr: 4,
    mb: 2,
};
var templateObject_1$9, templateObject_2$6, templateObject_3$5, templateObject_4$4, templateObject_5$3, templateObject_6$3, templateObject_7$2, templateObject_8$2;

var ArrowDown = function (props) { return (React__default.createElement("svg", __assign({ viewBox: "0 0 24 24" }, props),
    React__default.createElement("path", { fill: "none", stroke: props.strokefill, strokeWidth: props.strokeWidth, strokeLinejoin: "round", d: "M22 7.19l-9.873 9.873L2 6.937" }),
    React__default.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }))); };

var ArrowUp = function (props) { return (React__default.createElement("svg", __assign({ "data-name": "Layer 1", viewBox: "0 0 24 24" }, props),
    React__default.createElement("title", null, 'Ic'),
    React__default.createElement("path", { fill: "none", stroke: props.strokefill, strokeWidth: props.strokeWidth, strokeLinejoin: "round", d: "M2 16.81l9.873-9.873L22 17.063" }),
    React__default.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }))); };

var Select = function (props) {
    /**
     * Props
     */
    var label = props.label, title = props.title, id = props.id, name = props.name, onChange = props.onChange, listTextAlign = props.listTextAlign, _a = props.value, value = _a === void 0 ? null : _a, testid = props.testid, isLabelSeletionNull = props.isLabelSeletionNull, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, _d = props.background, background = _d === void 0 ? 'white' : _d, _e = props.arrowStrokeColor, arrowStrokeColor = _e === void 0 ? '#4d4d4d' : _e, _f = props.arrowStrokeWidth, arrowStrokeWidth = _f === void 0 ? '1' : _f, rest = __rest(props, ["label", "title", "id", "name", "onChange", "listTextAlign", "value", "testid", "isLabelSeletionNull", "variant", "disabled", "background", "arrowStrokeColor", "arrowStrokeWidth"]);
    /**
     * Ref
     */
    var ref = useRef(null);
    /**
     * State
     */
    var _g = useState(props.options), options = _g[0], setOptions = _g[1];
    var _h = useState(false), open = _h[0], setOpen = _h[1];
    var _j = useState(), selected = _j[0], setSelected = _j[1];
    useEffect(function () {
        setOptions(props.options);
        if (value !== null) {
            return;
        }
        if (isLabelSeletionNull) {
            setSelected({ id: null, label: label, value: null });
        }
        else if (label) {
            setSelected({ id: null, label: label, value: label });
        }
        else {
            setSelected(options[0]);
        }
    }, [label, value, props.options, options, isLabelSeletionNull]);
    useEffect(function () {
        if (value !== null) {
            var valueObj_1 = __assign({ id: null }, (value === Object(value)
                ? value
                : {
                    label: value,
                    value: value,
                }));
            var selectedOption = options.filter(function (x) { return x.value === valueObj_1.value; })[0];
            setSelected(selectedOption || valueObj_1);
        }
    }, [value, options]);
    /**
     * Handles & Interactions
     */
    useOnClickOutside(ref, function () { return setOpen(false); });
    var onOpenSelectHandle = function () {
        setOpen(!open);
    };
    var onSelectOptionHandle = function (option, index) { return function () {
        setSelected(option);
        setOpen(!open);
        onChange(option, index);
    }; };
    var transitions = useTransition(open, null, {
        from: { opacity: 0, transform: 'translateY(-15%)' },
        enter: { opacity: 1, transform: 'translateY(0%)' },
        leave: { opacity: 0, transform: 'translateY(5%)' },
    });
    var iconsSize = { height: '12px' };
    return (React__default.createElement(SelectWrapper, __assign({ id: id, name: name, error: false, ref: ref }, rest, { "data-testid": testid }),
        React__default.createElement(SelectBox, { "data-testid": "select-box", open: open, onClick: onOpenSelectHandle, background: background },
            title && React__default.createElement(Title$1, null, title),
            React__default.createElement(Wrapper, { variant: variant },
                selected ? (React__default.createElement(SelectBoxLabel, { variant: variant, as: "span" }, selected.label)) : (React__default.createElement(SelectBoxLabel, { variant: variant }, label)),
                !disabled && (React__default.createElement(React__default.Fragment, null, open ? (React__default.createElement(ArrowUp, { style: iconsSize, strokefill: arrowStrokeColor, strokeWidth: arrowStrokeWidth })) : (React__default.createElement(ArrowDown, { style: iconsSize, strokefill: arrowStrokeColor, strokeWidth: arrowStrokeWidth })))))),
        transitions.map(function (spring) {
            return (spring.item && (React__default.createElement(SelectOptions, { open: open, style: spring.props, key: spring.key, listTextAlign: listTextAlign, variant: variant }, options.map(function (option, index) { return (React__default.createElement(SelectOption, { "data-testid": "__selection_options_value__", selected: selected === option, key: option.id, onClick: onSelectOptionHandle(option, index), variant: variant }, option.label)); }))));
        })));
};
Select.defaultProps = {
    m: 2,
    testid: 'trolly-select',
    listTextAlign: 'center',
};

var _a$2 = theme.colors, blue$3 = _a$2.blue, mercury$1 = _a$2.mercury, silverChalice = _a$2.silverChalice, white$1 = _a$2.white;
var SwitchWrapper = styled.div(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var SwitchButtonWrapper = styled.div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject([""], [""])));
var Toggle = styled.input(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  position: absolute;\n  width: 36px;\n  opacity: 0;\n  height: 20px;\n  z-index: 1; /* 500; */\n  cursor: ", ";\n"], ["\n  position: absolute;\n  width: 36px;\n  opacity: 0;\n  height: 20px;\n  z-index: 1; /* 500; */\n  cursor: ", ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'default' : 'pointer');
});
var SwitchButton = styled.div(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  position: relative;\n  display: block;\n  width: 36px;\n  height: 20px;\n\n  ::before,\n  ::after {\n    content: '';\n    position: absolute;\n    margin: 0;\n    top: 50%;\n    transition: all 0.3s ease;\n  }\n\n  ::before {\n    transform: translate(0, -50%);\n    left: 1px;\n    width: 34px;\n    height: 14px;\n    border-radius: 8px;\n    background-color: ", ";\n    opacity: ", ";\n  }\n  ::after {\n    content: '';\n    left: 0;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.098), 0 1px 5px 0 rgba(0, 0, 0, 0.084);\n    background-color: mercury;\n    transform: ", ";\n    background-color: ", ";\n  }\n"], ["\n  position: relative;\n  display: block;\n  width: 36px;\n  height: 20px;\n\n  ::before,\n  ::after {\n    content: '';\n    position: absolute;\n    margin: 0;\n    top: 50%;\n    transition: all 0.3s ease;\n  }\n\n  ::before {\n    transform: translate(0, -50%);\n    left: 1px;\n    width: 34px;\n    height: 14px;\n    border-radius: 8px;\n    background-color: ",
    ";\n    opacity: ",
    ";\n  }\n  ::after {\n    content: '';\n    left: 0;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.098), 0 1px 5px 0 rgba(0, 0, 0, 0.084);\n    background-color: mercury;\n    transform: ", ";\n    background-color: ",
    ";\n  }\n"])), function (_a) {
    var checked = _a.checked, color = _a.color, isNewC4Journey = _a.isNewC4Journey;
    if (isNewC4Journey) {
        return color;
    }
    return checked ? color : silverChalice;
}, function (_a) {
    var checked = _a.checked, isNewC4Journey = _a.isNewC4Journey;
    if (isNewC4Journey) {
        return checked ? 1 : 0.28;
    }
    return checked ? 0.3 : 1;
}, function (_a) {
    var checked = _a.checked;
    return (checked ? 'translate(80%, -50%)' : 'translate(0, -50%)');
}, function (_a) {
    var checked = _a.checked, color = _a.color, isNewC4Journey = _a.isNewC4Journey;
    if (isNewC4Journey) {
        return white$1;
    }
    return checked ? color : mercury$1;
});
SwitchButton.defaultProps = {
    color: blue$3,
};
var Label = styled.label(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  ", ";\n  padding: ", ";\n"], ["\n  ", ";\n  padding: ", ";\n"])), function (_a) {
    var labelLeft = _a.labelLeft;
    return (labelLeft ? 'order: -1' : '');
}, function (_a) {
    var labelLeft = _a.labelLeft;
    return (labelLeft ? '0 16px 0 0' : '0 0 0 16px');
});
var templateObject_1$a, templateObject_2$7, templateObject_3$6, templateObject_4$5, templateObject_5$4;

var Switch = function (props) {
    var name = props.name, label = props.label, disabled = props.disabled, testid = props.testid, children = props.children, labelLeft = props.labelLeft, onChange = props.onChange, _a = props.checked, switchState = _a === void 0 ? false : _a, color = props.color, isNewC4Journey = props.isNewC4Journey, rest = __rest(props, ["name", "label", "disabled", "testid", "children", "labelLeft", "onChange", "checked", "color", "isNewC4Journey"]);
    var _b = useState(switchState), checked = _b[0], setChecked = _b[1];
    var onChangeCallback = useCallback(function (event) {
        setChecked(!checked);
        if (onChange) {
            onChange(event, !checked);
        }
    }, [onChange, checked]);
    useEffect(function () {
        setChecked(switchState);
    }, [switchState]);
    return (React__default.createElement(SwitchWrapper, __assign({}, rest),
        React__default.createElement(SwitchButtonWrapper, null,
            React__default.createElement(Toggle, { "data-testid": testid, type: "checkbox", name: name, checked: checked, onChange: onChangeCallback, disabled: disabled }),
            React__default.createElement(SwitchButton, { checked: checked, color: color, isNewC4Journey: isNewC4Journey })),
        label && (React__default.createElement(Label, { "data-testid": testid + "-label", htmlFor: name, labelLeft: labelLeft }, label)),
        children));
};
Switch.defaultProps = {
    testid: 'trolly-switch',
};

var fadeIn = keyframes(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n"], ["\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n"])));
var GlobalStyle = function (_a) {
    var isRtl = _a.isRtl;
    return (React__default.createElement(Global, { styles: css$1(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n      /* http://meyerweb.com/eric/tools/css/reset/\n        v2.0-modified | 20110126\n        License: none (public domain)\n      */\n      html,\n      body,\n      div,\n      span,\n      applet,\n      object,\n      iframe,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5,\n      h6,\n      p,\n      blockquote,\n      pre,\n      a,\n      abbr,\n      acronym,\n      address,\n      big,\n      cite,\n      code,\n      del,\n      dfn,\n      em,\n      img,\n      ins,\n      kbd,\n      q,\n      s,\n      samp,\n      small,\n      strike,\n      strong,\n      sub,\n      sup,\n      tt,\n      var,\n      b,\n      u,\n      i,\n      center,\n      dl,\n      dt,\n      dd,\n      ol,\n      ul,\n      li,\n      fieldset,\n      form,\n      label,\n      legend,\n      table,\n      caption,\n      tbody,\n      tfoot,\n      thead,\n      tr,\n      th,\n      td,\n      article,\n      aside,\n      canvas,\n      details,\n      embed,\n      figure,\n      figcaption,\n      footer,\n      header,\n      hgroup,\n      menu,\n      nav,\n      output,\n      ruby,\n      section,\n      summary,\n      time,\n      mark,\n      audio,\n      video {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        font-size: 100%;\n        vertical-align: baseline;\n      }\n\n      /* make sure to set some focus styles for accessibility */\n      :focus {\n        outline: 0;\n      }\n\n      /* HTML5 display-role reset for older browsers */\n      article,\n      aside,\n      details,\n      figcaption,\n      figure,\n      footer,\n      header,\n      hgroup,\n      menu,\n      nav,\n      section {\n        display: block;\n      }\n\n      body {\n        font-family: ", ";\n        font-size: 14px;\n        line-height: 1;\n      }\n\n      ol,\n      ul {\n        list-style: none;\n      }\n\n      blockquote,\n      q {\n        quotes: none;\n      }\n\n      blockquote:before,\n      blockquote:after,\n      q:before,\n      q:after {\n        content: '';\n        content: none;\n      }\n\n      table {\n        border-collapse: collapse;\n        border-spacing: 0;\n      }\n\n      input[type='search']::-webkit-search-cancel-button,\n      input[type='search']::-webkit-search-decoration,\n      input[type='search']::-webkit-search-results-button,\n      input[type='search']::-webkit-search-results-decoration {\n        -webkit-appearance: none;\n        -moz-appearance: none;\n      }\n\n      input[type='search'] {\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        -webkit-box-sizing: content-box;\n        -moz-box-sizing: content-box;\n        box-sizing: content-box;\n      }\n\n      textarea {\n        overflow: auto;\n        vertical-align: top;\n        resize: vertical;\n      }\n\n      /**\n  * Correct 'inline-block' display not defined in IE 6/7/8/9 and Firefox 3.\n  */\n\n      audio,\n      canvas,\n      video {\n        display: inline-block;\n        *display: inline;\n        *zoom: 1;\n        max-width: 100%;\n      }\n\n      /**\n  * Prevent modern browsers from displaying 'audio' without controls.\n  * Remove excess height in iOS 5 devices.\n  */\n\n      audio:not([controls]) {\n        display: none;\n        height: 0;\n      }\n\n      /**\n  * Address styling not present in IE 7/8/9, Firefox 3, and Safari 4.\n  * Known issue: no IE 6 support.\n  */\n\n      [hidden] {\n        display: none;\n      }\n\n      /**\n  * 1. Correct text resizing oddly in IE 6/7 when body 'font - size' is set using\n  *    'em' units.\n  * 2. Prevent iOS text size adjust after orientation change, without disabling\n  *    user zoom.\n  */\n\n      html {\n        font-size: 100%; /* 1 */\n        -webkit-text-size-adjust: 100%; /* 2 */\n        -ms-text-size-adjust: 100%; /* 2 */\n      }\n\n      /**\n  * Address 'outline' inconsistency between Chrome and other browsers.\n  */\n\n      a:focus {\n        outline: thin dotted;\n      }\n\n      /**\n  * Improve readability when focused and also mouse hovered in all browsers.\n  */\n\n      a:active,\n      a:hover {\n        outline: 0;\n      }\n\n      /**\n  * 1. Remove border when inside 'a' element in IE 6/7/8/9 and Firefox 3.\n  * 2. Improve image quality when scaled in IE 7.\n  */\n\n      img {\n        border: 0; /* 1 */\n        -ms-interpolation-mode: bicubic; /* 2 */\n      }\n\n      /**\n  * Address margin not present in IE 6/7/8/9, Safari 5, and Opera 11.\n  */\n\n      figure {\n        margin: 0;\n      }\n\n      /**\n  * Correct margin displayed oddly in IE 6/7.\n  */\n\n      form {\n        margin: 0;\n      }\n\n      /**\n  * Define consistent border, margin, and padding.\n  */\n\n      fieldset {\n        border: 1px solid #c0c0c0;\n        margin: 0 2px;\n        padding: 0.35em 0.625em 0.75em;\n      }\n\n      /**\n  * 1. Correct color not being inherited in IE 6/7/8/9.\n  * 2. Correct text not wrapping in Firefox 3.\n  * 3. Correct alignment displayed oddly in IE 6/7.\n  */\n\n      legend {\n        border: 0; /* 1 */\n        padding: 0;\n        white-space: normal; /* 2 */\n        *margin-left: -7px; /* 3 */\n      }\n\n      /**\n  * 1. Correct font size not being inherited in all browsers.\n  * 2. Address margins set differently in IE 6/7, Firefox 3+, Safari 5,\n  *    and Chrome.\n  * 3. Improve appearance and consistency in all browsers.\n  */\n\n      button,\n      input,\n      select,\n      textarea {\n        font-size: 100%; /* 1 */\n        margin: 0; /* 2 */\n        vertical-align: baseline; /* 3 */\n        *vertical-align: middle; /* 3 */\n      }\n\n      /**\n  * Address Firefox 3+ setting 'line - height' on 'input' using '!important' in\n  * the UA stylesheet.\n  */\n\n      button,\n      input {\n        line-height: normal;\n      }\n\n      /**\n  * Address inconsistent 'text - transform' inheritance for 'button' and 'select'.\n  * All other form control elements do not inherit 'text - transform' values.\n  * Correct 'button' style inheritance in Chrome, Safari 5+, and IE 6+.\n  * Correct 'select' style inheritance in Firefox 4+ and Opera.\n  */\n\n      button,\n      select {\n        text-transform: none;\n      }\n\n      /**\n  * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native 'audio'\n  *    and 'video' controls.\n  * 2. Correct inability to style clickable 'input' types in iOS.\n  * 3. Improve usability and consistency of cursor style between image-type\n  *    'input' and others.\n  * 4. Remove inner spacing in IE 7 without affecting normal text inputs.\n  *    Known issue: inner spacing remains in IE 6.\n  */\n\n      button,\n  html input[type=\"button\"], /* 1 */\n  input[type=\"reset\"],\n  input[type=\"submit\"] {\n        -webkit-appearance: button; /* 2 */\n        cursor: pointer; /* 3 */\n        *overflow: visible; /* 4 */\n      }\n\n      /**\n  * Re-set default cursor for disabled elements.\n  */\n\n      button[disabled],\n      html input[disabled] {\n        cursor: default;\n      }\n\n      /**\n  * 1. Address box sizing set to content-box in IE 8/9.\n  * 2. Remove excess padding in IE 8/9.\n  * 3. Remove excess padding in IE 7.\n  *    Known issue: excess padding remains in IE 6.\n  */\n\n      input[type='checkbox'],\n      input[type='radio'] {\n        box-sizing: border-box; /* 1 */\n        padding: 0; /* 2 */\n        *height: 13px; /* 3 */\n        *width: 13px; /* 3 */\n      }\n\n      /**\n  * 1. Address 'appearance' set to 'searchfield' in Safari 5 and Chrome.\n  * 2. Address 'box - sizing' set to 'border - box' in Safari 5 and Chrome\n  *    (include '- moz' to future-proof).\n  */\n\n      input[type='search'] {\n        -webkit-appearance: textfield; /* 1 */\n        -moz-box-sizing: content-box;\n        -webkit-box-sizing: content-box; /* 2 */\n        box-sizing: content-box;\n      }\n\n      /**\n  * Remove inner padding and search cancel button in Safari 5 and Chrome\n  * on OS X.\n  */\n\n      input[type='search']::-webkit-search-cancel-button,\n      input[type='search']::-webkit-search-decoration {\n        -webkit-appearance: none;\n      }\n\n      /**\n  * Remove inner padding and border in Firefox 3+.\n  */\n\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n\n      /**\n  * 1. Remove default vertical scrollbar in IE 6/7/8/9.\n  * 2. Improve readability and alignment in all browsers.\n  */\n\n      textarea {\n        overflow: auto; /* 1 */\n        vertical-align: top; /* 2 */\n      }\n\n      /**\n  * Remove most spacing between table cells.\n  */\n\n      table {\n        border-collapse: collapse;\n        border-spacing: 0;\n      }\n\n      html,\n      button,\n      input,\n      select,\n      textarea {\n        color: #222;\n      }\n\n      ::-moz-selection {\n        background: #b3d4fc;\n        text-shadow: none;\n      }\n\n      ::selection {\n        background: #b3d4fc;\n        text-shadow: none;\n      }\n\n      img {\n        vertical-align: middle;\n      }\n\n      fieldset {\n        border: 0;\n        margin: 0;\n        padding: 0;\n      }\n\n      textarea {\n        resize: vertical;\n      }\n\n      .chromeframe {\n        margin: 0.2em 0;\n        background: #ccc;\n        color: #000;\n        padding: 0.2em 0;\n      }\n\n      *,\n      *::before,\n      *::after {\n        box-sizing: border-box;\n        word-wrap: break-word;\n      }\n\n      img.lazy-image-loaded {\n        animation: ", " 130ms ease-in;\n      }\n\n      div.pac-container {\n        z-index: 1041;\n        padding: 5px 10px;\n      }\n      .pac-item {\n        border: 1px solid #cfcfcf;\n        border-radius: 15px;\n        padding: 5px 10px;\n        margin-top: 10px;\n        color: #000;\n      }\n      .pac-item:hover,\n      .pac-item-selected {\n        background-color: #0e5aa7;\n        color: #fff;\n      }\n      .pac-icon {\n        display: none;\n      }\n      .pac-item-query {\n        color: inherit;\n      }\n    "], ["\n      /* http://meyerweb.com/eric/tools/css/reset/\n        v2.0-modified | 20110126\n        License: none (public domain)\n      */\n      html,\n      body,\n      div,\n      span,\n      applet,\n      object,\n      iframe,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5,\n      h6,\n      p,\n      blockquote,\n      pre,\n      a,\n      abbr,\n      acronym,\n      address,\n      big,\n      cite,\n      code,\n      del,\n      dfn,\n      em,\n      img,\n      ins,\n      kbd,\n      q,\n      s,\n      samp,\n      small,\n      strike,\n      strong,\n      sub,\n      sup,\n      tt,\n      var,\n      b,\n      u,\n      i,\n      center,\n      dl,\n      dt,\n      dd,\n      ol,\n      ul,\n      li,\n      fieldset,\n      form,\n      label,\n      legend,\n      table,\n      caption,\n      tbody,\n      tfoot,\n      thead,\n      tr,\n      th,\n      td,\n      article,\n      aside,\n      canvas,\n      details,\n      embed,\n      figure,\n      figcaption,\n      footer,\n      header,\n      hgroup,\n      menu,\n      nav,\n      output,\n      ruby,\n      section,\n      summary,\n      time,\n      mark,\n      audio,\n      video {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        font-size: 100%;\n        vertical-align: baseline;\n      }\n\n      /* make sure to set some focus styles for accessibility */\n      :focus {\n        outline: 0;\n      }\n\n      /* HTML5 display-role reset for older browsers */\n      article,\n      aside,\n      details,\n      figcaption,\n      figure,\n      footer,\n      header,\n      hgroup,\n      menu,\n      nav,\n      section {\n        display: block;\n      }\n\n      body {\n        font-family: ", ";\n        font-size: 14px;\n        line-height: 1;\n      }\n\n      ol,\n      ul {\n        list-style: none;\n      }\n\n      blockquote,\n      q {\n        quotes: none;\n      }\n\n      blockquote:before,\n      blockquote:after,\n      q:before,\n      q:after {\n        content: '';\n        content: none;\n      }\n\n      table {\n        border-collapse: collapse;\n        border-spacing: 0;\n      }\n\n      input[type='search']::-webkit-search-cancel-button,\n      input[type='search']::-webkit-search-decoration,\n      input[type='search']::-webkit-search-results-button,\n      input[type='search']::-webkit-search-results-decoration {\n        -webkit-appearance: none;\n        -moz-appearance: none;\n      }\n\n      input[type='search'] {\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        -webkit-box-sizing: content-box;\n        -moz-box-sizing: content-box;\n        box-sizing: content-box;\n      }\n\n      textarea {\n        overflow: auto;\n        vertical-align: top;\n        resize: vertical;\n      }\n\n      /**\n  * Correct 'inline-block' display not defined in IE 6/7/8/9 and Firefox 3.\n  */\n\n      audio,\n      canvas,\n      video {\n        display: inline-block;\n        *display: inline;\n        *zoom: 1;\n        max-width: 100%;\n      }\n\n      /**\n  * Prevent modern browsers from displaying 'audio' without controls.\n  * Remove excess height in iOS 5 devices.\n  */\n\n      audio:not([controls]) {\n        display: none;\n        height: 0;\n      }\n\n      /**\n  * Address styling not present in IE 7/8/9, Firefox 3, and Safari 4.\n  * Known issue: no IE 6 support.\n  */\n\n      [hidden] {\n        display: none;\n      }\n\n      /**\n  * 1. Correct text resizing oddly in IE 6/7 when body 'font - size' is set using\n  *    'em' units.\n  * 2. Prevent iOS text size adjust after orientation change, without disabling\n  *    user zoom.\n  */\n\n      html {\n        font-size: 100%; /* 1 */\n        -webkit-text-size-adjust: 100%; /* 2 */\n        -ms-text-size-adjust: 100%; /* 2 */\n      }\n\n      /**\n  * Address 'outline' inconsistency between Chrome and other browsers.\n  */\n\n      a:focus {\n        outline: thin dotted;\n      }\n\n      /**\n  * Improve readability when focused and also mouse hovered in all browsers.\n  */\n\n      a:active,\n      a:hover {\n        outline: 0;\n      }\n\n      /**\n  * 1. Remove border when inside 'a' element in IE 6/7/8/9 and Firefox 3.\n  * 2. Improve image quality when scaled in IE 7.\n  */\n\n      img {\n        border: 0; /* 1 */\n        -ms-interpolation-mode: bicubic; /* 2 */\n      }\n\n      /**\n  * Address margin not present in IE 6/7/8/9, Safari 5, and Opera 11.\n  */\n\n      figure {\n        margin: 0;\n      }\n\n      /**\n  * Correct margin displayed oddly in IE 6/7.\n  */\n\n      form {\n        margin: 0;\n      }\n\n      /**\n  * Define consistent border, margin, and padding.\n  */\n\n      fieldset {\n        border: 1px solid #c0c0c0;\n        margin: 0 2px;\n        padding: 0.35em 0.625em 0.75em;\n      }\n\n      /**\n  * 1. Correct color not being inherited in IE 6/7/8/9.\n  * 2. Correct text not wrapping in Firefox 3.\n  * 3. Correct alignment displayed oddly in IE 6/7.\n  */\n\n      legend {\n        border: 0; /* 1 */\n        padding: 0;\n        white-space: normal; /* 2 */\n        *margin-left: -7px; /* 3 */\n      }\n\n      /**\n  * 1. Correct font size not being inherited in all browsers.\n  * 2. Address margins set differently in IE 6/7, Firefox 3+, Safari 5,\n  *    and Chrome.\n  * 3. Improve appearance and consistency in all browsers.\n  */\n\n      button,\n      input,\n      select,\n      textarea {\n        font-size: 100%; /* 1 */\n        margin: 0; /* 2 */\n        vertical-align: baseline; /* 3 */\n        *vertical-align: middle; /* 3 */\n      }\n\n      /**\n  * Address Firefox 3+ setting 'line - height' on 'input' using '!important' in\n  * the UA stylesheet.\n  */\n\n      button,\n      input {\n        line-height: normal;\n      }\n\n      /**\n  * Address inconsistent 'text - transform' inheritance for 'button' and 'select'.\n  * All other form control elements do not inherit 'text - transform' values.\n  * Correct 'button' style inheritance in Chrome, Safari 5+, and IE 6+.\n  * Correct 'select' style inheritance in Firefox 4+ and Opera.\n  */\n\n      button,\n      select {\n        text-transform: none;\n      }\n\n      /**\n  * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native 'audio'\n  *    and 'video' controls.\n  * 2. Correct inability to style clickable 'input' types in iOS.\n  * 3. Improve usability and consistency of cursor style between image-type\n  *    'input' and others.\n  * 4. Remove inner spacing in IE 7 without affecting normal text inputs.\n  *    Known issue: inner spacing remains in IE 6.\n  */\n\n      button,\n  html input[type=\"button\"], /* 1 */\n  input[type=\"reset\"],\n  input[type=\"submit\"] {\n        -webkit-appearance: button; /* 2 */\n        cursor: pointer; /* 3 */\n        *overflow: visible; /* 4 */\n      }\n\n      /**\n  * Re-set default cursor for disabled elements.\n  */\n\n      button[disabled],\n      html input[disabled] {\n        cursor: default;\n      }\n\n      /**\n  * 1. Address box sizing set to content-box in IE 8/9.\n  * 2. Remove excess padding in IE 8/9.\n  * 3. Remove excess padding in IE 7.\n  *    Known issue: excess padding remains in IE 6.\n  */\n\n      input[type='checkbox'],\n      input[type='radio'] {\n        box-sizing: border-box; /* 1 */\n        padding: 0; /* 2 */\n        *height: 13px; /* 3 */\n        *width: 13px; /* 3 */\n      }\n\n      /**\n  * 1. Address 'appearance' set to 'searchfield' in Safari 5 and Chrome.\n  * 2. Address 'box - sizing' set to 'border - box' in Safari 5 and Chrome\n  *    (include '- moz' to future-proof).\n  */\n\n      input[type='search'] {\n        -webkit-appearance: textfield; /* 1 */\n        -moz-box-sizing: content-box;\n        -webkit-box-sizing: content-box; /* 2 */\n        box-sizing: content-box;\n      }\n\n      /**\n  * Remove inner padding and search cancel button in Safari 5 and Chrome\n  * on OS X.\n  */\n\n      input[type='search']::-webkit-search-cancel-button,\n      input[type='search']::-webkit-search-decoration {\n        -webkit-appearance: none;\n      }\n\n      /**\n  * Remove inner padding and border in Firefox 3+.\n  */\n\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n\n      /**\n  * 1. Remove default vertical scrollbar in IE 6/7/8/9.\n  * 2. Improve readability and alignment in all browsers.\n  */\n\n      textarea {\n        overflow: auto; /* 1 */\n        vertical-align: top; /* 2 */\n      }\n\n      /**\n  * Remove most spacing between table cells.\n  */\n\n      table {\n        border-collapse: collapse;\n        border-spacing: 0;\n      }\n\n      html,\n      button,\n      input,\n      select,\n      textarea {\n        color: #222;\n      }\n\n      ::-moz-selection {\n        background: #b3d4fc;\n        text-shadow: none;\n      }\n\n      ::selection {\n        background: #b3d4fc;\n        text-shadow: none;\n      }\n\n      img {\n        vertical-align: middle;\n      }\n\n      fieldset {\n        border: 0;\n        margin: 0;\n        padding: 0;\n      }\n\n      textarea {\n        resize: vertical;\n      }\n\n      .chromeframe {\n        margin: 0.2em 0;\n        background: #ccc;\n        color: #000;\n        padding: 0.2em 0;\n      }\n\n      *,\n      *::before,\n      *::after {\n        box-sizing: border-box;\n        word-wrap: break-word;\n      }\n\n      img.lazy-image-loaded {\n        animation: ", " 130ms ease-in;\n      }\n\n      div.pac-container {\n        z-index: 1041;\n        padding: 5px 10px;\n      }\n      .pac-item {\n        border: 1px solid #cfcfcf;\n        border-radius: 15px;\n        padding: 5px 10px;\n        margin-top: 10px;\n        color: #000;\n      }\n      .pac-item:hover,\n      .pac-item-selected {\n        background-color: #0e5aa7;\n        color: #fff;\n      }\n      .pac-icon {\n        display: none;\n      }\n      .pac-item-query {\n        color: inherit;\n      }\n    "])), isRtl ? 'Noto Kufi Arabic' : theme.fonts.sansSerif, fadeIn) }));
};
var templateObject_1$b, templateObject_2$8;

var ThemeProvider = function (_a) {
    var children = _a.children, _b = _a.includeReset, includeReset = _b === void 0 ? true : _b, _c = _a.language, language = _c === void 0 ? 'en' : _c, _d = _a.extraTheme, extraTheme = _d === void 0 ? {} : _d;
    var isRtl = language === 'ar';
    var cache = useMemo(function () {
        return createCache(isRtl
            ? {
                stylisPlugins: [stylisRtl],
                speedy: true,
                prefix: true,
            }
            : {
                speedy: true,
            });
    }, [isRtl]);
    return (React__default.createElement(CacheProvider, { value: cache },
        React__default.createElement(ThemeProvider$1, { theme: __assign(__assign({}, theme), extraTheme) },
            includeReset && React__default.createElement(GlobalStyle, { isRtl: isRtl }),
            children)));
};
var MemoizedTheme = React__default.memo(ThemeProvider, function (_a, _b) {
    var prevInclude = _a.includeReset, prevLang = _a.language;
    var nextInclude = _b.includeReset, nextLang = _b.language;
    return prevLang !== nextLang || prevInclude !== nextInclude;
});

var CashbackWrapper = styled.span(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n"], ["\n  background-color: ", ";\n  display: flex;\n"])), function (props) { return props.theme.colors.cashbackGreen; });
var CashbackContentWrapper = styled.span(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 6px 0;\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 6px 0;\n"])));
var StickerWrapper = styled.span(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  display: inline-block;\n  border-radius: ", ";\n  ", ";\n  ", ";\n  ", "\n  ", ";\n  ", ";\n  ", "\n  ", ";\n  ", ";\n"], ["\n  display: inline-block;\n  border-radius: ",
    ";\n  ", ";\n  ", ";\n  ", "\n  ", ";\n  ", ";\n  ", "\n  ", ";\n  ", ";\n"])), function (_a) {
    var round = _a.round, theme = _a.theme;
    return round ? theme.radii[4] + "px" : '0px';
}, alignItems, border, color, flex, justifyContent, layout, space, typography);
var CashbackSticker = styled(StickerWrapper)(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n  align-items: center;\n  border-bottom-right-radius: 26px;\n  display: flex;\n  font-size: 70%;\n  justify-content: center;\n  padding: 0;\n\n  html[dir='rtl'] & {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 26px;\n  }\n"], ["\n  align-items: center;\n  border-bottom-right-radius: 26px;\n  display: flex;\n  font-size: 70%;\n  justify-content: center;\n  padding: 0;\n\n  html[dir='rtl'] & {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 26px;\n  }\n"])));
var templateObject_1$c, templateObject_2$9, templateObject_3$7, templateObject_4$6;

var getVariant = function (props) {
    var variant = props.variant, color = props.color, fontColor = props.fontColor;
    switch (variant) {
        case 'outlined':
            return {
                color: fontColor ? fontColor : color,
                backgroundColor: 'transparent',
                border: '2px solid',
                borderColor: color,
            };
        case 'filled':
            return {
                color: fontColor ? fontColor : 'white',
                backgroundColor: color,
            };
        case 'cashback':
            return {
                alignItems: 'center',
                color: fontColor ? fontColor : 'white',
                display: 'flex',
                backgroundColor: 'cashbackGreen',
                justifyContent: 'center',
                padding: '0 2px',
            };
    }
};
var Sticker = function (props) {
    var children = props.children, testid = props.testid, variant = props.variant, rest = __rest(props, ["children", "testid", "variant"]);
    if (variant === 'cashback') {
        return (React__default.createElement(CashbackWrapper, __assign({}, props),
            React__default.createElement(CashbackSticker, __assign({}, getVariant({ variant: 'filled', color: 'yellow', fontColor: 'red' }), { round: false, width: "45%", textAlign: "center", "data-testid": "rounded-cashback-sticker" }), "CASHBACK"),
            React__default.createElement(StickerWrapper, __assign({}, rest, getVariant({ variant: 'cashback' }), { round: false, textAlign: "center", width: "55%", "data-testid": testid }),
                React__default.createElement(CashbackContentWrapper, null, children))));
    }
    return (React__default.createElement(StickerWrapper, __assign({ "data-testid": testid }, rest, getVariant(props)), children));
};
Sticker.defaultProps = {
    variant: 'outlined',
    color: 'mineShaft',
    testid: 'trolly-sticker',
    fontWeight: 'bold',
    px: 3,
    py: 1,
    round: true,
};

var RadioIcon = function (props) {
    var checked = props.checked, hover = props.hover, disabled = props.disabled;
    var _a = useState(hover), isHover = _a[0], setIsHover = _a[1];
    var _b = useState(checked), isChecked = _b[0], setIsChecked = _b[1];
    var _c = useState(checked), isDisabled = _c[0], setIsDisabled = _c[1];
    useEffect(function () {
        setIsHover(hover);
    }, [hover]);
    useEffect(function () {
        setIsChecked(checked);
    }, [checked]);
    useEffect(function () {
        setIsDisabled(disabled);
    }, [disabled]);
    var animatedProps = useSpring({
        to: function (next, cancel) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(isHover && !isChecked)) return [3 /*break*/, 2];
                        return [4 /*yield*/, next({
                                height: 34,
                                width: 34,
                                opacity: 1,
                                background: 'rgba(14, 90, 167, 0.1)',
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!!isHover) return [3 /*break*/, 4];
                        return [4 /*yield*/, next({
                                height: 0,
                                width: 0,
                                opacity: 0,
                                background: 'rgba(14, 90, 167, 0)',
                            })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!isChecked) return [3 /*break*/, 6];
                        return [4 /*yield*/, next({
                                height: 12,
                                width: 12,
                                opacity: 1,
                                background: 'rgba(14, 90, 167, 1)',
                            })];
                    case 5:
                        _a.sent();
                        cancel();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); },
        from: { scale: 0, height: 0, width: 0, opacity: 0, background: 'rgba(14, 90, 167, 0)' },
        config: config.wobbly,
    });
    var mouseHandles = function (hovering) {
        if (!hovering) {
            return {
                onMouseEnter: function () { return setIsHover(true); },
                onMouseLeave: function () { return setIsHover(false); },
            };
        }
    };
    return (React__default.createElement(RadioIconWrapper, __assign({}, mouseHandles(hover), { checked: isChecked, disabled: isDisabled }),
        React__default.createElement(RadioIconBullet, { style: animatedProps })));
};
var RadioButton = function (props) {
    var wrapper = useRef(null);
    var radio = useRef(null);
    var valueTitle = wrapper.current && wrapper.current.textContent;
    var id = props.id, name = props.name, _a = props.value, value = _a === void 0 ? '' : _a, checked = props.checked, children = props.children, onChange = props.onChange, variant = props.variant, disabled = props.disabled, setTitle = props.setTitle, setChecked = props.setChecked, checkByDefault = props.checkByDefault, noCheckedRadios = props.noCheckedRadios, index = props.index, onClickOpenDrawer = props.onClickOpenDrawer, _b = props.testid, testid = _b === void 0 ? 'trolly-radio-button' : _b, refCallback = props.refCallback, _c = props.page, page = _c === void 0 ? '' : _c;
    if (refCallback) {
        refCallback(wrapper);
    }
    var _d = useState(false), hover = _d[0], setHover = _d[1];
    var onChangeRadioHandle = function (event) {
        event.preventDefault();
        var current = radio.current;
        if (!current || checked) {
            return;
        }
        setTitle(valueTitle);
        setChecked(current.value);
        onChange(__assign(__assign({}, radio), { index: index }));
        onClickOpenDrawer(); // close the radio drawer once clicked
    };
    var onMouseEnterHandle = function () {
        setHover(true);
    };
    var onMouseLeaveHandle = function () {
        setHover(false);
    };
    useEffect(function () {
        if (checked) {
            setTitle(valueTitle);
            setChecked(value);
        }
        if (noCheckedRadios && checkByDefault) {
            setTitle(valueTitle);
            setChecked(value);
        }
    }, [valueTitle, value, noCheckedRadios, checked, checkByDefault, setTitle, setChecked]);
    var isRadio = variant === 'radio';
    return (React__default.createElement(RadioButtonWrapper, { "data-testid": testid + "-wrapper", variant: variant, checked: checked, ref: wrapper, onClick: onChangeRadioHandle, my: [2, 2, 2, 0], mx: 2, onMouseEnter: onMouseEnterHandle, onMouseLeave: onMouseLeaveHandle, page: page },
        isRadio && React__default.createElement(RadioIcon, { hover: hover, checked: checked, disabled: disabled }),
        React__default.createElement(RadioInput, { role: "radio", ref: radio, style: { display: 'none' }, type: "radio", id: id, name: name, value: value, onChange: onChangeRadioHandle, disabled: disabled, checked: checked, "data-testid": testid }),
        React__default.createElement(RadioLabel, { htmlFor: id, isRadio: isRadio }, children)));
};
RadioButton.defaultProps = {
    variant: 'card',
    title: '',
};

var NavbarLink = styled(Flex)(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  line-height: 1;\n  // color: rgb(255, 255, 255);\n  list-style: none;\n  word-wrap: break-word;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  box-sizing: border-box;\n  margin: 0px;\n  min-width: 0px;\n  display: flex;\n  position: relative;\n"], ["\n  line-height: 1;\n  // color: rgb(255, 255, 255);\n  list-style: none;\n  word-wrap: break-word;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  box-sizing: border-box;\n  margin: 0px;\n  min-width: 0px;\n  display: flex;\n  position: relative;\n"])));
var TooltipWrapper = styled(Flex)(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
TooltipWrapper.defaultProps = {
    as: 'div',
};
var DummyChild = styled(Flex)(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject([""], [""])));
var PopupWrapper = styled(animated(Flex))(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  visibility: hidden;\n  flex-direction: column;\n  ", "\n"], ["\n  visibility: hidden;\n  flex-direction: column;\n  ",
    "\n"])), function (props) {
    var tipPosition = props.tipPosition, placement = props.placement, theme = props.theme, tipWidth = props.tipWidth, tipPositionFromRight = props.tipPositionFromRight;
    if (tipPosition) {
        /* other styles will be changed using computeTipStyle method when implementation for tooltip is for other placements */
        return "\n        &::before,&::after {\n        position: absolute;\n        bottom: 100%;\n        border: solid transparent;\n        content: \" \";\n        height: 0;\n        width: 0;\n        pointer-events: none;\n        " + (tipPosition === 'start' ? "left : 46px" : "right: 10px") + ";\n        " + (tipPositionFromRight && "right: " + tipPositionFromRight + "px") + "\n      }\n      &::after {\n        border-" + placement + "-color: " + theme.colors.white + ";\n        border-width: " + tipWidth + "px;\n        margin-left: -15px;\n       " + (placement === 'right' && "top:0px;right:0px;left:-1px") + "\n    ";
    }
});
var templateObject_1$d, templateObject_2$a, templateObject_3$8, templateObject_4$7;

var computePopupStyle = function (placement, parentInfo, popupInfo, tipPosition, placementStyle) {
    var width = parentInfo.width, height = parentInfo.height;
    var popupWidth = popupInfo.width, popupHeight = popupInfo.height;
    var style = __assign({ position: 'absolute', visibility: !popupWidth || !popupHeight ? 'hidden' : 'visible' }, placementStyle);
    var tipAdjustment = 0;
    if (tipPosition) {
        tipAdjustment = 16; /* tip is 16 px fixed for now */
    }
    var bottomPlacementTopPos = height + tipAdjustment;
    switch (placement) {
        case 'left':
            return __assign(__assign({}, style), { left: -(popupWidth + tipAdjustment), top: 0 });
        case 'bottom':
            return __assign(__assign({}, style), { top: bottomPlacementTopPos, right: 0 }); /*when tip is handled then left will be set accordingly */
        case 'top':
            return __assign(__assign({}, style), { left: 0, top: -(popupHeight + tipAdjustment), right: 0 });
        case 'right':
            return __assign(__assign({}, style), { left: width + tipAdjustment, top: 0 });
        case 'bottom-start':
            return __assign(__assign({}, style), { top: bottomPlacementTopPos, left: 0 });
        case 'bottom-end':
            return __assign(__assign({}, style), { top: bottomPlacementTopPos, right: 0 });
        default:
            throw new Error('invalid placement');
    }
};

var Tooltip = function (props) {
    /*
     * Props
     * */
    var _a;
    var children = props.children, _b = props.content, content = _b === void 0 ? 'div' : _b, _c = props.placement, placement = _c === void 0 ? 'bottom' : _c, cardProps = props.cardProps, onStateChange = props.onStateChange, getCurrentStateMethod = props.getCurrentStateMethod, getChangeStateMethod = props.getChangeStateMethod, role = props.role, _d = props.tipPosition, tipPosition = _d === void 0 ? 'end' : _d, popupWrapperStyle = props.popupWrapperStyle, testid = props.testid, stopDefaultOnClick = props.stopDefaultOnClick /* temporary will be removed after popup separation from tooltip */, _e = props.isOnMouseHover, isOnMouseHover = _e === void 0 ? false : _e, _f = props.closeOnScroll, closeOnScroll = _f === void 0 ? false : _f, _g = props.isHoverDropdown, isHoverDropdown = _g === void 0 ? false : _g, _h = props.tipWidth, tipWidth = _h === void 0 ? 10 : _h, tipPositionFromRight = props.tipPositionFromRight, transitionType = props.transitionType;
    var eventType = isHoverDropdown || isOnMouseHover ? 'onMouseEnter' : 'onClick';
    /*
     * Ref
     * */
    var ref = useRef(null);
    var popupRef = useRef(null);
    /*
     * State
     * */
    var _j = useState(false), open = _j[0], setOpen = _j[1];
    var _k = useState({ height: 0, width: 0 }), parentInfo = _k[0], setParentInfo = _k[1];
    var _l = useState({ height: 0, width: 0 }), popupInfo = _l[0], setPopupInfo = _l[1];
    /*
     * Interactions
     * */
    var onOpenHandle = function (value) {
        setOpen(value);
    };
    var onSetParentInfo = function (e) {
        setParentInfo({
            height: e.currentTarget.clientHeight,
            width: e.currentTarget.clientWidth,
        });
    };
    var handleScroll = useCallback(function () {
        if (closeOnScroll && open) {
            var currentScrollPos = window.pageYOffset;
            if (currentScrollPos > 0) {
                setOpen(false);
            }
        }
    }, [closeOnScroll, open]);
    useEffect(function () {
        if (closeOnScroll) {
            window.addEventListener('scroll', handleScroll);
        }
        return function () { return window.removeEventListener('scroll', handleScroll); };
    }, [closeOnScroll, handleScroll]);
    useEffect(function () {
        if (popupRef && popupRef.current) {
            setPopupInfo({ height: popupRef.current.clientHeight, width: popupRef.current.clientWidth });
        }
        if (onStateChange) {
            onStateChange(open);
        }
    }, [open, popupRef, onStateChange]);
    useEffect(function () {
        if (getCurrentStateMethod) {
            getCurrentStateMethod(open);
        }
        if (getChangeStateMethod) {
            getChangeStateMethod(onOpenHandle);
        }
    }, [getChangeStateMethod, getCurrentStateMethod, open]);
    useOnClickOutside(ref, function (e) {
        /* to prevent click on popup to be treated as outside click as ref of parent is binded */
        /* array of ref support can be added to useOnClickOutside method */
        if (popupRef.current && popupRef.current.contains(e.target)) {
            return;
        }
        onOpenHandle(false);
    }, true);
    var element = (_a = {
            ref: ref,
            'data-testid': testid
        },
        _a[eventType] = function (e) {
            if (!stopDefaultOnClick) {
                onSetParentInfo(e);
                onOpenHandle(!open);
            }
            if (children.props.onClick) {
                children.props.onClick(e);
            }
        },
        _a);
    if (isHoverDropdown || isOnMouseHover) {
        element.onMouseLeave = function () {
            onOpenHandle(false);
        };
    }
    var useTransitionParam = {
        from: { opacity: 0, transform: 'translateY(-15%)' },
        enter: { opacity: 1, transform: 'translateY(0%)' },
        leave: { opacity: 0, transform: 'translateY(5%)' },
        config: open ? __assign({}, config.stiff) : { duration: 150 },
    };
    if (transitionType === 'downOut' || transitionType === 'translateZ') {
        useTransitionParam.from = { opacity: 0, transform: 'translateZ(200px) transLateY(40px)' };
        useTransitionParam.enter = { opacity: 1, transform: 'translateZ(-10px) transLateY(0px)' };
        useTransitionParam.leave = { opacity: 0, transform: 'translateZ(0px) transLateY(0px)' };
    }
    var transitions = useTransition(open, null, useTransitionParam);
    var childrenEle = children;
    var popUp = useMemo(function () {
        return transitions.map(function (spring) {
            return (spring.item && (React__default.createElement(PopupWrapper, { "data-popup-testid": testid, style: __assign(__assign(__assign({}, computePopupStyle(placement, parentInfo, popupInfo, tipPosition)), spring.props), popupWrapperStyle), ref: popupRef, role: role, open: open, "aria-label": props['aria-label'], key: spring.key, tipPosition: tipPosition, placement: placement, tipWidth: tipWidth, tipPositionFromRight: tipPositionFromRight },
                React__default.createElement(Card, __assign({ elevation: 2 }, cardProps), content))));
        });
    }, [
        cardProps,
        content,
        open,
        parentInfo,
        placement,
        popupInfo,
        popupWrapperStyle,
        props,
        role,
        testid,
        tipPosition,
        tipPositionFromRight,
        tipWidth,
        transitions,
    ]);
    if (isHoverDropdown) {
        childrenEle = (React__default.createElement("div", null,
            children,
            popUp));
    }
    var parentElm = React__default.cloneElement(childrenEle, element);
    return (React__default.createElement(TooltipWrapper, null,
        parentElm,
        !isHoverDropdown && popUp));
    // return open && ReactDom.createPortal(elm, parentElm);
};

var ImageWrapper = styled.img(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  ", "\n  ", ";\n"], ["\n  ",
    "\n  ", ";\n"])), function (props) { return ({
    width: props.width,
    height: props.height,
}); }, space);
var templateObject_1$e;

var NOT_FOUND = 'data:image/png;base64,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';
var NOT_FOUND_ALT = 'data:image/png;base64,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';

var Image = function (_a) {
    var url = _a.url, name = _a.name, _b = _a.height, height = _b === void 0 ? 'auto' : _b, _c = _a.width, width = _c === void 0 ? '100%' : _c, testId = _a.testId, _d = _a.useAltFallback, useAltFallback = _d === void 0 ? false : _d, onErrorCb = _a.onErrorCb, rest = __rest(_a, ["url", "name", "height", "width", "testId", "useAltFallback", "onErrorCb"]);
    var _e = useState(url), imageUrl = _e[0], setState = _e[1];
    var onErrorHandler = useCallback(function () {
        var fallbackImage = useAltFallback ? NOT_FOUND_ALT : NOT_FOUND;
        setState(fallbackImage);
        if (onErrorCb) {
            onErrorCb();
        }
    }, [onErrorCb, useAltFallback]);
    return (React__default.createElement(ImageWrapper, __assign({ height: height, width: width, src: imageUrl, alt: name, onError: onErrorHandler, "data-testid": testId }, rest)));
};

var NOT_FOUND$1 = 'data:image/png;base64,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';

var LazyImage = function (props) {
    var _a = useState(''), className = _a[0], setClassName = _a[1];
    var onLoad = function () { return setClassName('lazy-image-loaded'); };
    return React__default.createElement(Img, __assign({ placeholder: NOT_FOUND$1, onLoad: onLoad }, props, { className: className }));
};

var Palette = function () {
    var getColors = function () {
        //eslint-disable-next-line autofix/no-unused-vars, unused-imports/no-unused-vars-ts
        var _a = baseTheme.colors, whites = _a.whites, blacks = _a.blacks, colors = __rest(_a, ["whites", "blacks"]);
        var Colors = __assign({}, colors);
        return Object.entries(Colors);
    };
    return (React__default.createElement(Flex, { flexWrap: "wrap" }, getColors().map(function (color) { return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Flex, { bg: color[1], height: 200, width: 200, alignItems: "center", flexDirection: "column", justifyContent: "center" },
            React__default.createElement(Box, { as: "p", fontSize: 5, mb: 2, color: lightOrDark(color[1]) }, color[0]),
            React__default.createElement(Box, { as: "p", fontSize: 4, color: lightOrDark(color[1]) }, color[1])))); })));
};

var alignItem = "\n    align-items: center;\n    display: flex;\n    justify-content: center;\n";
var ImageCircleWrapper = customStyled.div(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  ", ";\n  flex-direction: column;\n  width: ", "px;\n\n  @media (min-width: ", ") {\n    width: ", "px;\n  }\n\n  > a {\n    display: block;\n    outline: 0;\n    width: 100%;\n    text-decoration: none;\n    transition: opacity 0.3s ease 0s;\n\n    &:hover {\n      opacity: 0.75;\n\n      img {\n        transform: scale3d(1.03, 1.03, 1.03);\n      }\n    }\n  }\n"], ["\n  ", ";\n  flex-direction: column;\n  width: ", "px;\n\n  @media (min-width: ", ") {\n    width: ", "px;\n  }\n\n  > a {\n    display: block;\n    outline: 0;\n    width: 100%;\n    text-decoration: none;\n    transition: opacity 0.3s ease 0s;\n\n    &:hover {\n      opacity: 0.75;\n\n      img {\n        transform: scale3d(1.03, 1.03, 1.03);\n      }\n    }\n  }\n"])), alignItem, function (props) { return props.mRadius; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.radius; });
var ImageCircleHolder = customStyled.div(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n    ", ";\n    background-color: ", ";\n    border-radius: 100%;\n    box-sizing: border-box;\n    overflow: hidden;\n    height: ", ";\n    width: 100%;\n\n    > img {\n      max-width: 100%;\n      max-height: 100%;\n      width: auto;\n      height: auto;\n      transition: transform 0.2s ease-in-out 0s;\n    }\n\n    @media (min-width: ", ") {\n      height: ", ";\n    }\n"], ["\n    ", ";\n    background-color: ", ";\n    border-radius: 100%;\n    box-sizing: border-box;\n    overflow: hidden;\n    height: ", ";\n    width: 100%;\n\n    > img {\n      max-width: 100%;\n      max-height: 100%;\n      width: auto;\n      height: auto;\n      transition: transform 0.2s ease-in-out 0s;\n    }\n\n    @media (min-width: ", ") {\n      height: ", ";\n    }\n"])), alignItem, function (props) { return (props.backgroundColor ? props.backgroundColor : props.theme.colors.lightGray); }, function (props) { return props.mRadius; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.radius; });
var ImageCircleTitle = customStyled.div(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n    color: ", ";\n    display: -webkit-box;\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    margin-top: 16px;\n    overflow: hidden;\n    text-align: center;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n\n    @media (min-width: ", ") {\n      font-size: ", "px;\n    }\n\n    ", "\n\n    ", "\n    \n"], ["\n    color: ", ";\n    display: -webkit-box;\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    margin-top: 16px;\n    overflow: hidden;\n    text-align: center;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n\n    @media (min-width: ", ") {\n      font-size: ", "px;\n    }\n\n    ",
    "\n\n    ",
    "\n    \n"])), function (props) { return props.theme.colors.black; }, function (props) { return props.theme.fonts.montserrat; }, function (props) { return props.fontSize; }, function (props) { return props.theme.fontWeights[5]; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.theme.fontSizes[3]; }, function (props) {
    return props.isNewJourney
        ? "\n    font-family: " + props.theme.fonts.montserrat + " !important;\n    font-size: " + props.theme.fontSizes[1] + "px;\n    font-weight: " + props.theme.fontWeights[3] + " !important;\n    line-height: 16px;\n\n    @media (min-width: " + props.theme.breakpoints[1] + ") {\n      font-size: " + props.theme.fontSizes[3] + "px;\n      line-height: 20px;\n    }\n    "
        : '';
}, function (props) { return "\n    @media (max-width: " + props.theme.breakpoints[1] + ") {\n      max-width: 60px;\n    }\n    "; });
var templateObject_1$f, templateObject_2$b, templateObject_3$9;

var ImageCircle = function (_a) {
    var _b = _a.backgroundColor, backgroundColor = _b === void 0 ? '' : _b, imagePath = _a.imagePath, link = _a.link, _c = _a.title, title = _c === void 0 ? '' : _c, _d = _a.testId, testId = _d === void 0 ? '' : _d, onClick = _a.onClick, _e = _a.radius, radius = _e === void 0 ? '125px' : _e, _f = _a.mRadius, mRadius = _f === void 0 ? '85px' : _f, _g = _a.fontSize, fontSize = _g === void 0 ? '12px' : _g, _h = _a.isNewJourney, isNewJourney = _h === void 0 ? false : _h;
    return (React__default.createElement(ImageCircleWrapper, __assign({ radius: radius, mRadius: mRadius }, (testId ? { 'data-testid': testId } : {}), { onClick: onClick }),
        React__default.createElement("a", { href: link },
            React__default.createElement(ImageCircleHolder, { radius: radius, mRadius: mRadius, backgroundColor: backgroundColor },
                React__default.createElement(Image, { url: imagePath, name: title ? title : link })),
            title && (React__default.createElement(ImageCircleTitle, { fontSize: fontSize, "data-testid": "title", isNewJourney: isNewJourney }, title)))));
};

var react_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, '__esModule', { value: true });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function Alignment(params) {
  var viewSize = params.viewSize,
      align = params.align;
  var predefined = {
    start: start,
    center: center,
    end: end
  };
  function start() {
    return 0;
  }
  function center(n) {
    return end(n) / 2;
  }
  function end(n) {
    return viewSize - n;
  }
  function percent() {
    return viewSize * Number(align);
  }
  function measure(n) {
    if (typeof align === 'number') return percent();
    return predefined[align](n);
  }
  var self = {
    measure: measure
  };
  return self;
}
function Animation(callback) {
  var animationFrame = 0;
  function ifAnimating(active, cb) {
    return function () {
      if (active === !!animationFrame) cb();
    };
  }
  function start() {
    animationFrame = window.requestAnimationFrame(callback);
  }
  function stop() {
    window.cancelAnimationFrame(animationFrame);
    animationFrame = 0;
  }
  var self = {
    proceed: ifAnimating(true, start),
    start: ifAnimating(false, start),
    stop: ifAnimating(true, stop)
  };
  return self;
}
function Axis(axis) {
  var scroll = axis === 'y' ? 'y' : 'x';
  var cross = axis === 'y' ? 'x' : 'y';
  function measure(node) {
    var _a = node.getBoundingClientRect(),
        width = _a.width,
        height = _a.height;
    return scroll === 'x' ? width : height;
  }
  var self = {
    cross: cross,
    measure: measure,
    scroll: scroll
  };
  return self;
}
function Counter(params) {
  var start = params.start,
      limit = params.limit,
      loop = params.loop;
  var min = limit.min,
      max = limit.max;
  var type = loop ? 'loop' : 'constrain';
  var withinLimit = limit[type];
  var counter = withinLimit(start);
  function get() {
    return counter;
  }
  function set(n) {
    counter = withinLimit(n);
    return self;
  }
  function add(n) {
    if (n !== 0) {
      var sign = n / Math.abs(n);
      set(get() + sign);
      return add(n + sign * -1);
    }
    return self;
  }
  function clone() {
    return Counter({
      start: get(),
      limit: limit,
      loop: loop
    });
  }
  var self = {
    add: add,
    clone: clone,
    get: get,
    max: max,
    min: min,
    set: set
  };
  return self;
}
function Vector1D(value) {
  var vector = value;
  function get() {
    return vector;
  }
  function set(n) {
    vector = readNumber(n);
    return self;
  }
  function add(n) {
    vector += readNumber(n);
    return self;
  }
  function subtract(n) {
    vector -= readNumber(n);
    return self;
  }
  function multiply(n) {
    vector *= n;
    return self;
  }
  function divide(n) {
    vector /= n;
    return self;
  }
  function normalize() {
    if (vector !== 0) divide(vector);
    return self;
  }
  function readNumber(n) {
    return typeof n === 'number' ? n : n.get();
  }
  var self = {
    add: add,
    divide: divide,
    get: get,
    multiply: multiply,
    normalize: normalize,
    set: set,
    subtract: subtract
  };
  return self;
}
function Direction(value) {
  var direction = Vector1D(normalize(value));
  var get = direction.get;
  function normalize(n) {
    return n === 0 ? 0 : n / Math.abs(n);
  }
  function set(v) {
    var d = normalize(v.get());
    if (d !== 0) direction.set(d);
    return self;
  }
  var self = {
    get: get,
    set: set
  };
  return self;
}
function EventStore() {
  var listeners = [];
  function add(node, type, handler, options) {
    if (options === void 0) {
      options = false;
    }
    node.addEventListener(type, handler, options);
    listeners.push(function () {
      return node.removeEventListener(type, handler, options);
    });
    return self;
  }
  function removeAll() {
    listeners = listeners.filter(function (remove) {
      return remove();
    });
    return self;
  }
  var self = {
    add: add,
    removeAll: removeAll
  };
  return self;
}
function Limit(params) {
  var min = params.min,
      max = params.max;
  var length = Math.abs(min - max);
  function reachedMin(n) {
    return n < min;
  }
  function reachedMax(n) {
    return n > max;
  }
  function reachedAny(n) {
    return reachedMin(n) || reachedMax(n);
  }
  function removeOffset(n) {
    if (min === max) return n;
    while (reachedMin(n)) {
      n += length;
    }
    while (reachedMax(n)) {
      n -= length;
    }
    return n;
  }
  function loop(n) {
    if (!reachedAny(n)) return n;
    return reachedMin(n) ? max : min;
  }
  function constrain(n) {
    if (!reachedAny(n)) return n;
    return reachedMin(n) ? min : max;
  }
  var self = {
    constrain: constrain,
    length: length,
    loop: loop,
    max: max,
    min: min,
    reachedAny: reachedAny,
    reachedMax: reachedMax,
    reachedMin: reachedMin,
    removeOffset: removeOffset
  };
  return self;
}
function DragHandler(params) {
  var target = params.target,
      scrollBody = params.scrollBody,
      dragFree = params.dragFree,
      animation = params.animation,
      axis = params.axis;
  var element = params.element,
      dragTracker = params.dragTracker,
      location = params.location,
      events = params.events,
      limit = params.limit;
  var scrollAxis = axis.scroll,
      crossAxis = axis.cross;
  var focusNodes = ['INPUT', 'SELECT', 'TEXTAREA'];
  var startScroll = Vector1D(0);
  var startCross = Vector1D(0);
  var dragStartPoint = Vector1D(0);
  var activationEvents = EventStore();
  var interactionEvents = EventStore();
  var snapForceBoost = {
    mouse: 2.5,
    touch: 3.5
  };
  var freeForceBoost = {
    mouse: 5,
    touch: 7
  };
  var baseSpeed = dragFree ? 5 : 12;
  var dragThreshold = 4;
  var edgeLimit = Limit({
    min: limit.min - 70,
    max: limit.max + 70
  });
  var pointerIsDown = false;
  var preventScroll = false;
  var preventClick = false;
  var isMouse = false;
  function addActivationEvents() {
    var node = element;
    activationEvents.add(node, 'touchmove', function () {
      return undefined;
    }).add(node, 'touchend', function () {
      return undefined;
    }).add(node, 'touchstart', down).add(node, 'mousedown', down).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click);
  }
  function addInteractionEvents() {
    var node = !isMouse ? element : document;
    interactionEvents.add(node, 'touchmove', move).add(node, 'touchend', up).add(node, 'mousemove', move).add(node, 'mouseup', up);
  }
  function removeAllEvents() {
    activationEvents.removeAll();
    interactionEvents.removeAll();
  }
  function isFocusNode(node) {
    var name = node.nodeName || '';
    return focusNodes.indexOf(name) > -1;
  }
  function forceBoost() {
    var boost = dragFree ? freeForceBoost : snapForceBoost;
    var type = isMouse ? 'mouse' : 'touch';
    return boost[type];
  }
  function speedFactor(forceB, forceA) {
    var diff = delta(Math.abs(forceB), Math.abs(forceA));
    if (Math.abs(forceB) <= Math.abs(forceA)) return 0;
    if (forceB === 0 || forceA === 0) return 0;
    return Math.abs(diff / forceB);
  }
  function allowedForce(force) {
    var scrollTarget = params.scrollTarget,
        index = params.index;
    var currentLocation = scrollTarget.byDistance(0, false);
    var targetChanged = currentLocation.index !== index.get();
    var seekNext = !targetChanged && Math.abs(force) > dragThreshold;
    var destination = force + location.get();
    if (seekNext && !dragFree && !limit.reachedAny(destination)) {
      var next = index.clone().add(Direction(force).get() * -1);
      return scrollTarget.byIndex(next.get(), 0).distance;
    }
    if (!params.loop && edgeLimit.reachedAny(destination)) {
      var edge = edgeLimit.reachedMax(destination) ? 'max' : 'min';
      return edgeLimit[edge] - target.get();
    }
    return scrollTarget.byDistance(force, !dragFree).distance;
  }
  function down(evt) {
    isMouse = evt.type === 'mousedown';
    if (isMouse && evt.button !== 0) return;
    var isMoving = delta(target.get(), location.get()) >= 2;
    var clearPreventClick = isMouse || !isMoving;
    var isNotFocusNode = !isFocusNode(evt.target);
    var preventDefault = isMoving || isMouse && isNotFocusNode;
    pointerIsDown = true;
    dragTracker.pointerDown(evt);
    dragStartPoint.set(target);
    target.set(location);
    scrollBody.useBaseMass().useSpeed(80);
    addInteractionEvents();
    startScroll.set(dragTracker.readPoint(evt, scrollAxis));
    startCross.set(dragTracker.readPoint(evt, crossAxis));
    events.emit('pointerDown');
    if (clearPreventClick) preventClick = false;
    if (preventDefault) evt.preventDefault();
  }
  function move(evt) {
    if (!preventScroll && !isMouse) {
      if (!evt.cancelable) return up();
      var moveScroll = dragTracker.readPoint(evt, scrollAxis).get();
      var moveCross = dragTracker.readPoint(evt, crossAxis).get();
      var diffScroll = delta(moveScroll, startScroll.get());
      var diffCross = delta(moveCross, startCross.get());
      preventScroll = diffScroll > diffCross;
      if (!preventScroll && !preventClick) return up();
    }
    var diff = dragTracker.pointerMove(evt);
    var reachedLimit = limit.reachedAny(location.get());
    var resist = !params.loop && reachedLimit ? 2 : 1;
    if (!preventClick && diff) preventClick = true;
    animation.start();
    target.add(diff / resist);
    evt.preventDefault();
  }
  function up() {
    var scrollTo = params.scrollTo;
    var rawForce = dragTracker.pointerUp() * forceBoost();
    var force = allowedForce(rawForce);
    var factor = speedFactor(rawForce, force);
    var isMoving = delta(target.get(), dragStartPoint.get()) >= 0.5;
    if (isMoving && !isMouse) preventClick = true;
    preventScroll = false;
    pointerIsDown = false;
    interactionEvents.removeAll();
    scrollBody.useSpeed(baseSpeed + baseSpeed * factor);
    scrollTo.distance(force, !dragFree);
    isMouse = false;
    events.emit('pointerUp');
  }
  function delta(pointB, pointA) {
    return Math.abs(pointB - pointA);
  }
  function click(evt) {
    if (preventClick) evt.preventDefault();
  }
  function clickAllowed() {
    return !preventClick;
  }
  function pointerDown() {
    return pointerIsDown;
  }
  var self = {
    addActivationEvents: addActivationEvents,
    clickAllowed: clickAllowed,
    pointerDown: pointerDown,
    removeAllEvents: removeAllEvents
  };
  return self;
}
function DragTracker(params) {
  var axis = params.axis,
      pxToPercent = params.pxToPercent;
  var scrollAxis = axis.scroll;
  var coords = {
    x: 'clientX',
    y: 'clientY'
  };
  var startDrag = Vector1D(0);
  var diffDrag = Vector1D(0);
  var lastDrag = Vector1D(0);
  var pointValue = Vector1D(0);
  var trackInterval = 10;
  var trackLength = 5;
  var trackTime = 100;
  var trackPoints = [];
  var lastMoveTime = new Date().getTime();
  var isMouse = false;
  function readPoint(evt, type) {
    isMouse = !evt.touches;
    var c = coords[type];
    var value = isMouse ? evt[c] : evt.touches[0][c];
    return pointValue.set(value);
  }
  function pointerDown(evt) {
    var point = readPoint(evt, scrollAxis);
    startDrag.set(point);
    lastDrag.set(point);
    return pxToPercent.measure(startDrag.get());
  }
  function pointerMove(evt) {
    var point = readPoint(evt, scrollAxis);
    var nowTime = new Date().getTime();
    var diffTime = nowTime - lastMoveTime;
    if (diffTime >= trackInterval) {
      if (diffTime >= trackTime) trackPoints = [];
      trackPoints.push(point.get());
      lastMoveTime = nowTime;
    }
    diffDrag.set(point).subtract(lastDrag);
    lastDrag.set(point);
    return pxToPercent.measure(diffDrag.get());
  }
  function pointerUp() {
    var nowTime = new Date().getTime();
    var diffTime = nowTime - lastMoveTime;
    var currentPoint = lastDrag.get();
    var force = trackPoints.slice(-trackLength).map(function (trackPoint) {
      return currentPoint - trackPoint;
    }).sort(function (p1, p2) {
      return Math.abs(p1) < Math.abs(p2) ? 1 : -1;
    })[0];
    lastDrag.set(diffTime > trackTime || !force ? 0 : force);
    trackPoints = [];
    return pxToPercent.measure(lastDrag.get());
  }
  var self = {
    pointerDown: pointerDown,
    pointerMove: pointerMove,
    pointerUp: pointerUp,
    readPoint: readPoint
  };
  return self;
}
function PxToPercent(viewInPx) {
  var totalPercent = 100;
  function measure(n) {
    return n / viewInPx * totalPercent;
  }
  var self = {
    measure: measure,
    totalPercent: totalPercent
  };
  return self;
}
function map(value, iStart, iStop, oStart, oStop) {
  return oStart + (oStop - oStart) * ((value - iStart) / (iStop - iStart));
}
function arrayFromCollection(nodeList) {
  return Array.prototype.slice.call(nodeList);
}
function debounce(callback, time) {
  var timeout = {
    id: 0
  };
  return function () {
    window.clearTimeout(timeout.id);
    timeout.id = window.setTimeout(callback, time) || 0;
  };
}
function roundToDecimals(decimalPoints) {
  var pow = Math.pow(10, decimalPoints);
  return function (n) {
    return Math.round(n * pow) / pow;
  };
}
function groupArray(array, size) {
  var groups = [];
  for (var i = 0; i < array.length; i += size) {
    groups.push(array.slice(i, i + size));
  }
  return groups;
}
function arrayKeys(array) {
  return Object.keys(array).map(Number);
}
function removeClass(node, className) {
  var cl = node.classList;
  if (className && cl.contains(className)) cl.remove(className);
}
function addClass(node, className) {
  var cl = node.classList;
  if (className && !cl.contains(className)) cl.add(className);
}
function ScrollBody(params) {
  var location = params.location,
      baseSpeed = params.speed,
      baseMass = params.mass;
  var roundToTwoDecimals = roundToDecimals(2);
  var velocity = Vector1D(0);
  var acceleration = Vector1D(0);
  var attraction = Vector1D(0);
  var direction = Direction(0);
  var speed = baseSpeed;
  var mass = baseMass;
  function update() {
    velocity.add(acceleration);
    location.add(velocity);
    acceleration.multiply(0);
  }
  function applyForce(v) {
    v.divide(mass);
    acceleration.add(v);
  }
  function seek(v) {
    attraction.set(v).subtract(location);
    var magnitude = attraction.get();
    var m = map(magnitude, 0, 100, 0, speed);
    direction.set(attraction);
    attraction.normalize().multiply(m).subtract(velocity);
    applyForce(attraction);
    return self;
  }
  function settle(v) {
    var diff = v.get() - location.get();
    var diffRounded = roundToTwoDecimals(diff);
    var hasSettled = !diffRounded;
    if (hasSettled) location.set(v);
    return hasSettled;
  }
  function useSpeed(n) {
    speed = n;
    return self;
  }
  function useMass(n) {
    mass = n;
    return self;
  }
  function useBaseSpeed() {
    return useSpeed(baseSpeed);
  }
  function useBaseMass() {
    return useMass(baseMass);
  }
  var self = {
    direction: direction,
    seek: seek,
    settle: settle,
    update: update,
    useBaseMass: useBaseMass,
    useBaseSpeed: useBaseSpeed,
    useMass: useMass,
    useSpeed: useSpeed
  };
  return self;
}
function ScrollBounds(params) {
  var limit = params.limit,
      location = params.location,
      scrollBody = params.scrollBody,
      animation = params.animation;
  var min = limit.min,
      max = limit.max,
      reachedMin = limit.reachedMin,
      reachedMax = limit.reachedMax;
  var tolerance = 50;
  var disabled = false;
  var timeout = 0;
  function shouldConstrain(v) {
    if (disabled || timeout) return false;
    if (reachedMin(location.get())) return v.get() !== min;
    if (reachedMax(location.get())) return v.get() !== max;
    return false;
  }
  function constrain(v) {
    if (!shouldConstrain(v)) return;
    timeout = window.setTimeout(function () {
      var constraint = limit.constrain(v.get());
      v.set(constraint);
      scrollBody.useSpeed(10).useMass(3);
      animation.start();
      timeout = 0;
    }, tolerance);
  }
  function toggleActive(active) {
    disabled = !active;
  }
  var self = {
    constrain: constrain,
    toggleActive: toggleActive
  };
  return self;
}
function ScrollContain(params) {
  var alignment = params.alignment,
      contentSize = params.contentSize,
      viewSize = params.viewSize;
  var scrollBounds = Limit({
    min: -contentSize + viewSize,
    max: 0
  });
  var alignedWithinView = [alignment.measure(contentSize)];
  var contentExceedsView = contentSize > viewSize;
  function findDuplicates(scrollSnaps) {
    var startSnap = scrollSnaps[0];
    var endSnap = scrollSnaps[scrollSnaps.length - 1];
    var min = scrollSnaps.lastIndexOf(startSnap) + 1;
    var max = scrollSnaps.indexOf(endSnap);
    return Limit({
      min: min,
      max: max
    });
  }
  function measure(scrollSnaps, trim) {
    var containedSnaps = scrollSnaps.map(scrollBounds.constrain);
    var _a = findDuplicates(containedSnaps),
        min = _a.min,
        max = _a.max;
    if (!contentExceedsView) return alignedWithinView;
    if (!trim) return containedSnaps;
    return containedSnaps.slice(min - 1, max + 1);
  }
  var self = {
    measure: measure
  };
  return self;
}
function ScrollLimit(params) {
  var contentSize = params.contentSize,
      loop = params.loop;
  function measure(scrollSnaps) {
    var startSnap = scrollSnaps[0];
    var endSnap = scrollSnaps[scrollSnaps.length - 1];
    var min = loop ? startSnap - contentSize : endSnap;
    var max = startSnap;
    return Limit({
      min: min,
      max: max
    });
  }
  var self = {
    measure: measure
  };
  return self;
}
function ScrollLooper(params) {
  var contentSize = params.contentSize,
      location = params.location,
      limit = params.limit,
      pxToPercent = params.pxToPercent;
  var min = limit.min + pxToPercent.measure(0.1);
  var max = limit.max + pxToPercent.measure(0.1);
  var _a = Limit({
    min: min,
    max: max
  }),
      reachedMin = _a.reachedMin,
      reachedMax = _a.reachedMax;
  function shouldLoop(direction) {
    if (direction === 1) return reachedMax(location.get());
    if (direction === -1) return reachedMin(location.get());
    return false;
  }
  function loop(vectors, direction) {
    if (!shouldLoop(direction)) return;
    var loopDistance = contentSize * (direction * -1);
    vectors.forEach(function (v) {
      return v.add(loopDistance);
    });
  }
  var self = {
    loop: loop
  };
  return self;
}
function ScrollProgress(params) {
  var _a = params.limit,
      max = _a.max,
      scrollLength = _a.length;
  function get(n) {
    var currentLocation = n - max;
    return currentLocation / -scrollLength;
  }
  var self = {
    get: get
  };
  return self;
}
function ScrollSnap(params) {
  var snapSizes = params.snapSizes,
      alignment = params.alignment,
      loop = params.loop;
  var alignments = snapSizes.map(alignment.measure);
  var distancesBetween = distancesBetweenScrollSnaps();
  function distancesBetweenScrollSnaps() {
    var limit = Limit({
      min: 0,
      max: snapSizes.length - 1
    });
    var counter = Counter({
      limit: limit,
      start: 0,
      loop: loop
    });
    return snapSizes.map(function (size, index) {
      var next = counter.set(index + 1).get();
      return size + alignments[index] - alignments[next];
    });
  }
  function measure(index) {
    var sizes = distancesBetween.slice(0, index);
    return sizes.reduce(function (a, s) {
      return a - s;
    }, alignments[0]);
  }
  var self = {
    measure: measure
  };
  return self;
}
function ScrollTarget(params) {
  var loop = params.loop,
      limit = params.limit,
      scrollSnaps = params.scrollSnaps,
      contentSize = params.contentSize;
  var reachedMax = limit.reachedMax,
      reachedAny = limit.reachedAny,
      removeOffset = limit.removeOffset;
  function minDistance(d1, d2) {
    return Math.abs(d1) < Math.abs(d2) ? d1 : d2;
  }
  function findTargetSnap(target) {
    var distance = removeOffset(target);
    var ascDiffsToSnaps = scrollSnaps.map(function (scrollSnap) {
      return scrollSnap - distance;
    }).map(function (diffToSnap) {
      return shortcut(diffToSnap, 0);
    }).map(function (diff, i) {
      return {
        diff: diff,
        index: i
      };
    }).sort(function (d1, d2) {
      return Math.abs(d1.diff) - Math.abs(d2.diff);
    });
    var index = ascDiffsToSnaps[0].index;
    return {
      index: index,
      distance: distance
    };
  }
  function shortcut(target, direction) {
    var t1 = target;
    var t2 = target + contentSize;
    var t3 = target - contentSize;
    if (!loop) return t1;
    if (!direction) return minDistance(minDistance(t1, t2), t3);
    var shortest = minDistance(t1, direction === 1 ? t2 : t3);
    return Math.abs(shortest) * direction;
  }
  function findTargetIndex(target, index) {
    var reachedBound = !loop && reachedAny(target);
    if (!reachedBound) return index;
    var _a = params.index,
        min = _a.min,
        max = _a.max;
    return reachedMax(target) ? min : max;
  }
  function byIndex(index, direction) {
    var diffToSnap = scrollSnaps[index] - params.target.get();
    var distance = shortcut(diffToSnap, direction);
    return {
      index: index,
      distance: distance
    };
  }
  function byDistance(distance, snap) {
    var target = params.target.get() + distance;
    var targetSnap = findTargetSnap(target);
    var index = findTargetIndex(target, targetSnap.index);
    var reachedBound = !loop && reachedAny(target);
    if (!snap || reachedBound) return {
      index: index,
      distance: distance
    };
    var diffToSnap = scrollSnaps[index] - targetSnap.distance;
    var snapDistance = distance + shortcut(diffToSnap, 0);
    return {
      index: index,
      distance: snapDistance
    };
  }
  var self = {
    byDistance: byDistance,
    byIndex: byIndex,
    shortcut: shortcut
  };
  return self;
}
function ScrollTo(params) {
  var indexCurrent = params.index,
      scrollTarget = params.scrollTarget,
      animation = params.animation;
  var indexPrevious = params.indexPrevious,
      events = params.events,
      targetDistance = params.target;
  function scrollTo(target) {
    var distanceDiff = target.distance;
    var indexDiff = target.index !== indexCurrent.get();
    if (distanceDiff) {
      animation.start();
      targetDistance.add(distanceDiff);
    }
    if (indexDiff) {
      indexPrevious.set(indexCurrent.get());
      indexCurrent.set(target.index);
      events.emit('select');
    }
  }
  function distance(n, snap) {
    var target = scrollTarget.byDistance(n, snap);
    scrollTo(target);
  }
  function index(n, direction) {
    var targetIndex = indexCurrent.clone().set(n);
    var target = scrollTarget.byIndex(targetIndex.get(), direction);
    scrollTo(target);
  }
  var self = {
    distance: distance,
    index: index
  };
  return self;
}
function SlideLooper(params) {
  var axis = params.axis,
      scrollLocation = params.location,
      slidesInView = params.slidesInView;
  var contentSize = params.contentSize,
      viewSize = params.viewSize,
      slideSizes = params.slideSizes,
      scrollSnaps = params.scrollSnaps;
  var ascItems = arrayKeys(slideSizes);
  var descItems = arrayKeys(slideSizes).reverse();
  var loopPoints = startPoints().concat(endPoints());
  var loopStyle = axis.scroll === 'x' ? 'left' : 'top';
  function removeSlideSizes(indexes, from) {
    return indexes.reduce(function (a, i) {
      return a - slideSizes[i];
    }, from);
  }
  function slidesInGap(indexes, gap) {
    return indexes.reduce(function (a, i) {
      var remainingGap = removeSlideSizes(a, gap);
      return remainingGap > 0 ? a.concat([i]) : a;
    }, []);
  }
  function findLoopPoints(indexes, edge) {
    var isStartEdge = edge === 'start';
    var offset = isStartEdge ? -contentSize : contentSize;
    var slideBounds = slidesInView.findSlideBounds(offset);
    return indexes.map(function (index) {
      var initial = isStartEdge ? 0 : -contentSize;
      var altered = isStartEdge ? contentSize : 0;
      var bounds = slideBounds.filter(function (b) {
        return b.index === index;
      })[0];
      var point = bounds[isStartEdge ? 'end' : 'start'];
      var getTarget = function getTarget() {
        return scrollLocation.get() > point ? initial : altered;
      };
      return {
        point: point,
        getTarget: getTarget,
        index: index,
        location: -1
      };
    });
  }
  function startPoints() {
    var gap = scrollSnaps[0] - 1;
    var indexes = slidesInGap(descItems, gap);
    return findLoopPoints(indexes, 'end');
  }
  function endPoints() {
    var gap = viewSize - scrollSnaps[0] - 1;
    var indexes = slidesInGap(ascItems, gap);
    return findLoopPoints(indexes, 'start');
  }
  function canLoop() {
    return loopPoints.every(function (_a) {
      var index = _a.index;
      var otherIndexes = ascItems.filter(function (i) {
        return i !== index;
      });
      return removeSlideSizes(otherIndexes, viewSize) <= 0;
    });
  }
  function loop(slides) {
    loopPoints.forEach(function (loopPoint) {
      var getTarget = loopPoint.getTarget,
          location = loopPoint.location,
          index = loopPoint.index;
      var target = getTarget();
      if (target !== location) {
        slides[index].style[loopStyle] = target + "%";
        loopPoint.location = target;
      }
    });
  }
  function clear(slides) {
    loopPoints.forEach(function (_a) {
      var index = _a.index;
      slides[index].style[loopStyle] = '';
    });
  }
  var self = {
    canLoop: canLoop,
    clear: clear,
    loop: loop,
    loopPoints: loopPoints
  };
  return self;
}
function SlideFocus(params) {
  var scrollTo = params.scrollTo,
      slidesToScroll = params.slidesToScroll,
      root = params.root;
  var eventStore = EventStore();
  var removeAllEvents = eventStore.removeAll;
  var lastTabPressTime = 0;
  function registerTabPress(event) {
    if (event.keyCode !== 9) return;
    lastTabPressTime = new Date().getTime();
  }
  function addFocusEvent(slide, index) {
    var focus = function focus() {
      var nowTime = new Date().getTime();
      var diffTime = nowTime - lastTabPressTime;
      if (diffTime > 10) return;
      root.scrollLeft = 0;
      var selectedIndex = Math.floor(index / slidesToScroll);
      scrollTo.index(selectedIndex, 0);
    };
    eventStore.add(slide, 'focus', focus, true);
  }
  function addActivationEvents(slides) {
    eventStore.add(document, 'keydown', registerTabPress, false);
    slides.forEach(addFocusEvent);
  }
  var self = {
    addActivationEvents: addActivationEvents,
    removeAllEvents: removeAllEvents
  };
  return self;
}
function SlidesInView(params) {
  var contentSize = params.contentSize,
      slideSizes = params.slideSizes,
      viewSize = params.viewSize;
  var inViewThreshold = params.inViewThreshold,
      loop = params.loop;
  var threshold = Math.min(Math.max(inViewThreshold, 0.01), 0.99);
  var scrollSnaps = arrayKeys(slideSizes).map(scrollSnap);
  var offsets = loop ? [0, contentSize, -contentSize] : [0];
  var slideBounds = offsets.reduce(function (a, loopOffset) {
    return a.concat(findSlideBounds(loopOffset, threshold));
  }, []);
  function scrollSnap(index) {
    var span = slideSizes.slice(0, index);
    return span.reduce(function (a, s) {
      return a - s;
    }, 0);
  }
  function findSlideBounds(offset, threshold) {
    var thresholds = slideSizes.map(function (s) {
      return s * (threshold || 0);
    });
    return scrollSnaps.map(function (snap, index) {
      return {
        start: snap - slideSizes[index] + thresholds[index] + offset,
        end: snap + viewSize - thresholds[index] + offset,
        index: index
      };
    });
  }
  function check(location) {
    return slideBounds.reduce(function (list, slideBound) {
      var index = slideBound.index,
          start = slideBound.start,
          end = slideBound.end;
      var inList = list.indexOf(index) !== -1;
      var inView = start < location && end > location;
      return !inList && inView ? list.concat([index]) : list;
    }, []);
  }
  var self = {
    check: check,
    findSlideBounds: findSlideBounds
  };
  return self;
}
function Translate(params) {
  var axis = params.axis,
      container = params.container;
  var translates = {
    x: x,
    y: y
  };
  var translateAxis = translates[axis.scroll];
  var roundToTwoDecimals = roundToDecimals(2);
  var containerStyle = container.style;
  var disabled = false;
  var location = 0;
  function x(n) {
    return "translate3d(" + n + "%,0px,0px)";
  }
  function y(n) {
    return "translate3d(0px," + n + "%,0px)";
  }
  function to(v) {
    if (disabled) return;
    var target = roundToTwoDecimals(v.get());
    if (location !== target) {
      getComputedStyle(container).transform;
      containerStyle.transform = translateAxis(target);
      location = target;
    }
  }
  function toggleActive(active) {
    disabled = !active;
  }
  function clear() {
    containerStyle.transform = '';
    location = 0;
  }
  var self = {
    clear: clear,
    to: to,
    toggleActive: toggleActive
  };
  return self;
}
function Engine(root, container, slides, options, events) {
  var align = options.align,
      scrollAxis = options.axis,
      startIndex = options.startIndex,
      inViewThreshold = options.inViewThreshold,
      loop = options.loop,
      speed = options.speed,
      dragFree = options.dragFree,
      slidesToScroll = options.slidesToScroll,
      containScroll = options.containScroll;
  var axis = Axis(scrollAxis);
  var pxToPercent = PxToPercent(axis.measure(container));
  var viewSize = pxToPercent.totalPercent;
  var slideSizes = slides.map(axis.measure).map(pxToPercent.measure);
  var slideIndexes = arrayKeys(slideSizes);
  var groupedSizes = groupArray(slideSizes, slidesToScroll);
  var snapSizes = groupedSizes.map(function (g) {
    return g.reduce(function (a, s) {
      return a + s;
    });
  });
  var contentSize = slideSizes.reduce(function (a, s) {
    return a + s;
  }, 0);
  var alignment = Alignment({
    align: align,
    viewSize: viewSize
  });
  var scrollSnap = ScrollSnap({
    snapSizes: snapSizes,
    alignment: alignment,
    loop: loop
  });
  var defaultSnaps = arrayKeys(snapSizes).map(scrollSnap.measure);
  var contain = ScrollContain({
    alignment: alignment,
    contentSize: contentSize,
    viewSize: viewSize
  });
  var shouldContain = !loop && containScroll !== '';
  var trimSnaps = containScroll === 'trimSnaps';
  var containedSnaps = contain.measure(defaultSnaps, trimSnaps);
  var scrollSnaps = shouldContain ? containedSnaps : defaultSnaps;
  var indexMax = Math.max(0, scrollSnaps.length - 1);
  var indexSpan = Limit({
    min: 0,
    max: indexMax
  });
  var index = Counter({
    limit: indexSpan,
    start: startIndex,
    loop: loop
  });
  var indexPrevious = index.clone();
  var scrollLimit = ScrollLimit({
    loop: loop,
    contentSize: contentSize
  });
  var limit = scrollLimit.measure(scrollSnaps);
  var update = function update() {
    engine.scrollBody.seek(target).update();
    var settled = engine.scrollBody.settle(target);
    if (!dragHandler.pointerDown()) {
      if (!loop) engine.scrollBounds.constrain(target);
      if (settled) {
        engine.animation.stop();
        events.emit('settle');
      }
    }
    if (loop) {
      var direction = engine.scrollBody.direction.get();
      engine.scrollLooper.loop(loopVectors, direction);
      engine.slideLooper.loop(slides);
    }
    if (!settled) events.emit('scroll');
    engine.translate.to(location);
    engine.animation.proceed();
  };
  var animation = Animation(update);
  var startLocation = scrollSnaps[index.get()];
  var location = Vector1D(startLocation);
  var target = Vector1D(startLocation);
  var loopVectors = [location, target];
  var scrollBody = ScrollBody({
    location: location,
    speed: speed,
    mass: 1
  });
  var scrollTarget = ScrollTarget({
    contentSize: contentSize,
    index: index,
    limit: limit,
    loop: loop,
    scrollSnaps: scrollSnaps,
    target: target
  });
  var scrollTo = ScrollTo({
    animation: animation,
    events: events,
    index: index,
    indexPrevious: indexPrevious,
    scrollTarget: scrollTarget,
    target: target
  });
  var slidesInView = SlidesInView({
    contentSize: contentSize,
    inViewThreshold: inViewThreshold,
    loop: loop,
    slideSizes: slideSizes,
    viewSize: viewSize
  });
  var dragHandler = DragHandler({
    animation: animation,
    axis: axis,
    dragFree: dragFree,
    dragTracker: DragTracker({
      axis: axis,
      pxToPercent: pxToPercent
    }),
    element: root,
    events: events,
    index: index,
    limit: limit,
    location: location,
    loop: loop,
    scrollBody: scrollBody,
    scrollTo: scrollTo,
    scrollTarget: scrollTarget,
    target: target
  });
  var engine = {
    animation: animation,
    axis: axis,
    dragHandler: dragHandler,
    pxToPercent: pxToPercent,
    index: index,
    indexPrevious: indexPrevious,
    limit: limit,
    location: location,
    options: options,
    scrollBody: scrollBody,
    scrollBounds: ScrollBounds({
      animation: animation,
      limit: limit,
      location: location,
      scrollBody: scrollBody
    }),
    scrollLooper: ScrollLooper({
      contentSize: contentSize,
      limit: limit,
      location: location,
      pxToPercent: pxToPercent
    }),
    scrollProgress: ScrollProgress({
      limit: limit
    }),
    scrollSnaps: scrollSnaps,
    scrollTarget: scrollTarget,
    scrollTo: scrollTo,
    slideFocus: SlideFocus({
      root: root,
      scrollTo: scrollTo,
      slidesToScroll: slidesToScroll
    }),
    slideLooper: SlideLooper({
      axis: axis,
      contentSize: contentSize,
      location: location,
      scrollSnaps: scrollSnaps,
      slideSizes: slideSizes,
      slidesInView: slidesInView,
      viewSize: viewSize
    }),
    slidesInView: slidesInView,
    slideIndexes: slideIndexes,
    target: target,
    translate: Translate({
      axis: axis,
      container: container
    })
  };
  return engine;
}
function EventEmitter() {
  var listeners = {
    destroy: [],
    pointerDown: [],
    pointerUp: [],
    init: [],
    reInit: [],
    resize: [],
    scroll: [],
    select: [],
    settle: []
  };
  function emit(evt) {
    listeners[evt].forEach(function (e) {
      return e(evt);
    });
    return self;
  }
  function on(evt, cb) {
    listeners[evt] = listeners[evt].concat([cb]);
    return self;
  }
  function off(evt, cb) {
    listeners[evt] = listeners[evt].filter(function (e) {
      return e !== cb;
    });
    return self;
  }
  var self = {
    emit: emit,
    off: off,
    on: on
  };
  return self;
}
var defaultOptions = {
  align: 'center',
  axis: 'x',
  containScroll: '',
  containerSelector: '*',
  dragFree: false,
  draggable: true,
  draggableClass: 'is-draggable',
  draggingClass: 'is-dragging',
  inViewThreshold: 0,
  loop: false,
  selectedClass: 'is-selected',
  slidesToScroll: 1,
  speed: 10,
  startIndex: 0
};
function EmblaCarousel(sliderRoot, userOptions) {
  var events = EventEmitter();
  var eventStore = EventStore();
  var debouncedResize = debounce(resize, 500);
  var reInit = reActivate;
  var on = events.on,
      off = events.off;
  var engine;
  var activated = false;
  var options = _extends({}, defaultOptions);
  var rootElementSize = 0;
  var container;
  var slides;
  activate(userOptions);
  function storeElements() {
    if (!sliderRoot) throw new Error('Missing root node 😢');
    var selector = options.containerSelector;
    var sliderContainer = sliderRoot.querySelector(selector);
    if (!sliderContainer) throw new Error('Missing container node 😢');
    container = sliderContainer;
    slides = arrayFromCollection(container.children);
  }
  function activate(partialOptions) {
    storeElements();
    options = _extends(options, partialOptions);
    engine = Engine(sliderRoot, container, slides, options, events);
    rootElementSize = engine.axis.measure(sliderRoot);
    eventStore.add(window, 'resize', debouncedResize);
    engine.translate.to(engine.location);
    if (options.loop) {
      if (!engine.slideLooper.canLoop()) {
        deActivate();
        return activate({
          loop: false
        });
      }
      engine.slideLooper.loop(slides);
    }
    if (options.draggable && slides.length) {
      engine.dragHandler.addActivationEvents();
      if (options.draggableClass) {
        addClass(sliderRoot, options.draggableClass);
      }
      if (options.draggingClass) {
        events.on('pointerDown', toggleDraggingClass).on('pointerUp', toggleDraggingClass);
      }
    }
    if (slides.length) {
      engine.slideFocus.addActivationEvents(slides);
    }
    if (options.selectedClass) {
      toggleSelectedClass();
      events.on('select', toggleSelectedClass).on('pointerUp', toggleSelectedClass);
    }
    if (!activated) {
      setTimeout(function () {
        return events.emit('init');
      }, 0);
      activated = true;
    }
  }
  function toggleDraggingClass(evt) {
    var draggingClass = options.draggingClass;
    if (evt === 'pointerDown') addClass(sliderRoot, draggingClass);else removeClass(sliderRoot, draggingClass);
  }
  function toggleSelectedClass() {
    var selectedClass = options.selectedClass;
    var inView = slidesInView(true);
    var notInView = slidesNotInView(true);
    notInView.forEach(function (i) {
      return removeClass(slides[i], selectedClass);
    });
    inView.forEach(function (i) {
      return addClass(slides[i], selectedClass);
    });
  }
  function deActivate() {
    engine.dragHandler.removeAllEvents();
    engine.slideFocus.removeAllEvents();
    engine.animation.stop();
    eventStore.removeAll();
    engine.translate.clear();
    engine.slideLooper.clear(slides);
    removeClass(sliderRoot, options.draggableClass);
    slides.forEach(function (s) {
      return removeClass(s, options.selectedClass);
    });
    events.off('select', toggleSelectedClass);
    events.off('pointerUp', toggleSelectedClass);
    events.off('pointerDown', toggleDraggingClass);
    events.off('pointerUp', toggleDraggingClass);
  }
  function reActivate(partialOptions) {
    if (!activated) return;
    var startIndex = selectedScrollSnap();
    var newOptions = _extends({
      startIndex: startIndex
    }, partialOptions);
    deActivate();
    activate(newOptions);
    events.emit('reInit');
  }
  function destroy() {
    if (!activated) return;
    deActivate();
    activated = false;
    events.emit('destroy');
  }
  function resize() {
    if (!activated) return;
    var newRootElementSize = engine.axis.measure(sliderRoot);
    if (rootElementSize !== newRootElementSize) reActivate();
    events.emit('resize');
  }
  function slidesInView(target) {
    var location = engine[target ? 'target' : 'location'].get();
    var type = options.loop ? 'removeOffset' : 'constrain';
    return engine.slidesInView.check(engine.limit[type](location));
  }
  function slidesNotInView(target) {
    var inView = slidesInView(target);
    return engine.slideIndexes.filter(function (i) {
      return inView.indexOf(i) === -1;
    });
  }
  function scrollTo(index, direction) {
    engine.scrollBody.useBaseMass().useBaseSpeed();
    if (activated) engine.scrollTo.index(index, direction || 0);
  }
  function scrollNext() {
    var next = engine.index.clone().add(1);
    scrollTo(next.get(), -1);
  }
  function scrollPrev() {
    var prev = engine.index.clone().add(-1);
    scrollTo(prev.get(), 1);
  }
  function canScrollNext() {
    var next = engine.index.clone().add(1);
    return next.get() !== selectedScrollSnap();
  }
  function canScrollPrev() {
    var prev = engine.index.clone().add(-1);
    return prev.get() !== selectedScrollSnap();
  }
  function scrollSnapList() {
    return engine.scrollSnaps.map(engine.scrollProgress.get);
  }
  function scrollProgress() {
    return engine.scrollProgress.get(engine.location.get());
  }
  function selectedScrollSnap() {
    return engine.index.get();
  }
  function previousScrollSnap() {
    return engine.indexPrevious.get();
  }
  function clickAllowed() {
    return engine.dragHandler.clickAllowed();
  }
  function dangerouslyGetEngine() {
    return engine;
  }
  function containerNode() {
    return container;
  }
  function slideNodes() {
    return slides;
  }
  var self = {
    canScrollNext: canScrollNext,
    canScrollPrev: canScrollPrev,
    clickAllowed: clickAllowed,
    containerNode: containerNode,
    dangerouslyGetEngine: dangerouslyGetEngine,
    destroy: destroy,
    off: off,
    on: on,
    previousScrollSnap: previousScrollSnap,
    reInit: reInit,
    scrollNext: scrollNext,
    scrollPrev: scrollPrev,
    scrollProgress: scrollProgress,
    scrollSnapList: scrollSnapList,
    scrollTo: scrollTo,
    selectedScrollSnap: selectedScrollSnap,
    slideNodes: slideNodes,
    slidesInView: slidesInView,
    slidesNotInView: slidesNotInView
  };
  return self;
}
function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
function areEqualShallow(objectA, objectB) {
  return Object.keys(objectA).length === Object.keys(objectB).length && Object.keys(objectA).every(function (objectKey) {
    if (!objectB.hasOwnProperty(objectKey)) return false;
    return objectA[objectKey] === objectB[objectKey];
  });
}
function useEmblaCarousel(options) {
  if (options === void 0) {
    options = {};
  }
  var _a = React__default.useState(),
      embla = _a[0],
      setEmbla = _a[1];
  var _b = React__default.useState(),
      viewport = _b[0],
      setViewport = _b[1];
  var storedOptions = React__default.useRef(options);
  var activeOptions = React__default.useMemo(function () {
    if (!areEqualShallow(storedOptions.current, options)) {
      storedOptions.current = options;
    }
    return storedOptions.current;
  }, [storedOptions, options]);
  React__default.useEffect(function () {
    if (canUseDOM() && viewport) {
      var newEmbla_1 = EmblaCarousel(viewport, activeOptions);
      setEmbla(newEmbla_1);
      return function () {
        return newEmbla_1.destroy();
      };
    } else {
      setEmbla(undefined);
    }
  }, [viewport, activeOptions, setEmbla]);
  return [setViewport, embla];
}
exports.useEmblaCarousel = useEmblaCarousel;
});
unwrapExports(react_1);
var react_2 = react_1.useEmblaCarousel;

var SLIM_BANNER = 'slim-hero-banner';
var CarouselWrapper = customStyled.div(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n    /* @noflip */\n    direction: ltr;\n    position: relative;\n    width: 100%;\n    ", ";\n"], ["\n    /* @noflip */\n    direction: ltr;\n    position: relative;\n    width: 100%;\n    ", ";\n"])), space);
var CarouselInnerWrapper = customStyled.div(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
var CarouselViewport = customStyled.div(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n    overflow: hidden;\n\n    ", ";\n   \n\n    &.is-draggable {\n      cursor: move;\n      cursor: grab;\n    }\n\n    &.is-dragging {\n      cursor: grabbing;\n    }\n"], ["\n    overflow: hidden;\n\n    ",
    ";\n   \n\n    &.is-draggable {\n      cursor: move;\n      cursor: grab;\n    }\n\n    &.is-dragging {\n      cursor: grabbing;\n    }\n"])), function (props) {
    return props.arrowGap
        ? " width: 96%;\n    margin: 0 auto;"
        : "";
});
var CarouselContainer = customStyled(Flex)(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n    display: flex;\n    user-select: none;\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -webkit-tap-highlight-color: transparent;\n    will-change: transform;\n    \n    ", "\n"], ["\n    display: flex;\n    user-select: none;\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -webkit-tap-highlight-color: transparent;\n    will-change: transform;\n    \n    ",
    "\n"])), function (props) {
    return !props.loop
        ? props.rtl
            ? "\n        > div:first-of-type {\n            padding-right: 0;\n        }\n    \n        > div:last-of-type {\n            padding-left: 0;\n        }\n    "
            : "\n            > div:first-of-type {\n                padding-left: 0;\n            }\n        \n            > div:last-of-type {\n                padding-right: 0;\n            }\n        "
        : '';
});
var StyledButtonArrowWrapper = customStyled.div(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n"], ["\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n"])));
var StyledButton = customStyled(Button)(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n    align-items: center; \n    padding: 0;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: box-shadow 0.25s ease, border-color 0.25s ease;\n    z-index: 1;\n\n    svg {\n        transition: stroke 0.25s ease;\n\n        path:first-of-type {\n            stroke: ", ";\n        }\n    }\n\n    &:hover {\n        background-color: ", ";\n        \n        &:not([disabled]) {\n          box-shadow: ", ";\n        }\n    }\n\n    &[disabled] {\n        border-color: ", ";\n        cursor: not-allowed;\n        visibility: ", ";\n        svg path:first-of-type {\n            stroke: ", ";\n            \n        }\n        ", "\n    }\n\n    ", "\n"], ["\n    align-items: center; \n    padding: 0;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: box-shadow 0.25s ease, border-color 0.25s ease;\n    z-index: 1;\n\n    svg {\n        transition: stroke 0.25s ease;\n\n        path:first-of-type {\n            stroke: ", ";\n        }\n    }\n\n    &:hover {\n        background-color: ", ";\n        \n        &:not([disabled]) {\n          box-shadow: ",
    ";\n        }\n    }\n\n    &[disabled] {\n        border-color: ", ";\n        cursor: not-allowed;\n        visibility: ", ";\n        svg path:first-of-type {\n            stroke: ",
    ";\n            \n        }\n        ", "\n    }\n\n    ",
    "\n"])), function (props) { return (props.arrowType !== 'hero' ? props.theme.colors.copy : props.theme.colors.white); }, function (props) { return (props.arrowType !== 'hero' ? props.theme.colors.white : 'transparent'); }, function (props) {
    return props.arrowType !== 'hero'
        ? 'rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px'
        : 'none';
}, function (props) { return props.theme.colors.silverChalice; }, function (props) { return (props.arrowType !== 'solid' ? 'visible' : 'hidden'); }, function (props) {
    return props.arrowType !== 'hero' ? props.theme.colors.silverChalice : props.theme.colors.copy;
}, function (props) { return (props.arrowType === 'compact' ? 'display: none' : ''); }, function (props) {
    return variant({
        prop: 'arrowType',
        variants: {
            hero: {
                backgroundColor: 'transparent',
                height: 48,
                width: 48,
                svg: {
                    color: 'white',
                    height: 38,
                    width: 38,
                },
            },
            mini: {
                backgroundColor: 'white',
                border: "1px solid " + props.theme.colors.thundora,
                borderRadius: props.isNewButton ? (props.position === 'prev' ? '0 4px 4px 0' : '0 4px 0 4px') : 33,
                height: props.isNewButton ? 64 : 33,
                width: props.isNewButton ? 27 : 33,
                svg: {
                    height: 16,
                    width: 16,
                },
            },
            regular: {
                backgroundColor: 'white',
                border: "1px solid " + props.theme.colors.thundora,
                borderRadius: props.isNewButton ? (props.position === 'prev' ? '0 4px 4px 0' : '4px 0px 0px 4px') : 48,
                height: props.isNewButton ? 64 : 48,
                width: props.isNewButton ? 27 : 48,
                svg: {
                    height: 24,
                    width: 24,
                },
            },
            solid: {
                backgroundColor: 'white',
                boxShadow: '0px 0px 3px -2px rgba(0, 0, 0, 0.25)',
                height: 64,
                width: 27,
                svg: {
                    height: 20,
                    width: 16,
                    overflow: 'visible',
                    path: {
                        strokeWidth: 3,
                        strokeLinecap: 'round',
                    },
                },
            },
            compact: {
                backgroundColor: 'white',
                border: "1px solid " + props.theme.colors.antiFlash,
                boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.1)",
                borderRadius: 33,
                height: 24,
                width: 24,
                svg: {
                    height: 12,
                    width: 12,
                },
            },
        },
    });
});
var StyledButtonLeft = customStyled(StyledButton)(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n    svg {\n        /* @noflip */\n        position: relative;\n        transform: rotate(180deg);\n        ", "\n    }\n    ", "\n\n    /* @noflip */\n    ", "\n"], ["\n    svg {\n        /* @noflip */\n        position: relative;\n        transform: rotate(180deg);\n        ",
    "\n    }\n    ",
    "\n\n    /* @noflip */\n    ",
    "\n"])), function (props) {
    return !props.isNewButton &&
        "\n          left: 4px;\n          top: -1px;\n          transform: rotate(90deg);\n        ";
}, function (props) {
    return props.isNewButton &&
        "\n      border-left: 0;\n    ";
}, function (props) {
    return variant({
        prop: 'arrowType',
        variants: {
            hero: {
                left: props.theme.space[3],
            },
            mini: {
                left: props.isNewButton ? 0 : -props.theme.space[3],
            },
            regular: {
                left: props.isNewButton ? 0 : -props.theme.space[4],
            },
            solid: {
                left: props.theme.space[0],
                svg: {
                    left: '2px',
                },
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
            },
            compact: {
                left: -props.theme.space[3],
                svg: {
                    left: '2px',
                },
            },
        },
    });
});
var StyledButtonRight = customStyled(StyledButton)(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n    svg {\n        position: relative;\n        /* @noflip */\n        ", "\n    }\n    ", "\n\n    /* @noflip */\n    ", "\n"], ["\n    svg {\n        position: relative;\n        /* @noflip */\n        ",
    "\n    }\n    ",
    "\n\n    /* @noflip */\n    ",
    "\n"])), function (props) {
    return !props.isNewButton &&
        "\n          right: 4px;\n          top: " + (props.arrowType === 'mini' ? 0 : '1px') + ";\n          transform: rotate(-90deg);\n        ";
}, function (props) {
    return props.isNewButton &&
        "\n      border-right: 0;\n    ";
}, function (props) {
    return variant({
        prop: 'arrowType',
        variants: {
            hero: {
                right: props.theme.space[3],
            },
            mini: {
                right: props.isNewButton ? 0 : -props.theme.space[3],
            },
            regular: {
                right: props.isNewButton ? 0 : -props.theme.space[4],
            },
            solid: {
                right: props.theme.space[0],
                svg: {
                    right: '2px',
                },
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
            },
            compact: {
                right: -props.theme.space[3],
                svg: {
                    right: '2px',
                },
            },
        },
    });
});
var CarouselNavWrapper = customStyled(Flex)(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  margin: ", "px 0;\n  justify-content: center;\n  ", "\n"], ["\n  margin: ", "px 0;\n  justify-content: center;\n  ",
    "\n"])), function (props) { return props.theme.space[3]; }, function (props) {
    return props.bannerType === SLIM_BANNER
        ? "\n      position: absolute;\n      bottom: 12px;\n      left: 50%;\n      transform: translateX(-50%);\n      margin: 0;\n  "
        : '';
});
var StyledNavButton = customStyled.button(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n    align-items: center;\n    cursor: pointer;\n    display: flex;\n\n    ", "\n\n    ", "\n"], ["\n    align-items: center;\n    cursor: pointer;\n    display: flex;\n\n    ",
    "\n\n    ",
    "\n"])), function (props) {
    return variant({
        variants: {
            circles: {
                backgroundColor: props.selected ? props.theme.colors.alto : 'white',
                border: "1px solid " + props.theme.colors.silverChalice,
                borderRadius: props.theme.width[0] + "px",
                height: props.theme.heights[0] + "px",
                margin: "0 " + props.theme.space[2] + "px",
                width: props.theme.width[0] + "px",
            },
            flat: {
                backgroundColor: props.selected ? '#7FBFF6' : '#EBF0F3',
                border: '1px solid transparent',
                borderRadius: props.theme.width[0] + "px",
                height: [4, null, 6, null],
                margin: "0 3px",
                width: [26, null, 40, null],
            },
        },
    });
}, function (props) {
    return props.bannerType === SLIM_BANNER
        ? "\n      background: " + props.theme.colors.white + " !important;\n      margin: 0 4px !important;\n      height: 4px !important;\n\n      @media (min-width: " + props.theme.breakpoints[2] + ") {\n        margin: 0 6px !important;\n        height: 6px !important;\n      }\n\n      " + (props.selected
            ? "\n        width: 14px !important;\n        border-radius: 100px !important;\n\n        @media (min-width: " + props.theme.breakpoints[2] + ") {\n          width: 20px !important;\n        }\n      "
            : "\n        width: 4px !important;\n        border-radius: 50% !important;\n\n        @media (min-width: " + props.theme.breakpoints[2] + ") {\n          width: 6px !important;\n        }\n      ") + "\n    "
        : '';
});
var templateObject_1$g, templateObject_2$c, templateObject_3$a, templateObject_4$8, templateObject_5$5, templateObject_6$4, templateObject_7$3, templateObject_8$3, templateObject_9$1, templateObject_10$1;

var arrowSvg = function () { return (React__default.createElement(StyledButtonArrowWrapper, null,
    React__default.createElement(ArrowDown$1, { size: "M" }))); };
var arrowSvgNew = function () { return (React__default.createElement(StyledButtonArrowWrapper, null,
    React__default.createElement(ArrowDark, { size: "CUSTOM", height: "19px", width: "11px" }))); };
var BottomNavigation = function (props) { return React__default.createElement(StyledNavButton, __assign({}, props)); };
var PrevButton = function (_a) {
    var isNewButton = _a.isNewButton, props = __rest(_a, ["isNewButton"]);
    return (React__default.createElement(StyledButtonLeft, __assign({ className: "prev-button", testid: "prev-button", disabled: !props.enabled, isNewButton: isNewButton }, props), isNewButton ? arrowSvgNew() : arrowSvg()));
};
var NextButton = function (_a) {
    var isNewButton = _a.isNewButton, props = __rest(_a, ["isNewButton"]);
    return (React__default.createElement(StyledButtonRight, __assign({ className: "next-button", testid: "next-button", disabled: !props.enabled, isNewButton: isNewButton }, props), isNewButton ? arrowSvgNew() : arrowSvg()));
};

var useRecursiveTimeout = function (callback, delay) {
    var _a = useState(false), isRunning = _a[0], setIsRunning = _a[1];
    var _b = useState(false), isPaused = _b[0], setIsPaused = _b[1];
    var pause = useCallback(function () {
        setIsPaused(true);
        setIsRunning(false);
    }, [setIsPaused]);
    var restart = useCallback(function () {
        setTimeout(function () {
            setIsPaused(false);
            setIsRunning(true);
        }, 100);
    }, [setIsPaused, setIsRunning]);
    var stop = useCallback(function () { return setIsRunning(false); }, [setIsRunning]);
    var play = useCallback(function () { return setIsRunning(true); }, [setIsRunning]);
    var savedCallback = useRef(callback);
    useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(function () {
        var id = 0;
        if (isPaused)
            return clearTimeout(id);
        if (!isRunning)
            return;
        var tick = function () {
            if (!isRunning)
                return clearTimeout(id);
            savedCallback.current();
            requestAnimationFrame(function () { return (id = setTimeout(tick, delay)); });
        };
        requestAnimationFrame(function () { return (id = setTimeout(tick, delay)); });
        return function () {
            if (id)
                clearTimeout(id);
            stop();
        };
    }, [isRunning, delay, stop, isPaused]);
    return { play: play, stop: stop, pause: pause, restart: restart };
};

var defaultOptions$1 = {
    align: 'start',
    draggable: false,
    loop: false,
    containScroll: 'trimSnaps',
};
var Carousel = function (props) {
    var arrows = props.arrows, _a = props.autoPlay, autoPlay = _a === void 0 ? false : _a, _b = props.options, options = _b === void 0 ? {} : _b, children = props.children, _c = props.bottomNav, bottomNav = _c === void 0 ? '' : _c, hideNavMaxWidth = props.hideNavMaxWidth, _d = props.hideNavType, hideNavType = _d === void 0 ? 'both' : _d, onAfterChange = props.onAfterChange, _e = props.rtl, rtl = _e === void 0 ? false : _e, onSlideEnd = props.onSlideEnd, _f = props.arrowGap, arrowGap = _f === void 0 ? false : _f, _g = props.isNewButton, isNewButton = _g === void 0 ? false : _g, _h = props.className, className = _h === void 0 ? '' : _h, _j = props.stopOnMouseEnter, stopOnMouseEnter = _j === void 0 ? false : _j, _k = props.isSSRNav, isSSRNav = _k === void 0 ? false : _k, bannerType = props.bannerType;
    var _l = react_2(__assign(__assign({}, defaultOptions$1), { draggable: false })), viewportRef = _l[0], embla = _l[1];
    var _m = useState(false), prevBtnEnabled = _m[0], setPrevBtnEnabled = _m[1];
    var _o = useState(false), nextBtnEnabled = _o[0], setNextBtnEnabled = _o[1];
    var _p = useState(0), selectedIndex = _p[0], setSelectedIndex = _p[1];
    var _q = useState([]), scrollSnaps = _q[0], setScrollSnaps = _q[1];
    var _r = useState(false), arrowsVisible = _r[0], setArrowsVisible = _r[1];
    var _s = useState(!(typeof hideNavMaxWidth !== 'undefined')), visibleNavs = _s[0], setVisibleNavs = _s[1];
    var autoplayCb = useCallback(function () {
        if (!embla || autoPlay === false)
            return;
        var snapLen = embla.scrollSnapList().length;
        var selectedIndex = embla.selectedScrollSnap();
        var lastIdx = rtl ? 0 : snapLen - 1;
        if (!rtl) {
            embla.scrollNext();
        }
        else {
            embla.scrollPrev();
        }
        if (!options.loop && selectedIndex === lastIdx) {
            embla.scrollTo(lastIdx > 0 ? 0 : snapLen - 1);
        }
    }, [autoPlay, embla, options.loop, rtl]);
    var _t = useRecursiveTimeout(autoplayCb, typeof autoPlay === 'number' ? autoPlay : 3000), play = _t.play, stop = _t.stop, pause = _t.pause, restart = _t.restart;
    useEffect(function () {
        play();
    }, [play]);
    useEffect(function () {
        if (Object.keys(options).length > 0 && embla) {
            embla.reInit(options);
        }
    }, [embla, options]);
    useEffect(function () {
        if (!stopOnMouseEnter)
            return;
        embla === null || embla === void 0 ? void 0 : embla.slideNodes().forEach(function (slideNode) {
            slideNode.addEventListener('mouseover', pause);
            slideNode.addEventListener('mouseout', restart);
        });
        return function () {
            stopOnMouseEnter && (embla === null || embla === void 0 ? void 0 : embla.slideNodes().forEach(function (slideNode) {
                slideNode.removeEventListener('mouseover', pause);
                slideNode.removeEventListener('mouseout', restart);
            }));
        };
    }, [embla, pause, play, restart, stopOnMouseEnter]);
    var canScroll = useCallback(function () {
        var instance = embla;
        return instance.canScrollPrev() || instance.canScrollNext();
    }, [embla]);
    var onSelect = useCallback(function () {
        var instance = embla;
        setSelectedIndex(instance.selectedScrollSnap());
        setPrevBtnEnabled(instance.canScrollPrev());
        setNextBtnEnabled(instance.canScrollNext());
        if (onSlideEnd) {
            onSlideEnd(instance.selectedScrollSnap());
        }
    }, [embla, onSlideEnd]);
    var onResize = useCallback(function () {
        var instance = embla;
        var draggable = canScroll();
        setArrowsVisible(draggable);
        var align = rtl ? 'end' : defaultOptions$1.align;
        if (options.align) {
            align = options.align;
        }
        instance.reInit({
            align: align,
            draggable: draggable,
            startIndex: rtl ? instance.scrollSnapList().length - 1 : 0,
        });
        setScrollSnaps(instance.scrollSnapList());
        setPrevBtnEnabled(instance.canScrollPrev());
        setNextBtnEnabled(instance.canScrollNext());
        if (typeof hideNavMaxWidth !== 'undefined') {
            if (window.outerWidth > hideNavMaxWidth - 1) {
                setVisibleNavs(true);
            }
            else {
                setVisibleNavs(false);
            }
        }
    }, [canScroll, embla, hideNavMaxWidth, options.align, rtl]);
    var onSettle = useCallback(function () {
        play();
        if (onAfterChange) {
            onAfterChange(embla.selectedScrollSnap());
        }
    }, [embla, onAfterChange, play]);
    var scrollTo = useCallback(function (index) { return function () {
        embla.scrollTo(index);
    }; }, [embla]);
    var scrollPrev = useCallback(function () {
        embla.scrollPrev();
        stop();
    }, [embla, stop]);
    var scrollNext = useCallback(function () {
        embla.scrollNext();
        stop();
    }, [embla, stop]);
    var hasBottomNav = useMemo(function () {
        return ['circles', 'flat'].includes(bottomNav) && scrollSnaps.length > 1;
    }, [bottomNav, scrollSnaps]);
    useEffect(function () {
        if (embla) {
            onSelect();
            onResize();
            onSettle();
            embla.on('select', onSelect);
            embla.on('resize', onResize);
            embla.on('settle', onSettle);
            embla.on('pointerDown', stop);
        }
    }, [arrows, bottomNav, embla, hasBottomNav, onResize, onSelect, onSettle, stop]);
    var navCondition = useCallback(function (navType) {
        if (typeof hideNavMaxWidth !== 'undefined') {
            if (hideNavType === 'both') {
                return visibleNavs;
            }
            else {
                return hideNavType !== navType || visibleNavs;
            }
        }
        else {
            switch (navType) {
                case 'arrows':
                    return arrowsVisible;
                case 'bottomNav':
                    return hasBottomNav;
                // do nothing
            }
        }
    }, [arrowsVisible, hasBottomNav, hideNavMaxWidth, hideNavType, visibleNavs]);
    var pages = [];
    var childrens = Children.count(children);
    if (childrens < 1) {
        return null;
    }
    else {
        pages = Array.from(Array(childrens).keys());
    }
    return (React__default.createElement(CarouselWrapper, null,
        React__default.createElement(CarouselInnerWrapper, { className: "carousel-inner-wrapper" },
            React__default.createElement(CarouselViewport, { "data-testid": "carousel-viewport", ref: viewportRef, arrowGap: arrowsVisible ? arrowGap : false },
                React__default.createElement(CarouselContainer, { loop: options.loop || defaultOptions$1.loop, rtl: rtl, className: "carousel-container " + className, "data-testid": "carousel-container" }, rtl
                    ? Children.toArray(children)
                        .reverse()
                        .map(function (child) { return child; })
                    : children)),
            navCondition('arrows') && arrowsVisible && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(PrevButton, { arrowType: arrows, bottomNav: bottomNav, enabled: prevBtnEnabled, onClick: scrollPrev, isNewButton: isNewButton, position: "prev" }),
                React__default.createElement(NextButton, { arrowType: arrows, bottomNav: bottomNav, enabled: nextBtnEnabled, onClick: scrollNext, isNewButton: isNewButton, position: "next" })))),
        (isSSRNav || (navCondition('bottomNav') && hasBottomNav)) && (React__default.createElement(CarouselNavWrapper, { "data-testid": "carousel-nav-wrapper", bannerType: bannerType }, 
        // tslint:disable-next-line:variable-name
        pages.map(function (_snap, index) { return (React__default.createElement(BottomNavigation, { variant: bottomNav, selected: index === selectedIndex, onClick: scrollTo(index), key: index, bannerType: bannerType })); })))));
};

var ImageCircleContainerWrapper = customStyled(Flex)(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  display grid;\n  grid-column-gap: ", ";\n  grid-row-gap: ", "px;\n  grid-template-columns: ", ";\n  width: 100%;\n\n  @media (min-width: ", ") {\n    grid-template-columns: repeat(5, 1fr);\n  }\n  \n  @media (min-width: ", ") {\n    grid-template-columns: ", ";\n    grid-column-gap: ", ";\n    ", "\n  }\n"], ["\n  display grid;\n  grid-column-gap: ", ";\n  grid-row-gap: ", "px;\n  grid-template-columns: ", ";\n  width: 100%;\n\n  @media (min-width: ", ") {\n    grid-template-columns: repeat(5, 1fr);\n  }\n  \n  @media (min-width: ", ") {\n    grid-template-columns: ", ";\n    grid-column-gap: ", ";\n    ",
    "\n  }\n"])), function (props) { return props.mGap; }, function (props) { return props.theme.space[4]; }, function (props) { return "repeat(" + props.circlePerRows + ", 1fr)"; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.theme.breakpoints[3]; }, function (props) { return "repeat(auto-fit, " + props.radius + ")"; }, function (props) { return props.gap; }, function (props) {
    return props.isHideInDesktop &&
        "\n      display: none;\n    ";
});
var ImageCircleSlide = customStyled.div(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n    box-sizing: content-box;\n    flex: 0 0 auto;\n    padding: ", ";\n    position: relative;\n    width: ", ";\n\n    @media (min-width: ", ") {\n        width: ", ";\n    }\n\n    ", "\n"], ["\n    box-sizing: content-box;\n    flex: 0 0 auto;\n    padding: ", ";\n    position: relative;\n    width: ", ";\n\n    @media (min-width: ", ") {\n        width: ", ";\n    }\n\n    ",
    "\n"])), function (props) { return (props.isCarousel ? "0 " + props.theme.space[5] / 2 + "px" : 0); }, function (props) { return props.mRadius; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.radius; }, function (props) {
    return props.isNewJourney
        ? "\n      display: flex;\n      justify-content: center;\n      margin: auto;\n      align-items: start;\n      height: 100%;\n    "
        : '';
});
var templateObject_1$h, templateObject_2$d;

var ImageCircleContainer = function (_a) {
    var list = _a.list, isCarousel = _a.isCarousel, onClickHandler = _a.onClickHandler, css = _a.css, _b = _a.radius, radius = _b === void 0 ? '125px' : _b, _c = _a.mRadius, mRadius = _c === void 0 ? '85px' : _c, _d = _a.circlePerRows, circlePerRows = _d === void 0 ? 3 : _d, _e = _a.gap, gap = _e === void 0 ? '32px' : _e, _f = _a.mGap, mGap = _f === void 0 ? '32px' : _f, _g = _a.isHideInDesktop, isHideInDesktop = _g === void 0 ? false : _g, onView = _a.onView, _h = _a.isNewJourney, isNewJourney = _h === void 0 ? false : _h;
    useEffect(function () {
        if (onView && Array.isArray(list) && list.length > 0) {
            onView(list);
        }
    }, [list, onView]);
    var Container = isCarousel ? Carousel : ImageCircleContainerWrapper;
    return list.length > 0 ? (React__default.createElement(Container, { isCarousel: isCarousel, css: css, radius: radius, mRadius: mRadius, circlePerRows: circlePerRows, gap: gap, mGap: mGap, isHideInDesktop: isHideInDesktop, isNewJourney: isNewJourney }, list.map(function (l, index) { return (React__default.createElement(ImageCircleSlide, { key: index, isCarousel: isCarousel, mRadius: mRadius, radius: radius, isNewJourney: isNewJourney },
        React__default.createElement(ImageCircle, { imagePath: l.imagePath, link: l.link, title: l.title, backgroundColor: l.backgroundColor, onClick: function () { return onClickHandler && onClickHandler(index + 1, l); }, testId: "image-circle-" + (index + 1), altText: l.altText, radius: radius, mRadius: mRadius, isNewJourney: isNewJourney }))); }))) : null;
};

var _a$3 = theme.colors, red$3 = _a$3.red, persiangreen$2 = _a$3.persiangreen, copy$1 = _a$3.copy, blue$4 = _a$3.blue;
var variants = {
    primary: {
        color: blue$4,
    },
    error: {
        color: red$3,
    },
    success: {
        color: persiangreen$2,
    },
    secondary: {
        color: 'transparent',
    },
};
var Group = styled.div(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  position: relative;\n  ", "\n  opacity: ", ";\n  ", "\n"], ["\n  position: relative;\n  ",
    "\n  opacity: ", ";\n  ", "\n"])), function (_a) {
    var newStyle = _a.newStyle, variant = _a.variant;
    return !newStyle ? "border-bottom: 1px solid " + variants[variant].color + ";" : '';
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '0.6' : '1');
}, space);
Group.defaultProps = {
    mt: 3,
};
var TextInput = styled.input(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  ", "\n  background: transparent;\n  display: block;\n  width: 100%;\n  border: none;\n  outline: none;\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  background: transparent;\n  display: block;\n  width: 100%;\n  border: none;\n  outline: none;\n  ", "\n  ", "\n  ",
    "\n"])), function (_a) {
    var spacing = _a.theme.space;
    return "padding: " + spacing[2] + "px;";
}, typography, color, function (_a) {
    var newStyle = _a.newStyle, variant = _a.variant;
    return newStyle
        ? "\n    border: 1px solid " + variants[variant].color + ";\n    border-radius: 4px;\n  "
        : '';
});
var Label$1 = styled.label(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  font-weight: normal;\n  position: absolute;\n  pointer-events: none;\n  transition: 0.2s ease all;\n  color: ", ";\n  html[dir='ltr'] & {\n    left: 8px;\n  }\n\n  /* Truncate lengthy text */\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ", "\n\n  ", "};\n"], ["\n  font-weight: normal;\n  position: absolute;\n  pointer-events: none;\n  transition: 0.2s ease all;\n  color: ", ";\n  html[dir='ltr'] & {\n    left: 8px;\n  }\n\n  /* Truncate lengthy text */\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  ", "\n\n  ",
    "};\n"])), copy$1, typography, function (props) {
    var focussing = props.focussing, used = props.used;
    return "\n      " + (focussing || used ? "font-size: " + props.theme.fontSizes[0] + "px;" : '') + "\n      top: " + (focussing || used ? -10 : 8) + "px;\n      opacity: " + (focussing || used ? 1 : '0.6') + ";\n\n      > em {\n        font-size: " + props.theme.fontSizes[focussing || used ? 0 : 1] + "px;\n      }\n    ";
});
var Hint = styled.em(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  color: ", "!important;\n"], ["\n  color: ", "!important;\n"])), function (props) { return props.theme.colors.doveGrey; });
var Bar = styled.span(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  content: '';\n  height: 1px;\n  bottom: 0px;\n  position: absolute;\n  left: 0;\n  transition: 0.2s ease all;\n  ", "\n"], ["\n  content: '';\n  height: 1px;\n  bottom: 0px;\n  position: absolute;\n  left: 0;\n  transition: 0.2s ease all;\n  ",
    "\n"])), function (props) {
    var variant = props.variant, focussing = props.focussing;
    return "\n      width: " + (variant === 'primary' ? (focussing ? '100%' : 0) : '100%') + ";\n      background: " + variants[variant].color + ";\n    ";
});
var templateObject_1$i, templateObject_2$e, templateObject_3$b, templateObject_4$9, templateObject_5$6;

function Checked() {
    return (React__default.createElement("svg", { enableBackground: "new 0 0 32 32", height: "20px", id: "\u0421\u043B\u043E\u0439_1", version: "1.1", viewBox: "0 0 32 32", width: "20px", style: { fill: 'rgb(0, 150, 136)', stroke: 'rgb(0, 150, 136)' } },
        React__default.createElement("path", { clipRule: "evenodd", d: "M27.704,8.397c-0.394-0.391-1.034-0.391-1.428,0  L11.988,22.59l-6.282-6.193c-0.394-0.391-1.034-0.391-1.428,0c-0.394,0.391-0.394,1.024,0,1.414l6.999,6.899  c0.39,0.386,1.039,0.386,1.429,0L27.704,9.811C28.099,9.421,28.099,8.787,27.704,8.397C27.31,8.006,28.099,8.787,27.704,8.397z", fill: "#121313", fillRule: "evenodd", id: "Check" }),
        React__default.createElement("g", null),
        React__default.createElement("g", null),
        React__default.createElement("g", null),
        React__default.createElement("g", null),
        React__default.createElement("g", null),
        React__default.createElement("g", null)));
}

var predefinedRegExps = {
    alphanumericCommaPeriod: /[A-Za-z0-9\s.,]+/,
    alphanumericCommaPeriodArabic: /[A-Za-z0-9 ,.ء-ي٠-٩]+/,
};

var Input = function (props) {
    var onFocus = props.onFocus, value = props.value, disabled = props.disabled, onChange = props.onChange, onBlur = props.onBlur, icon = props.icon, variant = props.variant, _a = props.mask, mask = _a === void 0 ? '' : _a, maskChar = props.maskChar, testid = props.testid, register = props.register, name = props.name, successIcon = props.successIcon, allowedRegExpChars = props.allowedRegExpChars, label = props.label, type = props.type, hint = props.hint, _b = props.overrideInternalOptions, overrideInternalOptions = _b === void 0 ? {} : _b, fontSize = props.fontSize, defaultValue = props.defaultValue, maxLength = props.maxLength, newStyle = props.newStyle, rest = __rest(props, ["onFocus", "value", "disabled", "onChange", "onBlur", "icon", "variant", "mask", "maskChar", "testid", "register", "name", "successIcon", "allowedRegExpChars", "label", "type", "hint", "overrideInternalOptions", "fontSize", "defaultValue", "maxLength", "newStyle"]);
    var _c = useState(!!value || !!defaultValue), focussing = _c[0], setFocussing = _c[1];
    var _d = useState(!!value), used = _d[0], setUsed = _d[1];
    useEffect(function () {
        var isFocused = value || (type === 'number' && value === 0) || defaultValue;
        !newStyle && setFocussing(isFocused);
        setUsed(isFocused);
    }, [type, value, defaultValue, newStyle]);
    var onFocusHandle = function (e) {
        !newStyle && setFocussing(true);
        if (onFocus) {
            onFocus(e);
        }
    };
    var onBlurHandle = function (e) {
        if (onBlur) {
            onBlur(e);
        }
        if (!newStyle && (typeof value === 'undefined' || (type == 'number' && value !== 0))) {
            setFocussing(false);
        }
    };
    var onChangeHandle = function (event) {
        if (event.target.value) {
            setUsed(true);
        }
        else {
            setUsed(false);
        }
        if (onChange) {
            onChange(event);
        }
    };
    // Generates onKeyPress event that will restrict the input based on the provided `allowedRegExpChars` (only if provided)
    var restrictedInputProp = useMemo(function () {
        if (!allowedRegExpChars) {
            return {};
        }
        var regexp = allowedRegExpChars;
        // Checks if predefined RegExp
        if ((typeof allowedRegExpChars === 'string' || allowedRegExpChars instanceof String) &&
            predefinedRegExps.hasOwnProperty(allowedRegExpChars)) {
            regexp = predefinedRegExps[allowedRegExpChars];
        }
        // Checks if RegExp
        if (regexp instanceof RegExp) {
            return {
                onKeyPress: function (e) {
                    if (!regexp.test(e.key)) {
                        e.preventDefault();
                    }
                },
            };
        }
        // Fallback
        return {};
    }, [allowedRegExpChars]);
    return (React__default.createElement(Group, { disabled: disabled, "data-testid": testid, mt: newStyle ? 0 : 3, variant: variant, newStyle: newStyle },
        React__default.createElement(Flex, { alignItems: "center" },
            React__default.createElement(InputMask, { mask: mask, value: value, onChange: onChangeHandle, onFocus: onFocusHandle, onBlur: onBlurHandle, disabled: disabled, maskChar: maskChar }, function (inputProps) { return (React__default.createElement(TextInput, __assign({ focussing: focussing, value: value, maxLength: maxLength }, inputProps, { onChange: onChangeHandle, disabled: disabled, name: name, ref: register, fontSize: fontSize, type: type, defaultValue: defaultValue, newStyle: newStyle, variant: variant }, rest, restrictedInputProp))); }),
            icon && icon,
            successIcon && variant === 'success' && React__default.createElement(Checked, null)),
        (label || hint) && !newStyle && (React__default.createElement(Label$1, { focussing: focussing, fontSize: fontSize, used: overrideInternalOptions.used || used, variant: variant },
            label,
            " ",
            hint && React__default.createElement(Hint, null, hint))),
        variant !== 'secondary' && (!disabled || variant !== 'primary') && !newStyle && (React__default.createElement(Bar, { focussing: focussing, variant: variant, "data-testid": "trolly-input-bar" }))));
};
Input.defaultProps = {
    variant: 'primary',
    testid: 'trolly-input',
    disabled: false,
    maskChar: null,
    mask: '',
    successIcon: false,
    autoComplete: '',
    maxLength: -1,
    newStyle: false,
};
Input.predefinedRegExps = predefinedRegExps;

var _a$4 = theme.colors, alabaster = _a$4.alabaster, blue$5 = _a$4.blue, white$2 = _a$4.white, silverChalice$1 = _a$4.silverChalice;
var ButtonGroupItemStyled = styled.div(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  box-sizing: border-box;\n  border: 1px solid #f3f3f3;\n  border-radius: 4px;\n  background-color: ", ";\n  line-height: normal;\n  ", "\n  ", ";\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  box-sizing: border-box;\n  border: 1px solid #f3f3f3;\n  border-radius: 4px;\n  background-color: ", ";\n  line-height: normal;\n  ",
    "\n  ", ";\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), alabaster, function (props) {
    var checked = props.checked, disabled = props.disabled;
    if (checked) {
        return "\n      background-color: " + blue$5 + ";\n      color: " + white$2 + ";\n      cursor: not-allowed;\n      ";
    }
    else if (!checked && !disabled) {
        return 'cursor: pointer;';
    }
    if (disabled) {
        return "\n      opacity: 0.65;\n      cursor: not-allowed;\n      color: " + silverChalice$1 + ";\n      cursor: not-allowed;\n      ";
    }
}, flex, flexbox, space, typography, layout, color, border, position, background, boxShadow);
var templateObject_1$j;

function getClickProp(checked, onChange) {
    return checked ? { checked: checked } : { onClick: onChange };
}
var ButtonGroupItem = function (_a) {
    var checked = _a.checked, onChange = _a.onChange, index = _a.index, rest = __rest(_a, ["checked", "onChange", "index"]);
    return (React__default.createElement(ButtonGroupItemStyled, __assign({ mb: 3, p: 2, "data-testid": "trolly-group-button-item-" + index }, getClickProp(checked, onChange), rest)));
};

var ButtonGroup = function (props) {
    var children = props.children, onChange = props.onChange, rest = __rest(props, ["children", "onChange"]);
    var _a = useState(), checked = _a[0], setChecked = _a[1];
    var onItemClick = useCallback(function (index, value) { return function () {
        setChecked(index);
        onChange(value);
    }; }, [setChecked, onChange]);
    useEffect(function () {
        Children.map(children, function (child, index) {
            if (child && child.type === ButtonGroupItem) {
                var childProps = child.props;
                if (childProps.checked) {
                    setChecked(index);
                }
            }
        });
    }, [children]);
    return (React__default.createElement(Box, __assign({}, rest), Children.map(children, function (child, index) {
        if (child && child.type === ButtonGroupItem) {
            return cloneElement(child, __assign(__assign({}, child.props), { checked: checked === index, index: index, onChange: onItemClick(index, child.props.value), key: "btngrp-" + index }));
        }
        return child;
    })));
};

var HiddenCheckbox = styled.input(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clippath: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"], ["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clippath: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"])));
HiddenCheckbox.displayName = 'HiddenCheckbox';
var StyledCheckbox = styled.div(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n  background: ", ";\n  border-radius: 3px;\n  border: ", " ", ";\n"], ["\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n  background: ", ";\n  border-radius: 3px;\n  border: ", " ", ";\n"])), function (props) { return props.size + "px"; }, function (props) { return props.size + "px"; }, function (props) { return (props.checked ? props.checkedBackground : props.defaultBackground); }, baseTheme.borders[1], function (props) { return (props.borderColor != '' ? props.borderColor : baseTheme.colors.copy); });
StyledCheckbox.displayName = 'StyledCheckbox';
var CheckboxContainer = styled.div(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n  ", "\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n  ", "\n"])), space);
CheckboxContainer.displayName = 'CheckboxContainer';
var Icon$1 = styled('svg')({
    fill: 'none',
    strokeWidth: '3px',
}, function (props) { return ({
    stroke: props.checkMarkTint,
    visibility: props.checked ? 'visible' : 'hidden',
}); });
Icon$1.displayName = 'Icon';
var Test = styled('div')({
    background: '#000000',
});
Test.displayName = 'Test';
var templateObject_1$k, templateObject_2$f, templateObject_3$c;

var Checkbox = (function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, _b = props.defaultBackground, defaultBackground = _b === void 0 ? baseTheme.colors.alabaster : _b, _c = props.checkedBackground, checkedBackground = _c === void 0 ? baseTheme.colors.alabaster : _c, _d = props.checkMarkTint, checkMarkTint = _d === void 0 ? baseTheme.colors.blue : _d, _e = props.borderColor, borderColor = _e === void 0 ? '' : _e, checked = props.checked, onChangeCheckbox = props.onChangeCheckbox, _f = props.testid, testid = _f === void 0 ? 'trolly-checkbox' : _f, _g = props.disabled, disabled = _g === void 0 ? false : _g, rest = __rest(props, ["size", "defaultBackground", "checkedBackground", "checkMarkTint", "borderColor", "checked", "onChangeCheckbox", "testid", "disabled"]);
    return (React__default.createElement("label", { "data-testid": testid },
        React__default.createElement(CheckboxContainer, __assign({}, rest),
            React__default.createElement(HiddenCheckbox, { type: "checkbox", checked: checked, onChange: onChangeCheckbox, disabled: disabled }),
            React__default.createElement(StyledCheckbox, { checked: checked, size: size, defaultBackground: defaultBackground, checkedBackground: checkedBackground, borderColor: borderColor },
                React__default.createElement(Icon$1, { "data-testid": 'icon', viewBox: "0 0 24 24", checked: checked, checkMarkTint: checkMarkTint },
                    React__default.createElement("polyline", { points: "20 6 9 17 4 12" })),
                React__default.createElement(Test, null)))));
});

var AccordionWrapper = styled.div(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
var templateObject_1$l;

var colors = theme.colors, fontWeights = theme.fontWeights, fontSizes = theme.fontSizes, themeSpace = theme.space;
var AccordionSectionHeader = styled.div(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  background-color: ", ";\n  cursor: pointer;\n  display: flex;\n  font-weight: ", ";\n  font-size: ", "px;\n  padding: ", "px;\n  text-transform: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  background-color: ", ";\n  cursor: pointer;\n  display: flex;\n  font-weight: ", ";\n  font-size: ", "px;\n  padding: ", "px;\n  text-transform: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), colors.white, fontWeights[5], fontSizes[2], themeSpace[3], function (props) { return (props.textTransform ? props.textTransform : 'none'); }, alignItems, background, justifyContent, layout, textStyle, typography, padding, color, border);
var AccordionSectionHeaderLabel = styled.span(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), fontSize, space);
var AccordionSectionHeaderIcon = styled(animated.div)(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var AccordionSectionContentWrapper = styled.div(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  border-bottom: 1px solid ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), colors.wildSand, background, layout, textStyle, typography, padding, margin, border);
var AccordionSectionContent = styled(animated.div)(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  background-color: ", ";\n  overflow: hidden;\n"], ["\n  background-color: ", ";\n  overflow: hidden;\n"])), colors.white);
var AccordionSectionContentInner = styled.div(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  padding: ", ";\n  ", "\n"], ["\n  padding: ", ";\n  ", "\n"])), "0 " + themeSpace[3] + "px " + themeSpace[3] + "px " + themeSpace[3] + "px}", padding);
var templateObject_1$m, templateObject_2$g, templateObject_3$d, templateObject_4$a, templateObject_5$7, templateObject_6$5;

var isBrowser$1 = function () { return typeof window !== 'undefined'; };

var iconAnimation = {
    arrow: 'arrow-up-down',
    plusMinus: 'plus-minus',
};
var renderPlusMinus = function (isOpen, animation, fill) {
    if (isOpen === void 0) { isOpen = false; }
    return (React__default.createElement(React__default.Fragment, null, isOpen ? (React__default.createElement(AccordionSectionHeaderIcon, { style: animation },
        React__default.createElement(Minus, { fill: fill }))) : (React__default.createElement(AccordionSectionHeaderIcon, { style: animation },
        React__default.createElement(Plus, { fill: fill })))));
};
var renderUpDownArrow = function (animation, fill) {
    return (React__default.createElement(AccordionSectionHeaderIcon, { style: animation },
        React__default.createElement(ArrowDown$1, { fill: fill })));
};
var AnimationIcon = function (_a) {
    var isOpen = _a.isOpen, _b = _a.openCloseIcon, openCloseIcon = _b === void 0 ? 'arrow-up-down' : _b, fill = _a.fill;
    var _c = openCloseIcon === 'arrow-up-down' ? [0, -4] : [-4, -1], open = _c[0], close = _c[1];
    var spring = useSpring({
        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        top: isOpen ? open : close,
        config: {
            duration: 160,
        },
    });
    return (React__default.createElement(React__default.Fragment, null,
        openCloseIcon === iconAnimation.plusMinus && renderPlusMinus(isOpen, spring, fill),
        openCloseIcon === iconAnimation.arrow && renderUpDownArrow(spring, fill)));
};
var AccordionSection = function (props) {
    var children = props.children, isOpen = props.isOpen, label = props.label, identifier = props.identifier, _a = props.openAll, openAll = _a === void 0 ? false : _a, openCloseIcon = props.openCloseIcon, _b = props.containerStyles, containerStyles = _b === void 0 ? {} : _b, _c = props.headerStyles, headerStyles = _c === void 0 ? {
        alignItems: 'center',
        justifyContent: 'space-between',
    } : _c, _d = props.headerLabelStyles, headerLabelStyles = _d === void 0 ? {} : _d, flipHeaderContent = props.flipHeaderContent, _e = props.actionIconStyles, actionIconStyles = _e === void 0 ? {} : _e, onClick = props.onClick, rest = __rest(props, ["children", "isOpen", "label", "identifier", "openAll", "openCloseIcon", "containerStyles", "headerStyles", "headerLabelStyles", "flipHeaderContent", "actionIconStyles", "onClick"]);
    var ref = useRef(null);
    var height = useComponentSize(ref).height;
    var onClickHandler = useCallback(function () { return onClick(identifier); }, [identifier, onClick]);
    var transitions = useTransition(isOpen, null, {
        from: {
            height: 0,
        },
        enter: {
            height: height,
        },
        leave: {
            height: 0,
        },
        update: { height: height },
        config: {
            duration: 160,
        },
    });
    useEffectOnce(function () {
        if (openAll === true) {
            onClick(identifier, openAll);
        }
    });
    var header = useMemo(function () { return [
        React__default.createElement(AccordionSectionHeaderLabel, __assign({ key: label + "-label" }, headerLabelStyles), label),
        React__default.createElement(AnimationIcon, __assign({ key: label + "-icon", isOpen: isOpen, openCloseIcon: openCloseIcon }, actionIconStyles)),
    ]; }, [actionIconStyles, headerLabelStyles, isOpen, label, openCloseIcon]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(AccordionSectionHeader, __assign({ "data-testid": "accordion-section-header", onClick: onClickHandler, isOpen: isOpen }, headerStyles, rest), !flipHeaderContent ? header : header.reverse()),
        React__default.createElement(AccordionSectionContentWrapper, __assign({}, containerStyles), transitions.map(function (anim) {
            return (anim.item && (React__default.createElement(AccordionSectionContent, { key: anim.key, style: isBrowser$1() ? anim.props : {} },
                React__default.createElement(AccordionSectionContentInner, { padding: containerStyles.padding, ref: ref }, children))));
        }))));
};

var Accordion = function (props) {
    var children = props.children, _a = props.allowMultiple, allowMultiple = _a === void 0 ? false : _a, _b = props.openAll, openAll = _b === void 0 ? false : _b, _c = props.testid, testid = _c === void 0 ? 'trolly-accordion' : _c, _d = props.openCloseIcon, openCloseIcon = _d === void 0 ? 'arrow-up-down' : _d, _e = props.flipHeaderContent, flipHeaderContent = _e === void 0 ? false : _e, onClickCallback = props.onClickCallback, rest = __rest(props, ["children", "allowMultiple", "openAll", "testid", "openCloseIcon", "flipHeaderContent", "onClickCallback"]);
    var getInitialOpenSections = function () {
        var initialState = {};
        if (openAll) {
            React__default.Children.forEach(children, function (child) {
                if (child) {
                    var props_1 = child.props;
                    var identifier = props_1['data-key'] || props_1['data-label'];
                    initialState[identifier] = true;
                }
            });
        }
        return initialState;
    };
    var _f = useState(getInitialOpenSections), openSections = _f[0], setOpenSections = _f[1];
    var onClick = useCallback(function (label, open) {
        var _a, _b, _c;
        if (open === void 0) { open = false; }
        var isOpen = openSections[label];
        if (open) {
            var sections = Object.assign(openSections, (_a = {}, _a[label] = true, _a));
            setOpenSections(__assign({}, sections));
        }
        else if (allowMultiple) {
            setOpenSections(__assign(__assign({}, openSections), (_b = {}, _b[label] = !isOpen, _b)));
        }
        else {
            setOpenSections((_c = {}, _c[label] = !isOpen, _c));
        }
        if (onClickCallback) {
            onClickCallback(label);
        }
    }, [openSections, allowMultiple, onClickCallback]);
    return (React__default.createElement(AccordionWrapper, { "data-testid": testid }, React__default.Children.map(children, function (child) {
        if (child) {
            var props_2 = child.props;
            var identifier = props_2['data-key'] || props_2['data-label'];
            return (React__default.createElement(AccordionSection, __assign({ openAll: openAll, isOpen: !!openSections[identifier], label: child.props['data-label'], identifier: identifier, "data-testid": child.props['data-testid'], onClick: onClick, flipHeaderContent: flipHeaderContent, openCloseIcon: openCloseIcon }, rest), child.props.children));
        }
    })));
};

var SlideNavigationWrapper = styled.div(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  ", ";\n  display: flex;\n  flex-direction: column;\n"], ["\n  ", ";\n  display: flex;\n  flex-direction: column;\n"])), background);
var NavigationItem = styled(animated.div)(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n  background: #4d4d;\n  position: relative;\n  display: flex;\n  width: 100%;\n"], ["\n  background: #4d4d;\n  position: relative;\n  display: flex;\n  width: 100%;\n"])));
var NavigationTitle = styled(animated.div)(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  background: #eee;\n  position: relative;\n  width: 100%;\n"], ["\n  background: #eee;\n  position: relative;\n  width: 100%;\n"])));
var NavigationItemContent = styled.div(templateObject_4$b || (templateObject_4$b = __makeTemplateObject([""], [""])));
var templateObject_1$n, templateObject_2$h, templateObject_3$e, templateObject_4$b;

var colors$1 = theme.colors;
var NavigationContentWrapper = styled.div(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n"], ["\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n"])));
var NavigationItems = styled(animated.div)(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"])));
var NavigationItem$1 = styled.div(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  min-height: 40px;\n  border-bottom: 1px solid ", ";\n  padding: 15px;\n  min-width: 200px;\n  cursor: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  min-height: 40px;\n  border-bottom: 1px solid ", ";\n  padding: 15px;\n  min-width: 200px;\n  cursor: ", ";\n"])), colors$1.wildSand, function (_a) {
    var onClick = _a.onClick;
    return (onClick ? 'pointer' : 'default');
});
var templateObject_1$o, templateObject_2$i, templateObject_3$f;

var NavigationContent = function (_a) {
    var children = _a.children, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, onClickHandler = _a.onClickHandler;
    var childrens = useMemo(function () { return React__default.Children.toArray(children); }, [children]);
    var titleAnimRef = useRef(null);
    var contenAnimtRef = useRef(null);
    var contentRef = useRef(null);
    var width = useComponentSize(contentRef).width;
    var _c = useState(false), open = _c[0], setOpenState = _c[1];
    var _d = useState(0), selectedIndex = _d[0], setSelectedIndex = _d[1];
    var onSelectHandler = function (index, label) {
        setSelectedIndex(index);
        onClickHandler ? onClickHandler(label) : setOpenState(!open);
    };
    useEffect(function () {
        setOpenState(isOpen);
    }, [isOpen]);
    var navigationTitleTrans = useTransition(!open, null, {
        from: {
            right: width,
        },
        enter: {
            right: 0,
        },
        leave: {
            right: width,
        },
        update: {
            right: 0,
        },
        config: {
            duration: 200,
        },
        ref: titleAnimRef,
    });
    var navigationItemTrans = useTransition(open, null, {
        from: {
            left: width,
        },
        enter: {
            left: 0,
        },
        leave: {
            left: width,
        },
        config: {
            duration: 200,
        },
        ref: contenAnimtRef,
    });
    useChain(!open ? [titleAnimRef, contenAnimtRef] : [contenAnimtRef, titleAnimRef], [0, 0]);
    return (React__default.createElement(NavigationContentWrapper, null,
        navigationTitleTrans.map(function (animation) {
            return animation.item && (React__default.createElement(NavigationItems, { ref: contentRef, key: animation.key, style: animation.props }, React__default.Children.map(children, function (child, index) { return (React__default.createElement(NavigationItem$1, { "data-testid": "primary-item", 
                // tslint:disable-next-line: jsx-no-lambda
                onClick: function () { return onSelectHandler(index, child.props['data-label']); } },
                React__default.createElement(Text, { testid: "label-text" }, child.props['data-label']),
                React__default.createElement(RightArrow, { size: "S" }))); })));
        }),
        navigationItemTrans.map(function (animation) {
            return animation.item && (React__default.createElement(NavigationItems, { "data-testid": "secondary-item", style: animation.props, key: animation.key },
                React__default.createElement(NavigationItem$1, null, childrens[selectedIndex])));
        })));
};

var SlideNavigation = function (_a) {
    var children = _a.children, isOpen = _a.isOpen, onClick = _a.onClick, _b = _a.testid, testid = _b === void 0 ? 'trolly-slideNavigation' : _b, rest = __rest(_a, ["children", "isOpen", "onClick", "testid"]);
    return (React__default.createElement(SlideNavigationWrapper, __assign({ "data-testid": testid }, rest),
        React__default.createElement(NavigationContent, { onClickHandler: onClick, isOpen: isOpen }, children)));
};

var SearchableListContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
});
var ListItem = styled.li(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  align-items: center;\n  display: flex;\n  cursor: ", ";\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  align-items: center;\n  display: flex;\n  cursor: ", ";\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n"])), border, height, space, function (props) { return (props.hasCursor ? 'pointer' : 'default'); });
var InputContainer = customStyled(Flex)(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n  align-items: center;\n  width: 100%;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  align-items: center;\n  width: 100%;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), background, border, fontSize, space);
var SearchableListInput = styled.input(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n  padding-left: 5px;\n  background: transparent;\n  border: none;\n  width: 100%;\n"], ["\n  padding-left: 5px;\n  background: transparent;\n  border: none;\n  width: 100%;\n"])));
var SearchableList = customStyled.ul(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n  overflow: auto;\n  margin-top: 16px;\n  ", ";\n  ", ";\n"], ["\n  overflow: auto;\n  margin-top: 16px;\n  ", ";\n  ", ";\n"])), height, space);
var NotFoundTextWrapper = customStyled.div(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  height: 32px;\n  padding: 0 16px;\n"], ["\n  align-items: center;\n  display: flex;\n  height: 32px;\n  padding: 0 16px;\n"])));
var ToggleButton = customStyled(Text)(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n  color: ", ";\n  cursor: pointer;\n  display: inline-block;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  color: ", ";\n  cursor: pointer;\n  display: inline-block;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) { return props.theme.colors.blue; }, fontSize, fontWeight, height, space);
var templateObject_1$p, templateObject_2$j, templateObject_3$g, templateObject_4$c, templateObject_5$8, templateObject_6$6;

var SearchableListView = function (_a) {
    var entries = _a.entries, icon = _a.icon, itemsToShow = _a.itemsToShow, notFoundText = _a.notFoundText, onItemSelect = _a.onItemSelect, searchPlaceHolder = _a.searchPlaceHolder, showLessText = _a.showLessText, showMoreText = _a.showMoreText, inputContainerStyles = _a.inputContainerStyles, listItemStyles = _a.listItemStyles, toggleBtnStyles = _a.toggleBtnStyles, listStyles = _a.listStyles;
    var _b = useState(''), inputState = _b[0], onInputUpdate = _b[1];
    var _c = useState(itemsToShow ? itemsToShow : entries.length), shownItems = _c[0], setShownItems = _c[1];
    var regEx = new RegExp(inputState, 'i');
    var isExpanded = useMemo(function () { return (!itemsToShow ? true : shownItems === entries.length); }, [
        entries.length,
        itemsToShow,
        shownItems,
    ]);
    var hasOnItemSelect = useMemo(function () { return typeof onItemSelect !== 'undefined'; }, [onItemSelect]);
    var onClickListItem = useCallback(function (entry) { return function () {
        onItemSelect(entry);
    }; }, [onItemSelect]);
    var onInputChange = useCallback(function (e) {
        onInputUpdate(e.target.value);
    }, []);
    var renderEntry = useCallback(function (key, entry) {
        return (React__default.createElement(ListItem, __assign({ key: key, hasCursor: hasOnItemSelect }, listItemStyles, (hasOnItemSelect ? { onClick: onClickListItem(entry) } : {}), { "data-testid": "list-item" }), entry.name));
    }, [hasOnItemSelect, listItemStyles, onClickListItem]);
    var initialEntries = useMemo(function () {
        return entries.slice(0, shownItems).map(function (entry, index) { return renderEntry(index, entry); });
    }, [entries, renderEntry, shownItems]);
    var searchedEntries = useMemo(function () {
        if (!inputState)
            return [];
        return entries
            .map(function (entry, index) {
            if (regEx.test(entry.key) || regEx.test(entry.name)) {
                return renderEntry(index, entry);
            }
        })
            .filter(function (entry) { return typeof entry !== 'undefined'; });
    }, [entries, inputState, regEx, renderEntry]);
    var searchedEntriesNumResults = useMemo(function () { return searchedEntries.length; }, [searchedEntries]);
    var onClickToggleBtn = useCallback(function () {
        if (!isExpanded) {
            setShownItems(entries.length);
        }
        else {
            setShownItems(itemsToShow);
        }
    }, [entries.length, isExpanded, itemsToShow]);
    var renderToggleBtn = useCallback(function () {
        if (typeof itemsToShow === 'undefined')
            return null;
        if (inputState && (searchedEntriesNumResults < 1 || searchedEntriesNumResults <= itemsToShow))
            return null;
        if (entries.length <= itemsToShow)
            return null;
        return (React__default.createElement(ToggleButton, __assign({ "data-testid": "toggle-btn" }, toggleBtnStyles, { onClick: onClickToggleBtn }), !isExpanded ? showMoreText : showLessText));
    }, [
        entries.length,
        inputState,
        isExpanded,
        itemsToShow,
        onClickToggleBtn,
        searchedEntriesNumResults,
        showLessText,
        showMoreText,
        toggleBtnStyles,
    ]);
    var renderEntries = useCallback(function () {
        if (inputState && searchedEntriesNumResults) {
            return searchedEntries.slice(0, shownItems);
        }
        if (!inputState && initialEntries) {
            return initialEntries;
        }
        return (React__default.createElement(NotFoundTextWrapper, { "data-testid": "not-found-text-wrapper" },
            React__default.createElement(Text, { color: "alto" }, notFoundText)));
    }, [initialEntries, inputState, notFoundText, searchedEntries, searchedEntriesNumResults, shownItems]);
    return (React__default.createElement(SearchableListContainer, null,
        React__default.createElement(InputContainer, __assign({}, inputContainerStyles),
            !!icon && icon,
            React__default.createElement(SearchableListInput, { placeholder: searchPlaceHolder, onChange: onInputChange, value: inputState })),
        React__default.createElement(SearchableList, __assign({}, listStyles), renderEntries()),
        renderToggleBtn()));
};
SearchableListView.defaultProps = {
    inputContainerStyles: {
        backgroundColor: '#F5F5F5',
        padding: '10px',
    },
    notFoundText: 'No results found',
    listItemStyles: {
        borderBottom: '1px solid #E6E6E6',
        padding: '16px 0',
    },
    listStyles: {
        marginTop: '16px',
        height: '100%',
    },
    searchPlaceHolder: 'Search',
    showLessText: 'Show Less',
    showMoreText: 'Show More',
    toggleBtnStyles: {
        fontSize: '12px',
        fontWeight: '500',
        marginY: '16px',
    },
};

// Checks if CSS "mix-blend-mode" is supported by the browser
// export const isCSSMixBlendModeSupported = () =>
//   typeof (window.getComputedStyle(document.body) as any).mixBlendMode !== 'undefined';
// TODO: move to global helper?
var isExisty = function (target) { return target !== undefined && target !== null && target !== ''; };
var extractVal = function (arr, i, def) { return (isExisty(arr[i]) ? arr[i] : def); };
var extractValBaseOnDevice = function (device, arr, def) {
    var dd = def;
    if (device.isMobile) {
        dd = extractVal(arr, 0, dd);
    }
    else if (device.isPad1) {
        dd = extractVal(arr, 1, extractVal(arr, 0, dd));
    }
    else if (device.isPad2) {
        dd = extractVal(arr, 2, extractVal(arr, 1, extractVal(arr, 0, dd)));
    }
    else if (device.isDesktop) {
        dd = extractVal(arr, 3, extractVal(arr, 2, extractVal(arr, 1, extractVal(arr, 0, dd))));
    }
    return dd;
};
// Generates spotlight element style
var getSpotlightStyle = function (_a) {
    var centerOfAttentionRefCurrent = _a.centerOfAttentionRefCurrent, padding = _a.padding, pullTop = _a.pullTop, rtl = _a.rtl;
    var elementRect = centerOfAttentionRefCurrent.getBoundingClientRect();
    var top = Math.round(elementRect.top - padding);
    var left = Math.round(elementRect.left - padding);
    var height = Math.round(elementRect.height + padding * 2);
    var width = Math.round(elementRect.width + padding * 2);
    return {
        height: height,
        width: width,
        transform: "translate3d(" + (rtl ? -left : left) + "px, " + (top - pullTop) + "px, 0)",
    };
};
var getNoteMargin = function (_a, axis) {
    var theme = _a.theme, noteGap = _a.noteGap;
    var space = theme.space[noteGap];
    return {
        margin: axis === 'x' ? "0 " + space + "px" : space + "px 0",
    };
};
var getCalcPadding = function (device, theme, padding) {
    var calcPadding;
    if (Array.isArray(padding)) {
        var pp = extractValBaseOnDevice(device, padding, 2);
        calcPadding = typeof pp === 'number' ? theme.space[pp] : parseFloat(pp);
    }
    else {
        calcPadding = theme.space[padding];
    }
    return calcPadding;
};
var getCalcPullTop = function (device, theme, pullTop) {
    var calcPullTop;
    if (Array.isArray(pullTop)) {
        var pt = extractValBaseOnDevice(device, pullTop, 0);
        calcPullTop = typeof pt === 'number' ? theme.space[pt] : parseFloat(pt);
    }
    else {
        calcPullTop = theme.space[pullTop];
    }
    return calcPullTop;
};

var fadeIn$1 = keyframes(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  0% { opacity: 0 }\n  100% { opacity: 1 }\n"], ["\n  0% { opacity: 0 }\n  100% { opacity: 1 }\n"])));
var CoachMarkOverlay = customStyled('div', {
    shouldForwardProp: shouldForwardProp,
})(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n\n  animation: ", " 0.2s ease-in;\n  cursor: pointer;\n  background: ", ";\n  z-index: ", ";\n\n  @supports (mix-blend-mode: hard-light) {\n    mix-blend-mode: hard-light;\n  }\n\n"], ["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n\n  animation: ", " 0.2s ease-in;\n  cursor: pointer;\n  background: ", ";\n  z-index: ", ";\n\n  @supports (mix-blend-mode: hard-light) {\n    mix-blend-mode: hard-light;\n  }\n\n"])), fadeIn$1, function (props) { return rgba(props.theme.colors[props.color || 'black'], 0.8); }, function (props) { return props.zIndex; });
var templateObject_1$q, templateObject_2$k;

var fadeInZoomOut = keyframes(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  0% {\n    opacity: 0;\n    transform: scale3d(1.2, 1.2, 1.2)\n  }\n  100% { opacity: 1 }\n"], ["\n  0% {\n    opacity: 0;\n    transform: scale3d(1.2, 1.2, 1.2)\n  }\n  100% { opacity: 1 }\n"])));
var CoachMarkSpotlightBox = customStyled('div', {
    shouldForwardProp: shouldForwardProp,
})(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  transition: 0.3s ease-in-out;\n"], ["\n  position: absolute;\n  left: 0;\n  transition: 0.3s ease-in-out;\n"])));
var CoachMarkSpotlightAnimate = customStyled('div', {
    shouldForwardProp: shouldForwardProp,
})(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["\n  animation: ", " 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n\n  @supports (mix-blend-mode: hard-light) {\n    background: #909090;\n  }\n\n  @supports not(mix-blend-mode: hard-light) {\n    boxShadow: ", ";\n  }\n\n  ", "\n  ", "\n"], ["\n  animation: ", " 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n\n  @supports (mix-blend-mode: hard-light) {\n    background: #909090;\n  }\n\n  @supports not(mix-blend-mode: hard-light) {\n    boxShadow: ", ";\n  }\n\n  ", "\n  ", "\n"])), fadeInZoomOut, function (_a) {
    var color = _a.color;
    return "0 0 0 9999px " + color + ", 0 0 15px " + color;
}, border, space);
var CoachMarkSpotlight = function (_a) {
    var children = _a.children, style = _a.style, rest = __rest(_a, ["children", "style"]);
    return (React__default.createElement(CoachMarkSpotlightBox, { style: style },
        React__default.createElement(CoachMarkSpotlightAnimate, __assign({}, rest)),
        children));
};
var templateObject_1$r, templateObject_2$l, templateObject_3$h;

var CoachMarkNote = customStyled('div', {
    shouldForwardProp: shouldForwardProp,
})(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  color: ", ";\n  position: absolute;\n  transition: 0.3s ease-in-out;\n\n  ", ";\n\n  ", "\n\n    ", "\n"], ["\n  color: ", ";\n  position: absolute;\n  transition: 0.3s ease-in-out;\n\n  ", ";\n\n  ",
    "\n\n    ", "\n"])), function (props) { return props.theme.colors.white; }, function (props) { return (!props.isCustom ? 'white-space: nowrap' : ''); }, function (props) {
    return !props.isCustom &&
        variant({
            prop: 'notePosition',
            variants: {
                // Probably need to create object mapping for this ugly repetitive code lines
                left: {
                    left: 'auto',
                    bottom: 'auto',
                    right: '100%',
                    top: '50%',
                    transform: 'translate3d(0, -50%, 0)',
                    ...getNoteMargin(props, 'x'),
                },
                right: {
                    right: 'auto',
                    bottom: 'auto',
                    left: '100%',
                    top: '50%',
                    transform: 'translate3d(0, -50%, 0)',
                    ...getNoteMargin(props, 'x'),
                },
                top: {
                    top: 'auto',
                    right: 'auto',
                    bottom: '100%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    ...getNoteMargin(props, 'y'),
                },
                bottom: {
                    bottom: 'auto',
                    right: 'auto',
                    top: '100%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    ...getNoteMargin(props, 'y'),
                },
            },
        });
}, layout);
var templateObject_1$s;
// https://github.com/styled-system/styled-system/issues/1043
// ${system({
//   noteStyle: {
//     properties: ['left', 'bottom'],
//     transform: val => val,
//   },
// })}

/**
 * detect IEEdge
 * returns version of IE/Edge or false, if browser is not a Microsoft browser
 */
function detectIEEdge() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
    // other browser
    return false;
}
var CoachMark = function (_a) {
    var children = _a.children, color = _a.color, note = _a.note, noteGap = _a.noteGap, notePosition = _a.notePosition, noteCustomStyle = _a.noteCustomStyle, padding = _a.padding, pullTop = _a.pullTop, rootMargin = _a.rootMargin, timeout = _a.timeout, onHide = _a.onHide, defaultVisible = _a.visible, width = _a.width, zIndex = _a.zIndex, _b = _a.rtl, rtl = _b === void 0 ? false : _b, style = __rest(_a, ["children", "color", "note", "noteGap", "notePosition", "noteCustomStyle", "padding", "pullTop", "rootMargin", "timeout", "onHide", "visible", "width", "zIndex", "rtl"]);
    var theme = useTheme$2();
    var _c = useState(false), visible = _c[0], setVisible = _c[1];
    var centerOfAttentionRef = useRef();
    var device = useBreakpoints();
    var _d = useInView({
        rootMargin: rootMargin,
        threshold: 1,
        triggerOnce: true,
    }), inViewRef = _d[0], inView = _d[1];
    useEffect(function () {
        if (inView) {
            if (!device.isDesktop) {
                document.body.style.overflow = 'hidden';
            }
            else {
                disableBodyScroll(null);
            }
        }
    }, [inView, device.isDesktop]);
    var timeoutID = useRef();
    // Use `useCallback` so we don't recreate the function on each render - Could result in infinite loop
    var setRefs = useCallback(function (node) {
        // Ref's from useRef needs to have the node assigned to `current`
        centerOfAttentionRef.current = node;
        // Callback refs, like the one from `useInView`, is a function that takes the node as an argument
        inViewRef(node);
    }, [inViewRef]);
    // Hides CoachMark when overlay is clicked
    var handleClickOverlay = useCallback(function () {
        if (!device.isDesktop) {
            // enable touch on responsice device
            document.body.style.overflow = '';
        }
        else {
            clearAllBodyScrollLocks();
        }
        setVisible(false);
        if (onHide) {
            onHide();
        }
    }, [setVisible, device.isDesktop, onHide]);
    useEffect(function () {
        if (timeoutID.current) {
            clearTimeout(timeoutID.current);
        }
        timeoutID.current = setTimeout(function () {
            var isVisible = defaultVisible && inView;
            setVisible(isVisible);
            if (isVisible) {
                if (!device.isDesktop) {
                    document.body.style.overflow = 'hidden';
                }
                else {
                    disableBodyScroll(null);
                }
                if (timeout) {
                    setTimeout(handleClickOverlay, timeout);
                }
            }
        }, 200);
    }, [defaultVisible, inView, device.isDesktop, handleClickOverlay, timeout]);
    var CenterOfAttention = React__default.cloneElement(children, {
        ref: setRefs,
    });
    var renderCoachMark = useCallback(function () {
        // Dont do anything if element is not available or visible=false
        if (!centerOfAttentionRef.current || !visible) {
            return null;
        }
        // Generates dynamic spotlight styles
        var spotlightStyle = getSpotlightStyle({
            centerOfAttentionRefCurrent: centerOfAttentionRef.current,
            padding: getCalcPadding(device, theme, padding),
            pullTop: getCalcPullTop(device, theme, pullTop),
            rtl: rtl,
        });
        var getHightlightedBox = function () {
            if (detectIEEdge()) {
                // If Internet Explorer
                return (React__default.createElement("div", { style: {
                        background: 'white',
                        width: spotlightStyle.width,
                        padding: getCalcPadding(device, theme, padding) - 1,
                        borderRadius: 2,
                    } }, CenterOfAttention));
            }
        };
        return createPortal(React__default.createElement(CoachMarkOverlay, { key: "coach-mark-overlay", color: color, onClick: handleClickOverlay, zIndex: zIndex },
            noteCustomStyle && note && (React__default.createElement(CoachMarkNote, { key: "coach-mark-note", color: color, isCustom: true, style: __assign({}, noteCustomStyle), width: width }, note)),
            React__default.createElement(CoachMarkSpotlight, __assign({ key: "coach-mark-spotlight", color: color, style: spotlightStyle }, style),
                getHightlightedBox(),
                !noteCustomStyle && note && (React__default.createElement(CoachMarkNote, { color: color, noteGap: noteGap, notePosition: notePosition, width: width }, note)))), document.body);
    }, [
        device,
        visible,
        CenterOfAttention,
        color,
        handleClickOverlay,
        note,
        noteCustomStyle,
        noteGap,
        notePosition,
        padding,
        pullTop,
        style,
        theme,
        width,
        zIndex,
        rtl,
    ]);
    return (React__default.createElement(React__default.Fragment, null,
        CenterOfAttention,
        renderCoachMark()));
};
CoachMark.defaultProps = {
    // Color of the overlay; note that an alpha of 0.8 will be added to the color
    color: 'black',
    borderRadius: 1,
    // Note to show
    note: null,
    // Space between the note and spotlight
    noteGap: 3,
    // Position to show the note
    notePosition: 'top',
    // Padding for the spotlight
    padding: 3,
    pullTop: 0,
    // Ref: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    rootMargin: '0px',
    timeout: 0,
    // Flag to show coach mark
    visible: false,
    zIndex: 99999,
    isStoreDrawer: false,
};

var BrandsContainer = customStyled(Flex)(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  background: transparent;\n  overflow-y: hidden;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  padding: 5px;\n\n  > div:first-of-type {\n    padding-left: 0;\n  }\n\n  > div:last-of-type {\n      padding-right: 0;\n  }\n"], ["\n  background: transparent;\n  overflow-y: hidden;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  padding: 5px;\n\n  > div:first-of-type {\n    padding-left: 0;\n  }\n\n  > div:last-of-type {\n      padding-right: 0;\n  }\n"])));
var BrandSlide = customStyled.div(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  box-sizing: content-box;\n  flex: 0 0 auto;\n  position: relative;\n  // width: 181px;\n  padding: 0px 7.5px;\n"], ["\n  box-sizing: content-box;\n  flex: 0 0 auto;\n  position: relative;\n  // width: 181px;\n  padding: 0px 7.5px;\n"])));
var BrandWrapper = customStyled(Flex)(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px 0px;\n  border-radius: 8px;\n  height: 76px;\n  width: 181px;\n  align-items: center;\n  overflow: hidden;\n  flex: 0 0 auto;\n  text-decoration: none;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:hover {\n\n    img {\n      transform: scale3d(1.03, 1.03, 1.03);\n    }\n  }\n"], ["\n  background-color: ", ";\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px 0px;\n  border-radius: 8px;\n  height: 76px;\n  width: 181px;\n  align-items: center;\n  overflow: hidden;\n  flex: 0 0 auto;\n  text-decoration: none;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:hover {\n\n    img {\n      transform: scale3d(1.03, 1.03, 1.03);\n    }\n  }\n"])), function (props) { return (props.bg ? props.bg : props.theme.colors.white); });
var BrandDetails = customStyled(Flex)(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px 0px;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  border-radius: 8px;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:hover {\n    img {\n      transform: scale3d(1.03, 1.03, 1.03);\n    }\n  }\n\n  > img {\n    max-width: 100%;\n    transition: transform 0.2s ease-in-out 0s;\n  }\n"], ["\n  background-color: ", ";\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px 0px;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  border-radius: 8px;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:hover {\n    img {\n      transform: scale3d(1.03, 1.03, 1.03);\n    }\n  }\n\n  > img {\n    max-width: 100%;\n    transition: transform 0.2s ease-in-out 0s;\n  }\n"])), function (props) { return (props.bg ? props.bg : props.theme.colors.white); });
BrandDetails.defaultProps = {
    as: 'a',
    height: ['55px', null, '66px', '75px'],
    width: ['132px', null, '158px', '180px'],
    px: [12, null, null, 3],
    py: [2, null, null, 12],
};
var BrandImageWrapper = styled.div(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  width: 148px;\n  height: 51px;\n  margin: 0px auto;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n\n  > img {\n    max-width: 100%;\n    max-height: 100%;\n    transition: transform 0.2s ease-in-out 0s;\n  }\n"], ["\n  width: 148px;\n  height: 51px;\n  margin: 0px auto;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n\n  > img {\n    max-width: 100%;\n    max-height: 100%;\n    transition: transform 0.2s ease-in-out 0s;\n  }\n"])));
var templateObject_1$t, templateObject_2$m, templateObject_3$i, templateObject_4$d, templateObject_5$9;

var Brand = function (_a) {
    var _b = _a.testId, testId = _b === void 0 ? 'trolly-brand-item' : _b, backgroundColor = _a.backgroundColor, imagePath = _a.imagePath, altText = _a.altText, href = _a.href, onClick = _a.onClick;
    return (React__default.createElement(BrandDetails, { as: "a", href: href, "data-testid": testId, bg: backgroundColor, onClick: onClick },
        React__default.createElement(Image, { testId: "brand-image", height: "auto", width: "auto", url: imagePath, name: altText })));
};

var Brands = function (_a) {
    var items = _a.items, _b = _a.testId, testId = _b === void 0 ? 'trolly-brands' : _b, _c = _a.isCarousal, isCarousal = _c === void 0 ? false : _c, onClickHandler = _a.onClickHandler, onView = _a.onView;
    useEffect(function () {
        if (onView && Array.isArray(items) && items.length > 0) {
            onView(items);
        }
    }, [onView, items]);
    var Container = isCarousal ? Carousel : BrandsContainer;
    return (React__default.createElement(Container, { "data-testid": testId }, items.map(function (item, index) {
        return (React__default.createElement(BrandSlide, { key: testId + "-" + index },
            React__default.createElement(Brand, __assign({ testId: "brand-" + testId + "-" + index }, item, { onClick: onClickHandler && onClickHandler(item.altText, index + 1) }))));
    })));
};

var HiddenImage = customStyled(Image)(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  visibility: hidden\n"], ["\n  visibility: hidden\n"])));
var TextWrapper = customStyled(Flex)(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n    flex-direction: column;\n    justify-content: center;\n    padding: 5px;\n    flex: 0 1 65%;\n"], ["\n    flex-direction: column;\n    justify-content: center;\n    padding: 5px;\n    flex: 0 1 65%;\n"])));
var TextMargin = customStyled(Flex)(templateObject_3$j || (templateObject_3$j = __makeTemplateObject(["\n    width: 90%;\n    margin: auto;\n    justify-content: center;\n    flex-direction: column;\n"], ["\n    width: 90%;\n    margin: auto;\n    justify-content: center;\n    flex-direction: column;\n"])));
var StyledText = customStyled(Text)(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n    margin-bottom: ", ";\n    margin-top: ", ";\n    font-family: 'Teshrin AR LT';\n    font-weight: ", ";\n    line-height: 1;\n    color: ", ";\n    ", "\n\n    ", "\n    ", "\n"], ["\n    margin-bottom: ", ";\n    margin-top: ", ";\n    font-family: 'Teshrin AR LT';\n    font-weight: ", ";\n    line-height: 1;\n    color: ", ";\n    ",
    "\n\n    ",
    "\n    ",
    "\n"])), function (props) { return props.isL2 && '9px'; }, function (props) { return !props.isL2 && '16px'; }, function (props) { return (props.isL2 ? props.theme.fontWeights[5] : props.theme.fontWeights[3]); }, function (props) { return (props.color ? props.color : props.theme.colors.white); }, function (props) {
    return variant({
        prop: 'as',
        variants: {
            h1: {
                fontSize: [props.theme.fontSizes[3], null, props.theme.fontSizes[5], 32],
            },
            h2: {
                fontSize: [props.theme.fontSizes[3], null, null, props.theme.fontSizes[6]],
            },
            h3: {
                fontSize: [props.theme.fontSizes[2], null, props.theme.fontSizes[3], props.theme.fontSizes[5]],
            },
            h4: {
                fontSize: [props.theme.fontSizes[1], null, props.theme.fontSizes[4]],
            },
            h5: {
                fontSize: [props.theme.fontSizes[1], null, props.theme.fontSizes[3]],
            },
            h6: {
                fontSize: props.theme.fontSizes[2],
            },
            p: {
                fontSize: props.theme.fontSizes[2],
            },
        },
    });
}, variant({
    prop: 'layout',
    variants: {
        layout_3: {
            textAlign: 'center',
        },
        layout_4: {
            textAlign: 'center',
        },
    },
}), variant({
    prop: 'bannerType',
    variants: {
        promotionalBanner: {
            textAlign: 'center',
        },
        heroBanner: {
            textAlign: 'center',
        },
        monetizationBanner: {
            textAlign: 'center',
        },
    },
}));
var BannerContainer = customStyled.div(templateObject_5$a || (templateObject_5$a = __makeTemplateObject(["\n  display: grid;\n  gap: 8px;\n\n  @media (min-width: ", ") {\n    gap: 16px;\n  }\n\n  a {\n    overflow: hidden;\n    transition: opacity 0.3s ease 0s;\n\n    &:hover img {\n      transform: scale3d(1.03, 1.03, 1.03);\n    }\n  }\n\n  ", "\n"], ["\n  display: grid;\n  gap: 8px;\n\n  @media (min-width: ", ") {\n    gap: 16px;\n  }\n\n  a {\n    overflow: hidden;\n    transition: opacity 0.3s ease 0s;\n\n    &:hover img {\n      transform: scale3d(1.03, 1.03, 1.03);\n    }\n  }\n\n  ",
    "\n"])), function (props) { return props.theme.breakpoints[2]; }, variant({
    prop: 'bannerType',
    variants: {
        '1X2Banner_1': {
            gridTemplateColumns: [null, 'repeat(2, 1fr)'],
        },
        '1X3Banner_2': {
            gridTemplateColumns: [null, 'repeat(3, 1fr)'],
        },
        '1X5Banner_4': {
            gridTemplateColumns: [null, null, '334px 1fr', '450px 1fr'],
            gridTemplateRows: [null, null, '308px'],
            a: {
                height: [120, 'auto', null, null],
            },
            '> a': {
                display: 'flex',
                flexDirection: 'column',
                height: ['auto', null, null, null],
                justifyContent: 'center',
                'div:first-of-type': {
                    justifyContent: 'center',
                },
                'div:last-of-type': {
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    padding: '0 5px 10px',
                },
            },
        },
    },
}));
var BannerWrapper = customStyled.a(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 8px;\n  display: flex;\n  text-decoration: none;\n  position: ", ";\n\n  ", ";\n\n  ", "\n\n  .error-image > img {\n    width: 200px;\n  }\n\n  button {\n    margin-top: 14px;\n    padding: ", "px;\n    \n    span {\n      font-size: ", "px;\n\n      @media (min-width: ", ") {\n        font-size: ", "px;\n      }\n    }\n\n    @media (min-width: ", ") {\n      padding: ", "px;\n    }\n  }\n"], ["\n  background-color: ", ";\n  border-radius: 8px;\n  display: flex;\n  text-decoration: none;\n  position: ", ";\n\n  ",
    ";\n\n  ",
    "\n\n  .error-image > img {\n    width: 200px;\n  }\n\n  button {\n    margin-top: 14px;\n    padding: ", "px;\n    \n    span {\n      font-size: ", "px;\n\n      @media (min-width: ", ") {\n        font-size: ", "px;\n      }\n    }\n\n    @media (min-width: ", ") {\n      padding: ", "px;\n    }\n  }\n"])), function (props) { return (props.bgColor ? props.bgColor : props.theme.colors.white); }, function (props) { return (!props.haveImages && props.haveTitles ? 'relative' : 'inherit'); }, function (props) {
    return props.backgroundImage
        ? "\n      background-image: url('" + props.backgroundImage + "');\n      background-size: cover;\n    "
        : props.gradientColor && props.bgColor && props.gradientType
            ? "background-image: " + (props.gradientType + "-gradient(" + (props.gradientType === 'linear' ? (props.gradientAngle || 0) + "deg" : props.gradientAngle || 'circle') + ", " + props.bgColor + "," + props.gradientColor) + ")"
            : '';
}, function (_a) {
    var haveImages = _a.haveImages;
    return variant({
        prop: 'bannerType',
        variants: {
            '1X2Banner_1': {
                maxHeight: haveImages ? [175, 200, null, 232] : 232,
                minHeight: 175,
            },
            '1X3Banner_2': {
                maxHeight: haveImages ? [175, 200, null, 232] : 232,
                minHeight: 175,
            },
            monetizationBanner: {
                maxHeight: haveImages ? [110, 130, null, 196] : 196,
                minHeight: 110,
            },
            promotionalBanner: {
                maxHeight: haveImages ? [180, 220, null, 309] : 309,
                minHeight: 180,
            },
            heroBanner: {
                maxHeight: 309,
                minHeight: 180,
            },
        },
    });
}, function (props) { return props.theme.space[2]; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.theme.space[3]; });
var RestBannerWrapper5in1 = customStyled.div(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n  gap: 8px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n\n  @media (min-width: ", ") {\n    gap: 16px;\n  }\n"], ["\n  gap: 8px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n\n  @media (min-width: ", ") {\n    gap: 16px;\n  }\n"])), function (props) { return props.theme.breakpoints[2]; });
var BannerImage = customStyled(Flex)(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n\n  ", "\n\n  ", "\n\n  :first-child {\n    > div {\n      align-items: ", ";\n      justify-content: ", ";\n    }\n  }\n  > div {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n    height: 100%;\n  }\n\n    img {\n      max-height: 100%;\n      max-width: 100%;\n      width: auto;\n      height: auto;\n      transition: transform 0.2s ease-in-out 0s;\n    }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n\n  ",
    "\n\n  ",
    "\n\n  :first-child {\n    > div {\n      align-items: ", ";\n      justify-content: ", ";\n    }\n  }\n  > div {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n    height: 100%;\n  }\n\n    img {\n      max-height: 100%;\n      max-width: 100%;\n      width: auto;\n      height: auto;\n      transition: transform 0.2s ease-in-out 0s;\n    }\n"])), variant({
    prop: 'bannerType',
    variants: {
        promotionalBanner: {
            flexBasis: '55%',
        },
        heroBanner: {
            flexBasis: '55%',
        },
        monetizationBanner: {
            flexBasis: '55%',
        },
        '1X2Banner_1': {
            flexBasis: ['40%', null, null, '45%'],
        },
        '1X3Banner_2': {
            flexBasis: ['40%', null, null, '45%'],
        },
        '1X5Banner_4': {
            flexBasis: ['40%', null, null, '55%'],
        },
    },
}), variant({
    prop: 'layout',
    variants: {
        layout_3: {
            flexBasis: '30%',
        },
    },
}), function (props) { return (props.layout === 'layout_3' ? 'flex-start' : 'flex-end'); }, function (props) { return (props.layout === 'layout_3' ? 'flex-start' : 'flex-end'); });
var BannerTextWrapper = customStyled.div(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  word-break: break-word;\n  z-index: 2;\n  position: ", ";\n  width: ", ";\n  height: ", ";\n\n  @media (min-width: ", ") {\n    width: ", ";\n  }\n\n  ", "\n  ", "\n"], ["\n  align-items: center;\n  display: flex;\n  word-break: break-word;\n  z-index: 2;\n  position: ", ";\n  width: ", ";\n  height: ", ";\n\n  @media (min-width: ", ") {\n    width: ", ";\n  }\n\n  ",
    "\n  ",
    "\n"])), function (props) { return (!props.haveImages && props.haveTitles ? 'absolute' : 'inherit'); }, function (props) { return (!props.haveImages && props.haveTitles ? '63%' : 'inherit'); }, function (props) { return (!props.haveImages && props.haveTitles ? '100%' : 'inherit'); }, function (props) { return props.theme.breakpoints[3]; }, function (props) { return (!props.haveImages && props.haveTitles ? '45%' : 'inherit'); }, variant({
    prop: 'bannerType',
    variants: {
        promotionalBanner: {
            textAlign: 'center',
            justifyContent: 'center',
            '> div': {
                maxWidth: 437,
                paddingLeft: [null, null, 0],
            },
            flexBasis: '45%',
        },
        heroBanner: {
            textAlign: 'center',
            justifyContent: 'center',
            '> div': {
                maxWidth: 437,
                paddingLeft: [null, null, 0],
            },
            flexBasis: '45%',
        },
        monetizationBanner: {
            textAlign: 'center',
            justifyContent: 'center',
            flexBasis: '45%',
        },
        '1X2Banner_1': {
            flexBasis: ['60%', null, null, '55%'],
        },
        '1X3Banner_2': {
            flexBasis: ['60%', null, null, '55%'],
        },
        '1X5Banner_4': {
            flexBasis: ['60%', null, null, '45%'],
        },
    },
}), variant({
    prop: 'layout',
    variants: {
        layout_3: {
            flexBasis: '40%',
        },
    },
}));
var BannerTextMargin = customStyled.div(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject(["\n  padding: 12px 0 12px 7px;\n\n  @media (min-width: ", ") {\n    padding: 20px 0 20px 16px;\n  }\n"], ["\n  padding: 12px 0 12px 7px;\n\n  @media (min-width: ", ") {\n    padding: 20px 0 20px 16px;\n  }\n"])), function (props) { return props.theme.breakpoints[3]; });
var FlexHeroWrapper = customStyled(Flex)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  max-width: 1232px;\n  margin: 0 auto;\n  position: relative;\n  width: 100%;\n\n  .carousel-inner-wrapper {\n\n    .carousel-container {\n      max-height: 180px;\n\n      @media (min-width: ", ") {\n        max-height: 256px;\n      }\n  \n      @media (min-width: ", ") {\n        max-height: 309px;\n      }\n    }\n\n    a {\n      background-position: center;\n    }\n\n    .prev-button,\n    .next-button {\n      opacity: 0;\n      transition: opacity 0.25s;\n      pointer-events: none;\n      visibility: hidden;\n\n      @media (min-width: ", ") {\n        visibility: visible;\n      }\n    }\n\n    .is-draggable {\n      @media (min-width: ", ") {\n        border-radius: 8px;\n      }\n    }\n\n    &:hover {\n      .prev-button,\n      .next-button {\n        opacity: 1;\n        pointer-events: inherit;\n      }\n\n      .banner-slide.is-selected > div {\n        transform: scale3d(1.01, 1.01, 1.01);\n      }\n    }\n  }\n"], ["\n  max-width: 1232px;\n  margin: 0 auto;\n  position: relative;\n  width: 100%;\n\n  .carousel-inner-wrapper {\n\n    .carousel-container {\n      max-height: 180px;\n\n      @media (min-width: ", ") {\n        max-height: 256px;\n      }\n  \n      @media (min-width: ", ") {\n        max-height: 309px;\n      }\n    }\n\n    a {\n      background-position: center;\n    }\n\n    .prev-button,\n    .next-button {\n      opacity: 0;\n      transition: opacity 0.25s;\n      pointer-events: none;\n      visibility: hidden;\n\n      @media (min-width: ", ") {\n        visibility: visible;\n      }\n    }\n\n    .is-draggable {\n      @media (min-width: ", ") {\n        border-radius: 8px;\n      }\n    }\n\n    &:hover {\n      .prev-button,\n      .next-button {\n        opacity: 1;\n        pointer-events: inherit;\n      }\n\n      .banner-slide.is-selected > div {\n        transform: scale3d(1.01, 1.01, 1.01);\n      }\n    }\n  }\n"])), function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.breakpoints[3]; }, function (props) { return props.theme.breakpoints[3]; });
var BannerSlide = customStyled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  flex: 0 0 auto;\n  position: relative;\n  width: 100%;\n  direction: ", ";\n\n  > div {\n    transition: transform 0.2s ease-in-out 0s;\n    height: 100%;\n  }\n  \n"], ["\n  flex: 0 0 auto;\n  position: relative;\n  width: 100%;\n  direction: ", ";\n\n  > div {\n    transition: transform 0.2s ease-in-out 0s;\n    height: 100%;\n  }\n  \n"])), function (props) { return (props.isRTL ? 'rtl' : 'ltr'); });
var templateObject_1$u, templateObject_2$n, templateObject_3$j, templateObject_4$e, templateObject_5$a, templateObject_6$7, templateObject_7$4, templateObject_8$4, templateObject_9$2, templateObject_10$2, templateObject_11, templateObject_12;

var Title$2 = function (_a) {
    var titles = _a.titles, layout = _a.layout, bannerType = _a.bannerType, haveImages = _a.haveImages, haveTitles = _a.haveTitles, testId = _a.testId;
    var sortedTitles = useMemo(function () {
        return titles ? titles.sort(function (a, b) { return a.rank - b.rank; }) : [];
    }, [titles]);
    return (React__default.createElement(BannerTextWrapper, { bannerType: bannerType, layout: layout, haveImages: haveImages, haveTitles: haveTitles, "data-testid": testId },
        React__default.createElement(BannerTextMargin, { bannerType: bannerType }, sortedTitles &&
            sortedTitles.map(function (title, index) {
                var text = title.text, color = title.color, size = title.size, isButton = title.isButton, rank = title.rank;
                return isButton ? (React__default.createElement(Button, { key: text, variant: "primary", maxWidth: ['150px', null, '250px'] },
                    React__default.createElement("span", { dangerouslySetInnerHTML: { __html: text } }))) : (React__default.createElement(StyledText, { bannerType: bannerType, isL2: rank === 1, as: size, color: color, layout: layout, key: title + "-" + index },
                    React__default.createElement("span", { dangerouslySetInnerHTML: { __html: text } })));
            }))));
};

var useImages = function (images, layout, bannerType) {
    var _a = useState({ width: '100%', padding: '0' }), imageProp = _a[0], setImageProp = _a[1];
    var _b = useState(false), isImageError = _b[0], setImageError = _b[1];
    var onErrorCb = useCallback(function () {
        setImageError(true);
        setImageProp({ width: '200px', padding: '20px' });
    }, []);
    return useMemo(function () {
        var backgroundImage = '';
        var imageName = '';
        var frontgroundImages = images.filter(function (image) { return image.properties.field === 'L2 Image'; });
        if (frontgroundImages.length > 0) {
            imageName = frontgroundImages[frontgroundImages.length - 1].properties.altText || '';
        }
        var Images = images.map(function (image, index) {
            var href = image.href, _a = image.properties, _b = _a.altText, altText = _b === void 0 ? '' : _b, field = _a.field;
            if (field === 'Background Image') {
                backgroundImage = href;
                if (!imageName) {
                    imageName = altText;
                }
                return null;
            }
            return (!isImageError && (React__default.createElement(BannerImage, { "data-testid": "banner-image-" + altText + "-wrapper", key: href + "-" + index, layout: layout, bannerType: bannerType },
                React__default.createElement("div", null,
                    React__default.createElement(Image, __assign({}, imageProp, { testId: "banner-image-" + altText, url: href, name: altText, useAltFallback: true, onErrorCb: onErrorCb }))))));
        });
        return [backgroundImage, Images, imageName];
    }, [images, imageProp, isImageError, onErrorCb, layout, bannerType]);
};

var SingleBanner = function (_a) {
    var _b = _a.details, images = _b.images, titles = _b.titles, _c = _b.layout, layout = _c === void 0 ? 'layout_1' : _c, href = _b.href, bgColor = _b.bgColor, gradientAngle = _b.gradientAngle, gradientColor = _b.gradientColor, gradientType = _b.gradientType, bannerType = _a.bannerType, _d = _a.slotNumber, slotNumber = _d === void 0 ? 1 : _d, _e = _a.inViewCarousel, inViewCarousel = _e === void 0 ? false : _e, onClickHandler = _a.onClickHandler, onViewHandler = _a.onViewHandler;
    var _f = useImages(images, layout, bannerType), backgroundImage = _f[0], Images = _f[1], imageName = _f[2];
    var _g = useInView$1({
        /* Optional options */
        threshold: 0,
    }), ref = _g[0], inView = _g[1];
    useEffect(function () {
        if (inViewCarousel && onViewHandler) {
            onViewHandler(imageName, "Slot" + slotNumber);
        }
    }, [imageName, inViewCarousel, onViewHandler, slotNumber]);
    useEffect(function () {
        if (inView && onViewHandler) {
            onViewHandler(imageName, "Slot" + slotNumber);
        }
        // eslint-disable-next-line
    }, [inView]);
    var _h = useMemo(function () {
        return [titles.filter(function (title) { return title.text; }).length > 0, Images.filter(function (image) { return image; }).length > 0];
    }, [titles, Images]), haveTitles = _h[0], haveImages = _h[1];
    var getLayoutContent = useCallback(function () {
        switch (layout) {
            case 'layout_3':
                var filteredImages = Images.filter(function (image) { return image; });
                return (React__default.createElement(React__default.Fragment, null,
                    filteredImages[0],
                    (haveTitles || haveImages) && (React__default.createElement(Title$2, { bannerType: bannerType, layout: layout, titles: titles, haveImages: haveImages, haveTitles: haveTitles })),
                    filteredImages[1]));
            case 'layout_2':
                return (React__default.createElement(React__default.Fragment, null,
                    Images,
                    (haveImages || haveTitles) && (React__default.createElement(Title$2, { bannerType: bannerType, layout: layout, titles: titles, haveImages: haveImages, haveTitles: haveTitles }))));
            default:
                return (React__default.createElement(React__default.Fragment, null,
                    (haveImages || haveTitles) && (React__default.createElement(Title$2, { bannerType: bannerType, layout: layout, titles: titles, haveImages: haveImages, haveTitles: haveTitles })),
                    Images));
        }
    }, [Images, titles, bannerType, layout, haveImages, haveTitles]);
    return (React__default.createElement(BannerWrapper, { ref: ref, backgroundImage: backgroundImage, bannerType: bannerType, bgColor: bgColor, "data-testid": "banner-wrapper-single", href: href, layout: layout, gradientAngle: gradientAngle, gradientColor: gradientColor, gradientType: gradientType, onClick: onClickHandler && onClickHandler(imageName, "Slot" + slotNumber), haveTitles: haveTitles, haveImages: haveImages },
        !haveImages && backgroundImage && (React__default.createElement(HiddenImage, { width: "100%", height: "100%", testId: "banner-image-hidden", url: backgroundImage, name: "hidden-image", useAltFallback: true, key: backgroundImage })),
        getLayoutContent()));
};

var MultiBanner = function (_a) {
    var details = _a.details, bannerType = _a.bannerType, onClickHandler = _a.onClickHandler;
    var sortedBanners = useMemo(function () { return details.sort(function (a, b) { return a.rank - b.rank; }); }, [details]);
    return (React__default.createElement(React__default.Fragment, null, sortedBanners.map(function (banner, index) {
        var href = banner.href, images = banner.images, titles = banner.titles, bgColor = banner.bgColor, gradientAngle = banner.gradientAngle, gradientColor = banner.gradientColor, gradientType = banner.gradientType, _a = banner.layout, layout = _a === void 0 ? 'layout_1' : _a;
        var _b = useImages(images, layout, bannerType), backgroundImage = _b[0], Images = _b[1], imageName = _b[2];
        var haveTitles = titles.filter(function (title) { return title.text; }).length > 0;
        var haveImages = Images.filter(function (image) { return image; }).length > 0;
        return (React__default.createElement(BannerWrapper, { bannerType: bannerType, backgroundImage: backgroundImage, bgColor: bgColor, "data-testid": "banner-wrapper-" + (index + 1), href: href, key: index, layout: "layout_1", gradientAngle: gradientAngle, gradientColor: gradientColor, gradientType: gradientType, onClick: onClickHandler && onClickHandler(imageName, index + 1), haveImages: haveImages, haveTitles: haveTitles },
            (haveImages || haveTitles) && (React__default.createElement(Title$2, { bannerType: bannerType, layout: "layout_1", titles: titles, haveImages: haveImages, haveTitles: haveTitles, testId: "text-wrapper-" + index })),
            Images,
            !haveImages && (React__default.createElement(HiddenImage, { width: "100%", height: "100%", testId: "banner-image-hidden-" + index, url: backgroundImage, name: "hidden-image", useAltFallback: true, key: backgroundImage }))));
    })));
};

var FiveBanners = function (_a) {
    var details = _a.details, bannerType = _a.bannerType, onClickHandler = _a.onClickHandler;
    var sortedBanners = useMemo(function () { return details.sort(function (a, b) { return a.rank - b.rank; }); }, [details]);
    var firstBanner = useMemo(function () { return sortedBanners[0]; }, [sortedBanners]);
    var restBanners = useMemo(function () { return sortedBanners.slice(1, sortedBanners.length); }, [sortedBanners]);
    var _b = useImages(firstBanner.images, firstBanner.layout, bannerType), firstBannerBgImage = _b[0], firstBannerImages = _b[1], firstImageName = _b[2];
    var _c = useMemo(function () {
        return [
            firstBannerImages.filter(function (image) { return image; }).length > 0,
            firstBanner.titles.filter(function (title) { return title.text; }).length > 0,
        ];
    }, [firstBannerImages, firstBanner]), firstBannerHaveImages = _c[0], firstBannerHaveTitles = _c[1];
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BannerWrapper, { bannerType: bannerType, backgroundImage: firstBannerBgImage, bgColor: firstBanner.bgColor, "data-testid": "banner-wrapper", href: firstBanner.href, layout: "layout_1", onClick: onClickHandler && onClickHandler(firstImageName, 1) },
            !firstBannerHaveImages && (React__default.createElement(HiddenImage, { width: "100%", height: "80%", testId: "banner-image-hidden", url: firstBannerBgImage, name: "hidden-image", useAltFallback: true, key: firstBannerBgImage })),
            firstBannerImages,
            (firstBannerHaveImages || firstBannerHaveTitles) && (React__default.createElement(Title$2, { bannerType: bannerType, layout: "layout_1", titles: firstBanner.titles }))),
        React__default.createElement(RestBannerWrapper5in1, null, restBanners.map(function (banner, index) {
            var bgColor = banner.bgColor, href = banner.href, images = banner.images, titles = banner.titles, _a = banner.layout, layout = _a === void 0 ? 'layout_1' : _a;
            var _b = useImages(images, layout, bannerType), backgroundImage = _b[0], Images = _b[1], imageName = _b[2];
            var haveTitles = titles.filter(function (title) { return title.text; }).length > 0;
            var haveImages = Images.filter(function (image) { return image; }).length > 0;
            var el = [];
            if (haveImages || haveTitles) {
                el.push(React__default.createElement(Title$2, { bannerType: bannerType, key: titles + "-" + index, layout: "layout_1", titles: titles, haveImages: haveImages, haveTitles: haveTitles }));
            }
            el.push(Images);
            return (React__default.createElement(BannerWrapper, { bannerType: bannerType, backgroundImage: backgroundImage, bgColor: bgColor, "data-testid": "banner-wrapper", href: href, key: index, layout: "layout_1", onClick: onClickHandler && onClickHandler(imageName, index + 1), haveImages: haveImages, haveTitles: haveTitles },
                el,
                !haveImages && (React__default.createElement(HiddenImage, { width: "100%", height: "100%", testId: "banner-image-hidden", url: backgroundImage, name: "hidden-image", useAltFallback: true, key: backgroundImage }))));
        }))));
};

var HeroBanner = function (_a) {
    var bannerType = _a.bannerType, details = _a.details, isCarouselRtl = _a.isCarouselRtl, onClickHandler = _a.onClickHandler, onViewHandler = _a.onViewHandler;
    var sortedBanners = useMemo(function () { return details.sort(function (a, b) { return a.rank - b.rank; }); }, [details]);
    var _b = useState(), selectedIndex = _b[0], setSelectedIndex = _b[1];
    var onChange = useCallback(function (selectedIndex) {
        setSelectedIndex(selectedIndex);
    }, []);
    return (React__default.createElement(FlexHeroWrapper, null,
        React__default.createElement(Carousel, { rtl: isCarouselRtl, autoPlay: 3000, options: { loop: true }, arrows: "hero", bottomNav: "flat", onAfterChange: onChange }, sortedBanners.map(function (banner, index) {
            var slotNumber = index + 1;
            var comparer = typeof selectedIndex !== 'undefined' ? selectedIndex + 1 === slotNumber : false;
            return (React__default.createElement(BannerSlide, { className: "banner-slide", key: index, isRTL: isCarouselRtl },
                React__default.createElement(BannerContainer, { bannerType: bannerType },
                    React__default.createElement(SingleBanner, { bannerType: bannerType, details: banner, inViewCarousel: comparer, onClickHandler: onClickHandler, onViewHandler: onViewHandler, slotNumber: slotNumber }))));
        }))));
};

var Banner = function (_a) {
    var details = _a.details, bannerType = _a.bannerType, onClickHandler = _a.onClickHandler, onViewHandler = _a.onViewHandler, _b = _a.rtl, rtl = _b === void 0 ? false : _b;
    var bannerProps = useMemo(function () {
        if (bannerType === 'promotionalBanner' || bannerType === 'monetizationBanner') {
            return details[0];
        }
        return details;
    }, [bannerType, details]);
    var getBannerComponent = useCallback(function () {
        switch (bannerType) {
            case '1X2Banner_1':
                return (React__default.createElement(MultiBanner, { details: bannerProps, bannerType: bannerType, onClickHandler: onClickHandler }));
            case '1X5Banner_4':
                return (React__default.createElement(FiveBanners, { details: bannerProps, bannerType: bannerType, onClickHandler: onClickHandler }));
            case '1X3Banner_2':
                return (React__default.createElement(MultiBanner, { details: bannerProps, bannerType: bannerType, onClickHandler: onClickHandler }));
            default:
                return (React__default.createElement(SingleBanner, { onViewHandler: onViewHandler, details: bannerProps, bannerType: bannerType, onClickHandler: onClickHandler }));
        }
    }, [bannerType, bannerProps, onClickHandler, onViewHandler]);
    return bannerType !== 'heroBanner' ? (React__default.createElement(BannerContainer, { "data-testid": "banner-container", bannerType: bannerType }, getBannerComponent())) : (React__default.createElement(HeroBanner, { "data-test-id": "hero-banner", details: bannerProps, bannerType: bannerType, isCarouselRtl: rtl, onClickHandler: onClickHandler, onViewHandler: onViewHandler }));
};

var getFontSizes = function (props) {
    var items = {
        home: {
            'hero-banner': {
                h1: [props.theme.fontSizes[4], null, null, 38],
                h2: [props.theme.fontSizes[2], null, null, props.theme.fontSizes[6]],
            },
            'promotional-banner': {
                h1: [props.theme.fontSizes[3], null, null, 36],
                h2: [props.theme.fontSizes[1], null, null, props.theme.fontSizes[6]],
            },
            '2-in-1': {
                h1: [props.theme.fontSizes[5], null, null, 32],
                h2: [props.theme.fontSizes[3], null, null, props.theme.fontSizes[6]],
            },
            '3-in-1': {
                h1: [props.theme.fontSizes[5], null, null, 32],
                h2: [props.theme.fontSizes[3], null, null, props.theme.fontSizes[6]],
            },
        },
        clp: {
            'hero-banner': {
                h1: [props.theme.fontSizes[4], null, null, 32],
                h2: [props.theme.fontSizes[2], null, null, props.theme.fontSizes[6]],
            },
            'promotional-banner': {
                h1: [props.theme.fontSizes[3], null, null, props.theme.fontSizes[6]],
                h2: [props.theme.fontSizes[1], null, null, props.theme.fontSizes[5]],
            },
            '2-in-1': {
                h1: [props.theme.fontSizes[5], null, null, 28],
                h2: [props.theme.fontSizes[3], null, null, props.theme.fontSizes[6]],
            },
            '3-in-1': {
                h1: [props.theme.fontSizes[5], null, null, props.theme.fontSizes[6]],
                h2: [props.theme.fontSizes[3], null, null, props.theme.fontSizes[3]],
            },
        },
    };
    return items[props.page][props.bannerType];
};

var BANNER_TYPE;
(function (BANNER_TYPE) {
    BANNER_TYPE["HERO_BANNER"] = "hero-banner";
    BANNER_TYPE["PROMOTIONAL_BANNER"] = "promotional-banner";
    BANNER_TYPE["MONETIZATION_BANNER"] = "monetization-banner";
    BANNER_TYPE["TWO_IN_ONE"] = "2-in-1";
    BANNER_TYPE["THREE_IN_ONE"] = "3-in-1";
    BANNER_TYPE["FIVE_IN_ONE"] = "5-in-1";
})(BANNER_TYPE || (BANNER_TYPE = {}));

var _a$5, _b;
var fontFamily = 'Teshrin AR LT';
var HiddenImage$1 = customStyled(Image)(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n  visibility: hidden\n"], ["\n  visibility: hidden\n"])));
var TextWrapper$1 = customStyled(Flex)(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n    flex-direction: column;\n    justify-content: center;\n    padding: 5px;\n    flex: 0 1 65%;\n"], ["\n    flex-direction: column;\n    justify-content: center;\n    padding: 5px;\n    flex: 0 1 65%;\n"])));
var TextMargin$1 = customStyled(Flex)(templateObject_3$k || (templateObject_3$k = __makeTemplateObject(["\n    width: 90%;\n    margin: auto;\n    justify-content: center;\n    flex-direction: column;\n"], ["\n    width: 90%;\n    margin: auto;\n    justify-content: center;\n    flex-direction: column;\n"])));
var StyledText$1 = customStyled(Text)(templateObject_4$f || (templateObject_4$f = __makeTemplateObject(["\n    font-family: ", ";\n    line-height: 1.3;\n    font-weight: ", ";\n    color: ", ";\n    ", "\n    @media (max-width: ", ") {\n      ", "\n    }\n\n    ", "\n    ", "\n"], ["\n    font-family: ", ";\n    line-height: 1.3;\n    font-weight: ", ";\n    color: ", ";\n    ",
    "\n    @media (max-width: ", ") {\n      ",
    "\n    }\n\n    ",
    "\n    ",
    "\n"])), fontFamily, function (_a) {
    var isL2 = _a.isL2;
    return (isL2 ? 'normal' : 600);
}, function (props) { return (props.color ? props.color : props.theme.colors.white); }, function (_a) {
    var isL2 = _a.isL2;
    return isL2 &&
        "\n      margin-top: 16px;\n    ";
}, function (props) { return props.theme.breakpoints[3]; }, function (_a) {
    var isL2 = _a.isL2;
    return isL2 &&
        "\n        margin-top: 12px;\n      ";
}, function (props) {
    var fiveInOneMobileSize = 14;
    if (props === null || props === void 0 ? void 0 : props.isFirstBanner) {
        fiveInOneMobileSize = 20;
    }
    var fontSize = getFontSizes(props);
    return variant({
        prop: 'as',
        variants: {
            h1: {
                fontSize: (fontSize === null || fontSize === void 0 ? void 0 : fontSize.h1) || 32,
            },
            h2: {
                fontSize: (fontSize === null || fontSize === void 0 ? void 0 : fontSize.h2) || 24,
            },
            h3: {
                fontSize: [props.theme.fontSizes[2], null, props.theme.fontSizes[3], props.theme.fontSizes[5]],
            },
            h4: {
                fontSize: [fiveInOneMobileSize, null, null, 24],
            },
            h5: {
                fontSize: [props.theme.fontSizes[1], null, null, props.theme.fontSizes[3]],
            },
            h6: {
                fontSize: props.theme.fontSizes[2],
            },
            p: {
                fontSize: props.theme.fontSizes[2],
            },
        },
    });
}, variant({
    prop: 'bannerType',
    variants: (_a$5 = {},
        _a$5[BANNER_TYPE.PROMOTIONAL_BANNER] = {
            textAlign: 'center',
        },
        _a$5[BANNER_TYPE.HERO_BANNER] = {
            textAlign: ['left', null, null, 'center'],
        },
        _a$5[BANNER_TYPE.MONETIZATION_BANNER] = {
            textAlign: 'center',
        },
        _a$5),
}));
var BannerContainer$1 = customStyled.div(templateObject_5$b || (templateObject_5$b = __makeTemplateObject(["\n  display: grid;\n  gap: 8px;\n\n  @media (min-width: ", ") {\n    gap: 16px;\n  }\n\n  a {\n    overflow: hidden;\n    transition: opacity 0.3s ease 0s;\n\n    &:hover img {\n      transform: scale3d(1.03, 1.03, 1.03);\n    }\n  }\n  ", "\n"], ["\n  display: grid;\n  gap: 8px;\n\n  @media (min-width: ", ") {\n    gap: 16px;\n  }\n\n  a {\n    overflow: hidden;\n    transition: opacity 0.3s ease 0s;\n\n    &:hover img {\n      transform: scale3d(1.03, 1.03, 1.03);\n    }\n  }\n  ",
    "\n"])), function (props) { return props.theme.breakpoints[2]; }, function (_a) {
    var _b;
    var page = _a.page;
    return variant({
        prop: 'bannerType',
        variants: (_b = {},
            _b[BANNER_TYPE.TWO_IN_ONE] = {
                gridTemplateColumns: [null, 'repeat(2, 1fr)'],
            },
            _b[BANNER_TYPE.THREE_IN_ONE] = {
                gridTemplateColumns: [null, 'repeat(3, 1fr)'],
            },
            _b[BANNER_TYPE.FIVE_IN_ONE] = {
                gridTemplateColumns: [null, null, '334px 1fr', page === 'clp' ? '354px 1fr' : '450px 1fr'],
                gridTemplateRows: [null, null, '308px'],
                a: {
                    height: [120, 'auto', null, null],
                },
                '> a': {
                    display: 'flex',
                    flexDirection: 'column',
                    height: ['auto', null, null, null],
                    justifyContent: 'center',
                    'div:first-of-type': {
                        justifyContent: 'center',
                    },
                    'div:last-of-type': {
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                    },
                },
            },
            _b),
    });
});
var BannerWrapper$1 = customStyled.a(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 8px;\n  display: flex;\n  text-decoration: none;\n  position: ", ";\n  ", "\n  ", "\n\n  .error-image > img {\n    width: 200px;\n  }\n\n  button {\n    margin-top: 14px;\n    padding: ", "px;\n    \n    span {\n      font-size: ", "px;\n\n      @media (min-width: ", ") {\n        font-size: ", "px;\n      }\n    }\n\n    @media (min-width: ", ") {\n      padding: ", "px;\n    }\n  }\n"], ["\n  background-color: ", ";\n  border-radius: 8px;\n  display: flex;\n  text-decoration: none;\n  position: ", ";\n  ",
    "\n  ",
    "\n\n  .error-image > img {\n    width: 200px;\n  }\n\n  button {\n    margin-top: 14px;\n    padding: ", "px;\n    \n    span {\n      font-size: ", "px;\n\n      @media (min-width: ", ") {\n        font-size: ", "px;\n      }\n    }\n\n    @media (min-width: ", ") {\n      padding: ", "px;\n    }\n  }\n"])), function (props) { return (props.bgColor ? props.bgColor : props.theme.colors.white); }, function (props) { return (!props.haveImages && props.haveTitles ? 'relative' : 'inherit'); }, function (props) {
    return props.backgroundImage &&
        " background-image: url('" + props.backgroundImage + "');\n      background-size: cover;";
}, function (_a) {
    var _b;
    var haveImages = _a.haveImages, page = _a.page;
    var maxHeight = page === 'clp' ? 157 : 196;
    return variant({
        prop: 'bannerType',
        variants: (_b = {},
            _b[BANNER_TYPE.TWO_IN_ONE] = {
                maxHeight: haveImages ? [175, 200, null, 232] : 232,
                minHeight: [175, 200, null, 232],
            },
            _b[BANNER_TYPE.THREE_IN_ONE] = {
                maxHeight: haveImages ? [175, 200, null, 232] : 232,
                minHeight: [175, 200, null, 232],
            },
            _b[BANNER_TYPE.MONETIZATION_BANNER] = {
                maxHeight: haveImages ? [110, 130, null, maxHeight] : maxHeight,
                minHeight: 110,
            },
            _b[BANNER_TYPE.PROMOTIONAL_BANNER] = {
                maxHeight: haveImages ? [110, 130, null, maxHeight] : maxHeight,
                minHeight: 110,
            },
            _b[BANNER_TYPE.HERO_BANNER] = {
                maxHeight: 309,
                minHeight: [180, null, 309, 309],
            },
            _b),
    });
}, function (props) { return props.theme.space[2]; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.theme.space[3]; });
var RestBannerWrapper5in1$1 = customStyled.div(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["\n  gap: 8px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n\n  @media (min-width: ", ") {\n    gap: 16px;\n  }\n"], ["\n  gap: 8px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n\n  @media (min-width: ", ") {\n    gap: 16px;\n  }\n"])), function (props) { return props.theme.breakpoints[2]; });
var BannerImage$1 = customStyled(Flex)(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject(["\n  flex-direction: column;\n  justify-content: flex-end;\n\n  ", "\n\n  :first-child {\n    > div {\n      align-items: flex-end;\n      justify-content: flex-end;\n    }\n  }\n  > div {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n    height: 100%;\n  }\n\n  img {\n    max-height: 100%;\n    max-width: 100%;\n    width: auto;\n    height: auto;\n    transition: transform 0.2s ease-in-out 0s;\n  }\n"], ["\n  flex-direction: column;\n  justify-content: flex-end;\n\n  ",
    "\n\n  :first-child {\n    > div {\n      align-items: flex-end;\n      justify-content: flex-end;\n    }\n  }\n  > div {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n    height: 100%;\n  }\n\n  img {\n    max-height: 100%;\n    max-width: 100%;\n    width: auto;\n    height: auto;\n    transition: transform 0.2s ease-in-out 0s;\n  }\n"])), function (_a) {
    var _b;
    var page = _a.page;
    var threeInOneDesktop = '43%';
    var twoInOneDesktop = '41%';
    if (page === 'home') {
        threeInOneDesktop = '45%';
        twoInOneDesktop = '33%';
    }
    return variant({
        prop: 'bannerType',
        variants: (_b = {},
            _b[BANNER_TYPE.PROMOTIONAL_BANNER] = {
                flexBasis: '55%',
            },
            _b[BANNER_TYPE.HERO_BANNER] = {
                flexBasis: '50%',
            },
            _b[BANNER_TYPE.MONETIZATION_BANNER] = {
                flexBasis: '55%',
            },
            _b[BANNER_TYPE.TWO_IN_ONE] = {
                flexBasis: ['40%', null, null, twoInOneDesktop],
            },
            _b[BANNER_TYPE.THREE_IN_ONE] = {
                flexBasis: ['40%', null, null, threeInOneDesktop],
            },
            _b[BANNER_TYPE.FIVE_IN_ONE] = {
                flexBasis: ['45%', null, null, '38%'],
            },
            _b),
    });
});
var BannerTextWrapper$1 = customStyled.div(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  word-break: break-word;\n  z-index: 2;\n  position: ", ";\n  width: ", ";\n  height: ", ";\n\n  @media (min-width: ", ") {\n    width: ", ";\n  }\n  ", "\n"], ["\n  align-items: center;\n  display: flex;\n  word-break: break-word;\n  z-index: 2;\n  position: ", ";\n  width: ", ";\n  height: ", ";\n\n  @media (min-width: ", ") {\n    width: ", ";\n  }\n  ",
    "\n"])), function (props) { return (!props.haveImages && props.haveTitles ? 'absolute' : 'inherit'); }, function (props) { return (!props.haveImages && props.haveTitles ? '63%' : 'inherit'); }, function (props) { return (!props.haveImages && props.haveTitles ? '100%' : 'inherit'); }, function (props) { return props.theme.breakpoints[3]; }, function (props) { return (!props.haveImages && props.haveTitles ? '55%' : 'inherit'); }, function (_a) {
    var _b;
    var page = _a.page;
    var threeInOneDesktop = '57%';
    var twoInOneDesktop = '59%';
    if (page === 'home') {
        threeInOneDesktop = '55%';
        twoInOneDesktop = '67%';
    }
    return variant({
        prop: 'bannerType',
        variants: (_b = {},
            _b[BANNER_TYPE.PROMOTIONAL_BANNER] = {
                textAlign: 'center',
                justifyContent: 'center',
                flexBasis: '45%',
            },
            _b[BANNER_TYPE.HERO_BANNER] = {
                textAlign: 'center',
                justifyContent: 'center',
                flexBasis: '50%',
            },
            _b[BANNER_TYPE.MONETIZATION_BANNER] = {
                textAlign: 'center',
                justifyContent: 'center',
                flexBasis: '45%',
            },
            _b[BANNER_TYPE.TWO_IN_ONE] = {
                flexBasis: ['60%', null, null, twoInOneDesktop],
            },
            _b[BANNER_TYPE.THREE_IN_ONE] = {
                flexBasis: ['60%', null, null, threeInOneDesktop],
            },
            _b[BANNER_TYPE.FIVE_IN_ONE] = {
                flexBasis: ['55%', null, null, '62%'],
            },
            _b),
    });
});
var BannerTextMargin$1 = customStyled(Box)(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), variant({
    prop: 'bannerType',
    variants: (_b = {},
        _b[BANNER_TYPE.FIVE_IN_ONE] = {
            paddingRight: 0,
        },
        _b[BANNER_TYPE.HERO_BANNER] = {
            padding: [16, null, null, 20],
        },
        _b),
}));
BannerTextMargin$1.defaultProps = {
    padding: [10, null, null, 20],
};
var FlexHeroWrapper$1 = customStyled(Flex)(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n  max-width: 1232px;\n  margin: 0 auto;\n  position: relative;\n  width: 100%;\n\n  .carousel-inner-wrapper {\n\n    .carousel-container {\n      max-height: 180px;\n\n      @media (min-width: ", ") {\n        max-height: 256px;\n      }\n  \n      @media (min-width: ", ") {\n        max-height: 309px;\n      }\n    }\n\n    a {\n      background-position: center;\n    }\n\n    .prev-button,\n    .next-button {\n      opacity: 0;\n      transition: opacity 0.25s;\n      pointer-events: none;\n      visibility: hidden;\n\n      @media (min-width: ", ") {\n        visibility: visible;\n      }\n    }\n\n    .is-draggable {\n      @media (min-width: ", ") {\n        border-radius: 8px;\n      }\n    }\n\n    &:hover {\n      .prev-button,\n      .next-button {\n        opacity: 1;\n        pointer-events: inherit;\n      }\n\n      .banner-slide.is-selected > div {\n        ", "\n      }\n    }\n  }\n"], ["\n  max-width: 1232px;\n  margin: 0 auto;\n  position: relative;\n  width: 100%;\n\n  .carousel-inner-wrapper {\n\n    .carousel-container {\n      max-height: 180px;\n\n      @media (min-width: ", ") {\n        max-height: 256px;\n      }\n  \n      @media (min-width: ", ") {\n        max-height: 309px;\n      }\n    }\n\n    a {\n      background-position: center;\n    }\n\n    .prev-button,\n    .next-button {\n      opacity: 0;\n      transition: opacity 0.25s;\n      pointer-events: none;\n      visibility: hidden;\n\n      @media (min-width: ", ") {\n        visibility: visible;\n      }\n    }\n\n    .is-draggable {\n      @media (min-width: ", ") {\n        border-radius: 8px;\n      }\n    }\n\n    &:hover {\n      .prev-button,\n      .next-button {\n        opacity: 1;\n        pointer-events: inherit;\n      }\n\n      .banner-slide.is-selected > div {\n        ",
    "\n      }\n    }\n  }\n"])), function (props) { return props.theme.breakpoints[1]; }, function (props) { return props.theme.breakpoints[2]; }, function (props) { return props.theme.breakpoints[3]; }, function (props) { return props.theme.breakpoints[3]; }, function (props) {
    return props.isHover &&
        "\n          transform: scale3d(1.01, 1.01, 1.01);\n        ";
});
var BannerSlide$1 = customStyled.div(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n  flex: 0 0 auto;\n  position: relative;\n  width: 100%;\n  direction: ", ";\n\n  > div {\n    transition: transform 0.2s ease-in-out 0s;\n    height: 100%;\n  }\n  \n"], ["\n  flex: 0 0 auto;\n  position: relative;\n  width: 100%;\n  direction: ", ";\n\n  > div {\n    transition: transform 0.2s ease-in-out 0s;\n    height: 100%;\n  }\n  \n"])), function (props) { return (props.isRTL ? 'rtl' : 'ltr'); });
var templateObject_1$v, templateObject_2$o, templateObject_3$k, templateObject_4$f, templateObject_5$b, templateObject_6$8, templateObject_7$5, templateObject_8$5, templateObject_9$3, templateObject_10$3, templateObject_11$1, templateObject_12$1;

var _a$6;
var BannersMap = (_a$6 = {},
    _a$6[BANNER_TYPE.TWO_IN_ONE] = {
        title: {
            size: 'h1',
        },
        subtitle: {
            size: 'h2',
        },
    },
    _a$6[BANNER_TYPE.THREE_IN_ONE] = {
        title: {
            size: 'h1',
        },
        subtitle: {
            size: 'h2',
        },
    },
    _a$6[BANNER_TYPE.FIVE_IN_ONE] = {
        title: {
            size: 'h4',
        },
        subtitle: {
            size: 'h5',
        },
    },
    _a$6[BANNER_TYPE.HERO_BANNER] = {
        title: {
            size: 'h1',
        },
        subtitle: {
            size: 'h2',
        },
    },
    _a$6[BANNER_TYPE.PROMOTIONAL_BANNER] = {
        title: {
            size: 'h1',
        },
        subtitle: {
            size: 'h2',
        },
    },
    _a$6[BANNER_TYPE.MONETIZATION_BANNER] = {
        title: {
            size: 'h1',
        },
        subtitle: {
            size: 'h2',
        },
    },
    _a$6);
var Title$3 = function (_a) {
    var _b, _c;
    var title = _a.title, bannerType = _a.bannerType, haveImage = _a.haveImage, haveTitle = _a.haveTitle, testId = _a.testId, fontColor = _a.fontColor, subtitle = _a.subtitle, _d = _a.isFirstBanner, isFirstBanner = _d === void 0 ? false : _d, _e = _a.page, page = _e === void 0 ? 'clp' : _e;
    return (React__default.createElement(BannerTextWrapper$1, { page: page, bannerType: bannerType, haveImages: haveImage, haveTitles: haveTitle, "data-testid": testId },
        React__default.createElement(BannerTextMargin$1, { bannerType: bannerType },
            React__default.createElement(StyledText$1, { page: page, bannerType: bannerType, color: fontColor, as: (_b = BannersMap[bannerType]) === null || _b === void 0 ? void 0 : _b.title.size, isFirstBanner: isFirstBanner },
                React__default.createElement("span", { dangerouslySetInnerHTML: { __html: title } })),
            subtitle && (React__default.createElement(StyledText$1, { bannerType: bannerType, color: fontColor, as: (_c = BannersMap[bannerType]) === null || _c === void 0 ? void 0 : _c.subtitle.size, subtitle: true, isL2: true, page: page }, subtitle && React__default.createElement("span", { dangerouslySetInnerHTML: { __html: subtitle } }))))));
};

var useImages$1 = function (image, bannerType, altText, mediaMobile, page) {
    if (image === void 0) { image = ''; }
    if (altText === void 0) { altText = ''; }
    if (mediaMobile === void 0) { mediaMobile = ''; }
    if (page === void 0) { page = 'clp'; }
    var _a = useState({ width: '100%', padding: '0', loading: 'lazy' }), imageProp = _a[0], setImageProp = _a[1];
    var _b = useState(false), isImageError = _b[0], setImageError = _b[1];
    var isMobile = useBreakpoints().isMobile;
    var onErrorCb = useCallback(function () {
        setImageError(true);
        setImageProp({ width: '200px', padding: '20px', loading: 'lazy' });
    }, []);
    var Images = !isImageError && (React__default.createElement(BannerImage$1, { page: page, "data-testid": "banner-image-wrapper", key: "" + image, bannerType: bannerType },
        React__default.createElement("div", null,
            React__default.createElement(Image, __assign({}, imageProp, { testId: "banner-image-" + altText, url: !isMobile ? image : mediaMobile || image, name: altText, useAltFallback: true, onErrorCb: onErrorCb, "data-size": "big" })))));
    return [Images, '', altText];
};

var NewSingleBanner = function (_a) {
    var _b = _a.details, _c = _b.media_web, image = _c === void 0 ? '' : _c, _d = _b.media_mobile, mediaMobile = _d === void 0 ? '' : _d, _e = _b.title, title = _e === void 0 ? '' : _e, _f = _b.subtitle, subtitle = _f === void 0 ? '' : _f, href = _b.cta_url_web, bgColor = _b.background_color, backgroundImage = _b.background_image_web, color = _b.font_color, _g = _b.alt_text, altText = _g === void 0 ? '' : _g, bannerType = _a.bannerType, _h = _a.slotNumber, slotNumber = _h === void 0 ? 1 : _h, _j = _a.inViewCarousel, inViewCarousel = _j === void 0 ? false : _j, onClickHandler = _a.onClickHandler, onViewHandler = _a.onViewHandler, page = _a.page;
    var _k = useImages$1(image, bannerType, altText, mediaMobile), Images = _k[0], imageName = _k[1];
    var _l = useInView$1({
        /* Optional options */
        threshold: 0,
    }), ref = _l[0], inView = _l[1];
    useEffect(function () {
        if (inViewCarousel && onViewHandler) {
            onViewHandler(imageName, "Slot" + slotNumber);
        }
    }, [imageName, inViewCarousel, onViewHandler, slotNumber]);
    useEffect(function () {
        if (inView && onViewHandler) {
            onViewHandler(imageName, "Slot" + slotNumber);
        }
        // eslint-disable-next-line
    }, [inView]);
    var haveTitles = (title === null || title === void 0 ? void 0 : title.length) > 0;
    var haveImages = (image === null || image === void 0 ? void 0 : image.length) > 0;
    return (React__default.createElement(BannerWrapper$1, { ref: ref, backgroundImage: backgroundImage, bannerType: bannerType, bgColor: bgColor, "data-testid": "banner-wrapper-single", href: href, onClick: onClickHandler && onClickHandler(imageName, "Slot" + slotNumber), haveTitles: haveTitles, haveImages: haveImages, page: page },
        !haveImages && backgroundImage && (React__default.createElement(HiddenImage$1, { width: "100%", height: "100%", testId: "banner-image-hidden", url: backgroundImage, name: "hidden-image", useAltFallback: true, key: backgroundImage })),
        (haveImages || haveTitles) && title && (React__default.createElement(Title$3, { bannerType: bannerType, title: title, subtitle: subtitle, haveImage: haveImages, haveTitle: haveTitles, fontColor: color, page: page })),
        image && Images));
};

var MultiBanner$1 = function (_a) {
    var details = _a.details, bannerType = _a.bannerType, onClickHandler = _a.onClickHandler, page = _a.page;
    return (React__default.createElement(React__default.Fragment, null, details.map(function (banner, index) {
        var bgColor = banner.background_color, _a = banner.background_image_web, backgroundImage = _a === void 0 ? '' : _a, _b = banner.title, title = _b === void 0 ? '' : _b, subtitle = banner.subtitle, font_color = banner.font_color, _c = banner.media_web, media_web = _c === void 0 ? '' : _c, href = banner.cta_url_web, id = banner.id, _d = banner.alt_text, altText = _d === void 0 ? '' : _d, _e = banner.media_mobile, mediaMobile = _e === void 0 ? '' : _e;
        var _f = useImages$1(media_web, bannerType, altText, mediaMobile), Images = _f[0], imageName = _f[1];
        var haveTitle = (title === null || title === void 0 ? void 0 : title.length) > 0;
        var haveImage = (media_web === null || media_web === void 0 ? void 0 : media_web.length) > 0;
        return (React__default.createElement(BannerWrapper$1, { bannerType: bannerType, backgroundImage: backgroundImage, bgColor: bgColor, "data-testid": "banner-wrapper-" + index, href: href, key: id, onClick: onClickHandler && onClickHandler(imageName, id), haveImages: haveImage, haveTitles: haveTitle, page: page },
            (haveImage || haveTitle) && (React__default.createElement(Title$3, { bannerType: bannerType, title: title, fontColor: font_color, subtitle: subtitle, haveImage: haveImage, haveTitle: haveTitle, testId: "text-wrapper-" + index, page: page })),
            Images,
            !haveImage && (React__default.createElement(HiddenImage$1, { width: "100%", height: "100%", testId: "banner-image-hidden-" + index, url: backgroundImage, name: "hidden-image", useAltFallback: true, key: backgroundImage }))));
    })));
};

var FiveBanners$1 = function (_a) {
    var details = _a.details, bannerType = _a.bannerType, onClickHandler = _a.onClickHandler, page = _a.page;
    var firstBanner = useMemo(function () { return details[0]; }, [details]);
    var restBanners = useMemo(function () { return details.slice(1, details.length); }, [details]);
    var bgColor = firstBanner.background_color, href = firstBanner.cta_url_web, _b = firstBanner.media_web, image = _b === void 0 ? '' : _b, _c = firstBanner.title, title = _c === void 0 ? '' : _c, _d = firstBanner.background_image_web, firstBannerBgImage = _d === void 0 ? '' : _d, _e = firstBanner.alt_text, altText = _e === void 0 ? '' : _e, _f = firstBanner.media_mobile, mediaMobile = _f === void 0 ? '' : _f;
    var _g = useImages$1(image, bannerType, altText, mediaMobile), firstBannerImages = _g[0], firstImageName = _g[1];
    var firstBannerHaveTitles = (title === null || title === void 0 ? void 0 : title.length) > 0;
    var firstBannerHaveImages = (image === null || image === void 0 ? void 0 : image.length) > 0;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BannerWrapper$1, { bannerType: bannerType, backgroundImage: firstBannerBgImage, bgColor: bgColor, "data-testid": "banner-wrapper", href: href, onClick: onClickHandler && onClickHandler(firstImageName, 1), page: page },
            !firstBannerHaveImages && (React__default.createElement(HiddenImage$1, { width: "100%", height: "80%", testId: "banner-image-hidden", url: firstBannerBgImage, name: "hidden-image", useAltFallback: true, key: firstBannerBgImage })),
            firstBannerImages,
            (firstBannerHaveImages || firstBannerHaveTitles) && (React__default.createElement(Title$3, { bannerType: bannerType, title: firstBanner.title || '', fontColor: firstBanner.font_color, isL2: true, isFirstBanner: true, page: page }))),
        React__default.createElement(RestBannerWrapper5in1$1, null, restBanners.map(function (banner, index) {
            var bgColor = banner.background_color, href = banner.cta_url_web, _a = banner.media_web, image = _a === void 0 ? '' : _a, _b = banner.title, title = _b === void 0 ? '' : _b, _c = banner.background_image_web, backgroundImage = _c === void 0 ? '' : _c, id = banner.id, _d = banner.alt_text, altText = _d === void 0 ? '' : _d, _e = banner.font_color, font_color = _e === void 0 ? '' : _e, _f = banner.media_mobile, mediaMobile = _f === void 0 ? '' : _f;
            var _g = useImages$1(image, bannerType, altText, mediaMobile), Images = _g[0], imageName = _g[1];
            var haveTitles = (title === null || title === void 0 ? void 0 : title.length) > 0;
            var haveImages = (image === null || image === void 0 ? void 0 : image.length) > 0;
            var el = [];
            if (haveImages || haveTitles) {
                el.push(React__default.createElement(Title$3, { bannerType: bannerType, key: title + "-" + id, title: title, haveImage: haveImages, haveTitle: haveTitles, fontColor: font_color, page: page }));
            }
            el.push(Images);
            return (React__default.createElement(BannerWrapper$1, { bannerType: bannerType, backgroundImage: backgroundImage, bgColor: bgColor, "data-testid": "banner-wrapper", href: href, key: index, onClick: onClickHandler && onClickHandler(imageName, index + 1), haveImages: haveImages, haveTitles: haveTitles, page: page },
                el,
                !haveImages && (React__default.createElement(HiddenImage$1, { width: "100%", height: "100%", testId: "banner-image-hidden", url: backgroundImage, name: "hidden-image", useAltFallback: true, key: backgroundImage }))));
        }))));
};

var HeroBanner$1 = function (_a) {
    var bannerType = _a.bannerType, details = _a.details, isCarouselRtl = _a.isCarouselRtl, onClickHandler = _a.onClickHandler, onViewHandler = _a.onViewHandler, page = _a.page;
    var _b = useState(), selectedIndex = _b[0], setSelectedIndex = _b[1];
    var onChange = useCallback(function (selectedIndex) {
        setSelectedIndex(selectedIndex);
    }, []);
    return (React__default.createElement(FlexHeroWrapper$1, { isHover: details.length > 1 },
        React__default.createElement(Carousel, { rtl: isCarouselRtl, autoPlay: 3000, options: { loop: true }, arrows: "hero", bottomNav: "flat", onAfterChange: onChange }, details.map(function (banner, index) {
            var slotNumber = index + 1;
            var comparer = typeof selectedIndex !== 'undefined' ? selectedIndex + 1 === slotNumber : false;
            return (React__default.createElement(BannerSlide$1, { className: "banner-slide", key: index, isRTL: isCarouselRtl },
                React__default.createElement(BannerContainer$1, { bannerType: bannerType },
                    React__default.createElement(NewSingleBanner, { bannerType: bannerType, details: banner, inViewCarousel: comparer, onClickHandler: onClickHandler, onViewHandler: onViewHandler, slotNumber: slotNumber, page: page }))));
        }))));
};

var NewBanner = function (_a) {
    var details = _a.details, bannerType = _a.bannerType, onClickHandler = _a.onClickHandler, onViewHandler = _a.onViewHandler, _b = _a.rtl, rtl = _b === void 0 ? false : _b, _c = _a.page, page = _c === void 0 ? 'clp' : _c;
    var bannerProps = useMemo(function () {
        if (bannerType === BANNER_TYPE.PROMOTIONAL_BANNER || bannerType === BANNER_TYPE.MONETIZATION_BANNER) {
            return details[0];
        }
        return details;
    }, [bannerType, details]);
    var getBannerComponent = useCallback(function () {
        switch (bannerType) {
            case BANNER_TYPE.TWO_IN_ONE:
                return (React__default.createElement(MultiBanner$1, { details: bannerProps, bannerType: bannerType, onClickHandler: onClickHandler, page: page }));
            case BANNER_TYPE.FIVE_IN_ONE:
                return (React__default.createElement(FiveBanners$1, { details: bannerProps, bannerType: bannerType, onClickHandler: onClickHandler, page: page }));
            case BANNER_TYPE.THREE_IN_ONE:
                return (React__default.createElement(MultiBanner$1, { details: bannerProps, bannerType: bannerType, onClickHandler: onClickHandler, page: page }));
            default:
                return (React__default.createElement(NewSingleBanner, { onViewHandler: onViewHandler, details: bannerProps, bannerType: bannerType, onClickHandler: onClickHandler, page: page }));
        }
    }, [bannerType, bannerProps, onClickHandler, onViewHandler, page]);
    return bannerType !== BANNER_TYPE.HERO_BANNER ? (React__default.createElement(BannerContainer$1, { page: page, "data-testid": "banner-container", bannerType: bannerType }, getBannerComponent())) : (React__default.createElement(HeroBanner$1, { "data-test-id": "hero-banner", details: bannerProps, bannerType: bannerType, isCarouselRtl: rtl, onClickHandler: onClickHandler, onViewHandler: onViewHandler, page: page }));
};

var performanceNow = createCommonjsModule(function (module) {
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }
}).call(commonjsGlobal);
});

var root = typeof window === 'undefined' ? commonjsGlobal : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix];
for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix];
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix];
}
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60;
  raf = function(callback) {
    if(queue.length === 0) {
      var _now = performanceNow()
        , next = Math.max(0, frameDuration - (_now - last));
      last = next + _now;
      setTimeout(function() {
        var cp = queue.slice(0);
        queue.length = 0;
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last);
            } catch(e) {
              setTimeout(function() { throw e }, 0);
            }
          }
        }
      }, Math.round(next));
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    });
    return id
  };
  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true;
      }
    }
  };
}
var raf_1 = function(fn) {
  return raf.call(root, fn)
};
var cancel = function() {
  caf.apply(root, arguments);
};
var polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf;
  object.cancelAnimationFrame = caf;
};
raf_1.cancel = cancel;
raf_1.polyfill = polyfill;

var debounce = function (func, wait, immediate) {
    if (immediate === void 0) { immediate = false; }
    var timeout;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // @ts-ignore
        var context = this;
        var later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        // @ts-ignore
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
};

var ScrollableListViewWrapper = styled.ul(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n  display: block;\n  flex: auto;\n  width: 100%;\n  position: relative;\n"], ["\n  display: block;\n  flex: auto;\n  width: 100%;\n  position: relative;\n"])));
var RowItemWrapper = styled(Box)(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var ItemCountWrapper = customStyled(Flex)(templateObject_3$l || (templateObject_3$l = __makeTemplateObject(["\n  position: sticky;\n  border-radius: 20px;\n  justify-content: flex-end;\n  padding: 2px 2px 2px 10px;\n  z-index: 2;\n  bottom: 30px;\n  cursor: pointer;\n  margin: -40px 10px auto auto;\n  text-transform: capitalize;\n"], ["\n  position: sticky;\n  border-radius: 20px;\n  justify-content: flex-end;\n  padding: 2px 2px 2px 10px;\n  z-index: 2;\n  bottom: 30px;\n  cursor: pointer;\n  margin: -40px 10px auto auto;\n  text-transform: capitalize;\n"])));
var BackToTop = styled(Flex)(templateObject_4$g || (templateObject_4$g = __makeTemplateObject(["\n  background: #fff;\n  border-radius: 50%;\n  height: 40px;\n  width: 40px;\n  padding-top: 3px;\n  cursor: pointer;\n  position: relative;\n  border: 1px solid #0e5aa7;\n  justify-content: space-evenly;\n\n  & svg {\n    margin-top: 2px;\n  }\n"], ["\n  background: #fff;\n  border-radius: 50%;\n  height: 40px;\n  width: 40px;\n  padding-top: 3px;\n  cursor: pointer;\n  position: relative;\n  border: 1px solid #0e5aa7;\n  justify-content: space-evenly;\n\n  & svg {\n    margin-top: 2px;\n  }\n"])));
var TotalProducts = styled(Box)(templateObject_5$c || (templateObject_5$c = __makeTemplateObject(["\n  margin: 6px 10px;\n"], ["\n  margin: 6px 10px;\n"])));
var ScrollbleViewContainer = styled(Box)(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject([""], [""])));
var templateObject_1$w, templateObject_2$p, templateObject_3$l, templateObject_4$g, templateObject_5$c, templateObject_6$9;

// const ItemCount: React.FunctionComponent<{ total: number; currentCount: number }> = ({ total, currentCount }) => {
var ItemCount = function () {
    var onClick = useRef(function () {
        window.scrollTo({ top: 0 });
    });
    return (React__default.createElement(ItemCountWrapper, { "data-testid": "scrolled-items-count", onClick: onClick.current },
        React__default.createElement(BackToTop, { "data-testid": "scroll-to-top" },
            React__default.createElement(TopArrow, { fill: "#0E5AA7", size: "M" }))));
};
// export default React.memo(
//   ItemCount,
//   ({ currentCount: prevCurrentCount, total: prevTotal }, { currentCount, total }) =>
//     prevCurrentCount - currentCount === 0 && prevTotal - total === 0,
// );
var ItemCount$1 = React__default.memo(ItemCount);

var visibleElements;
var ScrollableListView = function (_a) {
    var onScrollEndHandler = _a.onScrollEndHandler, _b = _a.testId, testId = _b === void 0 ? 'scrollable-list-view' : _b, _c = _a.hasMore, hasMore = _c === void 0 ? true : _c, children = _a.children, _d = _a.countMultiplier, countMultiplier = _d === void 0 ? 1 : _d, _e = _a.showCounter, showCounter = _e === void 0 ? false : _e, _f = _a.displayAfterProducts, displayAfterProducts = _f === void 0 ? 1 : _f;
    var loader = useRef(onScrollEndHandler);
    var _g = useState(null), element = _g[0], setElement = _g[1];
    var observer = useRef(isBrowser$1()
        ? new IntersectionObserver(function (entries) {
            var first = entries[0];
            if (first && first.isIntersecting && loader.current) {
                loader.current();
            }
        }, { threshold: 0.25 })
        : null);
    var isMobile = useBreakpoints().isMobile;
    useEffect(function () {
        loader.current = onScrollEndHandler;
        visibleElements = new Set();
    }, [onScrollEndHandler]);
    useEffect(function () {
        var currentElement = element;
        var currentObserver = observer.current;
        if (currentElement && currentObserver) {
            currentObserver.observe(currentElement);
        }
        return function () {
            if (currentElement && currentObserver) {
                currentObserver.unobserve(currentElement);
            }
        };
    }, [element]);
    var _h = useState(0), counter = _h[0], setCounter = _h[1];
    var onViewRef = useRef(debounce(function () {
        raf_1(function () {
            var count = Math.max.apply(Math, Array.from(visibleElements)) + 1;
            setCounter(function (prevCount) {
                if (prevCount !== count) {
                    return count;
                }
                return prevCount;
            });
        });
    }, 10));
    var totalProductsDisplayed = counter * countMultiplier;
    if (!children) {
        return null;
    }
    return (React__default.createElement(ScrollableListViewWrapper, { "data-testid": testId },
        React__default.createElement(ScrollbleViewContainer, { mb: isMobile ? 6 : 0 }, React__default.Children.map(children, function (child, rowIndex) {
            return (React__default.createElement(RowItem, { onView: onViewRef.current, index: rowIndex, key: rowIndex }, child));
        })),
        hasMore && React__default.createElement("li", { "data-testid": "trolly-load-more-element", ref: setElement }),
        showCounter && totalProductsDisplayed > displayAfterProducts && (
        // <ItemCount currentCount={totalProductsDisplayed} total={countMultiplier * React.Children.count(children)} />
        React__default.createElement(ItemCount$1, null)
        // </ItemCount>
        )));
};
var RowItem = function (_a) {
    var children = _a.children, index = _a.index, onView = _a.onView;
    var _b = useState(index < 8), inView = _b[0], setInView = _b[1];
    var _c = useState(0), setHeight = _c[1];
    var _d = useState(null), element = _d[0], setElement = _d[1];
    var observer = useRef(isBrowser$1()
        ? new IntersectionObserver(function (entries) {
            var first = entries[0];
            if (first && first.isIntersecting) {
                setInView(true);
                visibleElements.add(index);
                onView();
            }
            else if (first && !first.isIntersecting) {
                visibleElements.delete(index);
                if (visibleElements.has(0)) {
                    onView();
                }
            }
        }, { rootMargin: '10px', threshold: 0.25 })
        : null);
    useEffect(function () {
        var currentElement = element;
        var currentObserver = observer.current;
        if (currentElement && currentObserver) {
            currentObserver.observe(currentElement);
            // @ts-ignore
            var childHeight_1 = currentElement.firstChild ? currentElement.firstChild.clientHeight : 0;
            if (childHeight_1 > 0) {
                setHeight(function (prevHeight) { return (prevHeight !== childHeight_1 ? childHeight_1 : prevHeight); });
            }
        }
        return function () {
            if (currentElement && currentObserver) {
                currentObserver.unobserve(currentElement);
            }
        };
    }, [element]);
    return (React__default.createElement(RowItemWrapper, { minHeight: !inView ? '60vh' : '0px', ref: setElement }, inView && children));
};

var FeaturedLinksWrapper = customStyled(Card)(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n    border: 1px solid ", ";\n\n    h2 {\n        font-size: ", "px;\n        font-weight: ", ";\n        margin-bottom: ", "px;\n        text-transform: capitalize;\n    }\n"], ["\n    border: 1px solid ", ";\n\n    h2 {\n        font-size: ", "px;\n        font-weight: ", ";\n        margin-bottom: ", "px;\n        text-transform: capitalize;\n    }\n"])), function (props) { return props.theme.colors.wildSand; }, function (props) { return props.theme.fontSizes[3]; }, function (props) { return props.theme.fontWeights[6]; }, function (props) { return props.theme.space[4]; });
var FeaturedLinksBlock = customStyled.div(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n    &:not(:last-of-type) {\n        margin-bottom: ", "px;\n    }\n"], ["\n    &:not(:last-of-type) {\n        margin-bottom: ", "px;\n    }\n"])), function (props) { return props.theme.space[4]; });
var FeaturedLinksUl = customStyled.ul(templateObject_3$m || (templateObject_3$m = __makeTemplateObject(["\n    list-style-type: none;\n"], ["\n    list-style-type: none;\n"])));
var FeaturedLinksLi = customStyled.li(templateObject_4$h || (templateObject_4$h = __makeTemplateObject(["\n    &:not(:first-of-type) {\n        margin-top: ", "px;\n    }\n"], ["\n    &:not(:first-of-type) {\n        margin-top: ", "px;\n    }\n"])), function (props) { return props.theme.space[3]; });
var FeaturedLinksA = customStyled.a(templateObject_5$d || (templateObject_5$d = __makeTemplateObject(["\n    align-items: center;\n    color: #333;\n    display: flex;\n    font-family: 'Montserrat';\n    font-weight: ", ";\n    justify-content: space-between;\n    text-decoration: none;\n    cursor:pointer;\n\n    > span {\n        color: #909090;\n        font-size: ", "px;\n    }\n    &.active{\n        color:", ";\n    }\n"], ["\n    align-items: center;\n    color: #333;\n    display: flex;\n    font-family: 'Montserrat';\n    font-weight: ", ";\n    justify-content: space-between;\n    text-decoration: none;\n    cursor:pointer;\n\n    > span {\n        color: #909090;\n        font-size: ", "px;\n    }\n    &.active{\n        color:", ";\n    }\n"])), function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.fontSizes[0]; }, function (props) { return props.theme.colors.blue; });
var templateObject_1$x, templateObject_2$q, templateObject_3$m, templateObject_4$h, templateObject_5$d;

var FeaturedLinks = function (_a) {
    var featuredLinks = _a.featuredLinks, clickHandler = _a.clickHandler, _b = _a.activeIndex, activeIndex = _b === void 0 ? '' : _b;
    var onClickHandler = useCallback(function (index, title, code, value) { return function () { return clickHandler(index, title, code, value); }; }, [
        clickHandler,
    ]);
    return (React__default.createElement(FeaturedLinksWrapper, { as: "div", elevation: 0, p: 3 }, featuredLinks.map(function (_a) {
        var title = _a.title, links = _a.links, code = _a.code;
        return (React__default.createElement(FeaturedLinksBlock, { key: title },
            title && React__default.createElement("h2", null, title),
            React__default.createElement(FeaturedLinksUl, null, links.map(function (_a, index) {
                var count = _a.count, href = _a.href, label = _a.label, value = _a.value;
                return (React__default.createElement(FeaturedLinksLi, { key: index }, clickHandler ? (React__default.createElement(FeaturedLinksA, { onClick: onClickHandler(index, title, code, value), className: "" + (activeIndex === title + "-" + index ? 'active' : ''), "data-filter-type": title, "data-testid": "btn-filter-" + title + "-" + index },
                    label,
                    count && React__default.createElement("span", null,
                        "(",
                        count,
                        ")"))) : (React__default.createElement(FeaturedLinksA, { href: href },
                    label,
                    count && React__default.createElement("span", null,
                        "(",
                        count,
                        ")")))));
            }))));
    })));
};

var CapsuleWrapper = customStyled(Flex)(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n    ", "\n    font-size: ", "px;\n    justify-content: space-between;\n"], ["\n    ", "\n    font-size: ", "px;\n    justify-content: space-between;\n"])), function (props) { return (props.withPointer ? "cursor: pointer;" : ''); }, function (props) { return props.theme.fontSizes[1]; });
var CapsuleContent = customStyled(Flex)(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n    align-items: center;\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 2px;\n    padding: ", "px;\n    max-height: 32px;\n    justify-content: space-around;\n    text-align: center;\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n\n    span {\n        font-weight: ", ";\n        color: ", ";\n    }\n"], ["\n    align-items: center;\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 2px;\n    padding: ", "px;\n    max-height: 32px;\n    justify-content: space-around;\n    text-align: center;\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n\n    span {\n        font-weight: ", ";\n        color: ", ";\n    }\n"])), function (props) { return props.backgroundColor; }, function (props) { return props.theme.colors.alto; }, function (props) { return (!props.hasLabel && props.isValueElement ? 5 : 10); }, background, border, space, width, boxShadow, function (props) { return props.theme.fontWeights[3]; }, function (props) { return props.theme.colors.darkGray; });
var CapsuleValue = customStyled.div(templateObject_3$n || (templateObject_3$n = __makeTemplateObject(["\n    display: inline-block;\n    ", ";\n    ", ";\n    ", ";\n"], ["\n    display: inline-block;\n    ", ";\n    ", ";\n    ", ";\n"])), fontStyle, fontWeight, fontFamily$1);
var CapsuleAction = customStyled.div(templateObject_4$i || (templateObject_4$i = __makeTemplateObject(["\n    position: relative;\n    top: 3px;\n    margin-left: 5px;\n\n    svg {\n        width: 12px;\n        height: 12px;\n    }\n"], ["\n    position: relative;\n    top: 3px;\n    margin-left: 5px;\n\n    svg {\n        width: 12px;\n        height: 12px;\n    }\n"])));
var CapsuleElementValue = customStyled.div(templateObject_5$e || (templateObject_5$e = __makeTemplateObject(["\n    display: inherit;\n    margin-left: ", ";\n"], ["\n    display: inherit;\n    margin-left: ", ";\n"])), function (props) { return (props.hasLabel ? "5px" : 0); });
var templateObject_1$y, templateObject_2$r, templateObject_3$n, templateObject_4$i, templateObject_5$e;

var CapsulesWrapper = customStyled(Flex)(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n    align-items: center;\n    font-size: ", "px;\n    white-space: nowrap;\n    \n    b {\n        font-weight: ", ";\n    }\n\n    ", ";\n    ", ";\n"], ["\n    align-items: center;\n    font-size: ", "px;\n    white-space: nowrap;\n    \n    b {\n        font-weight: ", ";\n    }\n\n    ", ";\n    ", ";\n"])), function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.fontWeights[5]; }, space, overflow);
var CapsulesHolder = customStyled.div(templateObject_2$s || (templateObject_2$s = __makeTemplateObject(["\n    &:not(:first-of-type) {\n        margin-left: ", "px;\n    }\n"], ["\n    &:not(:first-of-type) {\n        margin-left: ", "px;\n    }\n"])), function (props) { return props.theme.space[2]; });
var ClearText = customStyled(CapsuleContent)(templateObject_3$o || (templateObject_3$o = __makeTemplateObject(["\n    color: ", ";\n    cursor: pointer;\n    min-width: auto;\n    font-weight: ", ";\n    \n    ", "   \n"], ["\n    color: ", ";\n    cursor: pointer;\n    min-width: auto;\n    font-weight: ", ";\n    \n    ",
    "   \n"])), function (props) { return props.theme.colors.blue; }, function (props) { return props.theme.fontWeights[5]; }, function (props) {
    return props.responsive
        ? "\n        background-color: transparent;\n        border: 0;\n        margin-left: " + props.theme.space[3] + "px;\n        padding: 0;\n    "
        : "\n            border-color: " + props.theme.colors.blue + ";\n            margin-left: 0;\n            " + background + ";\n            " + border + ";\n        ";
});
var templateObject_1$z, templateObject_2$s, templateObject_3$o;

var Capsule = function (_a) {
    var _b = _a.label, label = _b === void 0 ? '' : _b, value = _a.value, isRemovable = _a.isRemovable, _c = _a.responsive, isResponsive = _c === void 0 ? false : _c, _d = _a.withPointer, withPointer = _d === void 0 ? false : _d, _e = _a.width, width = _e === void 0 ? 'auto' : _e, _f = _a.backgroundColor, backgroundColor = _f === void 0 ? 'white' : _f, rest = __rest(_a, ["label", "value", "isRemovable", "responsive", "withPointer", "width", "backgroundColor"]);
    var isMobile = useBreakpoints().isMobile;
    var condition = useMemo(function () { return typeof value === 'string'; }, [value]);
    var responsive = useMemo(function () {
        var hasLabel = label !== '';
        if (!isResponsive && hasLabel) {
            return true;
        }
        return !isMobile && hasLabel;
    }, [isMobile, label, isResponsive]);
    var renderView = useCallback(function () {
        var Container = condition ? customStyled.div(templateObject_1$A || (templateObject_1$A = __makeTemplateObject([""], [""]))) : Flex;
        return (React__default.createElement(Container, __assign({ "data-testid": "tag-content" }, (!condition ? { alignItems: 'center' } : {})),
            responsive && React__default.createElement("span", null,
                label,
                ": "),
            condition ? (React__default.createElement(CapsuleValue, null, value)) : (React__default.createElement(CapsuleElementValue, { "data-testid": "tag-content-element", hasLabel: label !== '' }, value))));
    }, [condition, label, responsive, value]);
    return (React__default.createElement(CapsuleWrapper, { "data-testid": "tag-wrapper", isRemovable: isRemovable, withPointer: withPointer },
        React__default.createElement(CapsuleContent, __assign({ hasLabel: label !== '', "data-testid": "tag-wrapper-element", isValueElement: !condition, width: width, backgroundColor: backgroundColor }, rest),
            renderView(),
            isRemovable && (React__default.createElement(CapsuleAction, null,
                React__default.createElement(Cross, null))))));
};
var templateObject_1$A;

var Capsules = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, list = _a.list, onClick = _a.onClick, onClear = _a.onClear, _c = _a.overflowProps, overflowProps = _c === void 0 ? { overflow: 'auto' } : _c, onClearText = _a.onClearText, _d = _a.responsive, isResponsive = _d === void 0 ? false : _d, _e = _a.capsuleStyles, capsuleStyles = _e === void 0 ? {} : _e, _f = _a.capsuleValueStyles, capsuleValueStyles = _f === void 0 ? {} : _f, _g = _a.withRemoveIcon, withRemoveIcon = _g === void 0 ? false : _g, rest = __rest(_a, ["title", "list", "onClick", "onClear", "overflowProps", "onClearText", "responsive", "capsuleStyles", "capsuleValueStyles", "withRemoveIcon"]);
    var isMobile = useBreakpoints().isMobile;
    var onClickCb = useCallback(function (data) { return function () {
        if (onClick) {
            onClick(data);
        }
    }; }, [onClick]);
    var renderClearText = useCallback(function () {
        if (onClear && onClearText) {
            return (React__default.createElement(ClearText, __assign({ "data-testid": "clear", responsive: (isResponsive && !isMobile) || !isResponsive, onClick: onClear }, capsuleStyles), onClearText));
        }
        return null;
    }, [capsuleStyles, isMobile, isResponsive, onClear, onClearText]);
    if (list.length < 1)
        return null;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(CapsulesWrapper, __assign({}, overflowProps, rest),
            isMobile && renderClearText(),
            list.map(function (data) {
                var label = data.label, value = data.value;
                return (React__default.createElement(CapsulesHolder, __assign({ title: title, key: label + "-" + value }, (onClick ? { onClick: onClickCb(data) } : {})),
                    React__default.createElement(Capsule, __assign({ label: label, value: value, responsive: isResponsive, isRemovable: withRemoveIcon, withPointer: typeof onClick !== 'undefined' }, capsuleStyles, capsuleValueStyles))));
            }),
            !isMobile && renderClearText())));
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".rc-slider {\n    position: relative;\n    height: 14px;\n    padding: 5px 0;\n    width: 100%;\n    border-radius: 6px;\n    touch-action: none;\n    box-sizing: border-box;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  }\n  .rc-slider * {\n    box-sizing: border-box;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  }\n  .rc-slider-rail {\n    position: absolute;\n    width: 100%;\n    background-color: #e9e9e9;\n    height: 4px;\n    border-radius: 6px;\n  }\n  .rc-slider-track {\n    position: absolute;\n    left: 0;\n    height: 4px;\n    border-radius: 6px;\n    background-color: #abe2fb;\n  }\n  .rc-slider-handle {\n    position: absolute;\n    width: 14px;\n    height: 14px;\n    cursor: pointer;\n    cursor: -webkit-grab;\n    margin-top: -5px;\n    cursor: grab;\n    border-radius: 50%;\n    border: solid 2px #96dbfa;\n    background-color: #fff;\n    touch-action: pan-x;\n  }\n  .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n    border-color: #57c5f7;\n    box-shadow: 0 0 0 5px #96dbfa;\n  }\n  .rc-slider-handle:focus {\n    outline: none;\n  }\n  .rc-slider-handle-click-focused:focus {\n    border-color: #96dbfa;\n    box-shadow: unset;\n  }\n  .rc-slider-handle:hover {\n    border-color: #57c5f7;\n  }\n  .rc-slider-handle:active {\n    border-color: #57c5f7;\n    box-shadow: 0 0 5px #57c5f7;\n    cursor: grabbing;\n  }\n  .rc-slider-mark {\n    position: absolute;\n    top: 18px;\n    left: 0;\n    width: 100%;\n    font-size: 12px;\n  }\n  .rc-slider-mark-text {\n    position: absolute;\n    display: inline-block;\n    vertical-align: middle;\n    text-align: center;\n    cursor: pointer;\n    color: #999;\n  }\n  .rc-slider-mark-text-active {\n    color: #666;\n  }\n  .rc-slider-step {\n    position: absolute;\n    width: 100%;\n    height: 4px;\n    background: transparent;\n  }\n  .rc-slider-dot {\n    position: absolute;\n    bottom: -2px;\n    margin-left: -4px;\n    width: 8px;\n    height: 8px;\n    border: 2px solid #e9e9e9;\n    background-color: #fff;\n    cursor: pointer;\n    border-radius: 50%;\n    vertical-align: middle;\n  }\n  .rc-slider-dot-active {\n    border-color: #96dbfa;\n  }\n  .rc-slider-dot-reverse {\n    margin-right: -4px;\n  }\n  .rc-slider-disabled {\n    background-color: #e9e9e9;\n  }\n  .rc-slider-disabled .rc-slider-track {\n    background-color: #ccc;\n  }\n  .rc-slider-disabled .rc-slider-handle,\n  .rc-slider-disabled .rc-slider-dot {\n    border-color: #ccc;\n    box-shadow: none;\n    background-color: #fff;\n    cursor: not-allowed;\n  }\n  .rc-slider-disabled .rc-slider-mark-text,\n  .rc-slider-disabled .rc-slider-dot {\n    cursor: not-allowed !important;\n  }\n  .rc-slider-vertical {\n    width: 14px;\n    height: 100%;\n    padding: 0 5px;\n  }\n  .rc-slider-vertical .rc-slider-rail {\n    height: 100%;\n    width: 4px;\n  }\n  .rc-slider-vertical .rc-slider-track {\n    left: 5px;\n    bottom: 0;\n    width: 4px;\n  }\n  .rc-slider-vertical .rc-slider-handle {\n    margin-left: -5px;\n    touch-action: pan-y;\n  }\n  .rc-slider-vertical .rc-slider-mark {\n    top: 0;\n    left: 18px;\n    height: 100%;\n  }\n  .rc-slider-vertical .rc-slider-step {\n    height: 100%;\n    width: 4px;\n  }\n  .rc-slider-vertical .rc-slider-dot {\n    left: 2px;\n    margin-bottom: -4px;\n  }\n  .rc-slider-vertical .rc-slider-dot:first-child {\n    margin-bottom: -4px;\n  }\n  .rc-slider-vertical .rc-slider-dot:last-child {\n    margin-bottom: -4px;\n  }\n  .rc-slider-tooltip-zoom-down-enter,\n  .rc-slider-tooltip-zoom-down-appear {\n    animation-duration: 0.3s;\n    animation-fill-mode: both;\n    display: block !important;\n    animation-play-state: paused;\n  }\n  .rc-slider-tooltip-zoom-down-leave {\n    animation-duration: 0.3s;\n    animation-fill-mode: both;\n    display: block !important;\n    animation-play-state: paused;\n  }\n  .rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,\n  .rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {\n    animation-name: rcSliderTooltipZoomDownIn;\n    animation-play-state: running;\n  }\n  .rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {\n    animation-name: rcSliderTooltipZoomDownOut;\n    animation-play-state: running;\n  }\n  .rc-slider-tooltip-zoom-down-enter,\n  .rc-slider-tooltip-zoom-down-appear {\n    transform: scale(0, 0);\n    animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n  }\n  .rc-slider-tooltip-zoom-down-leave {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n  }\n  @keyframes rcSliderTooltipZoomDownIn {\n    0% {\n      opacity: 0;\n      transform-origin: 50% 100%;\n      transform: scale(0, 0);\n    }\n    100% {\n      transform-origin: 50% 100%;\n      transform: scale(1, 1);\n    }\n  }\n  @keyframes rcSliderTooltipZoomDownOut {\n    0% {\n      transform-origin: 50% 100%;\n      transform: scale(1, 1);\n    }\n    100% {\n      opacity: 0;\n      transform-origin: 50% 100%;\n      transform: scale(0, 0);\n    }\n  }\n  .rc-slider-tooltip {\n    position: absolute;\n    left: -9999px;\n    top: -9999px;\n    visibility: visible;\n    box-sizing: border-box;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  }\n  .rc-slider-tooltip * {\n    box-sizing: border-box;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  }\n  .rc-slider-tooltip-hidden {\n    display: none;\n  }\n  .rc-slider-tooltip-placement-top {\n    padding: 4px 0 8px 0;\n  }\n  .rc-slider-tooltip-inner {\n    padding: 6px 2px;\n    min-width: 24px;\n    height: 24px;\n    font-size: 12px;\n    line-height: 1;\n    color: #fff;\n    text-align: center;\n    text-decoration: none;\n    background-color: #6c6c6c;\n    border-radius: 6px;\n    box-shadow: 0 0 4px #d9d9d9;\n  }\n  .rc-slider-tooltip-arrow {\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-color: transparent;\n    border-style: solid;\n  }\n  .rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {\n    bottom: 4px;\n    left: 50%;\n    margin-left: -4px;\n    border-width: 4px 4px 0;\n    border-top-color: #6c6c6c;\n  }\n  \n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLGtCQUFrQjtJQUNsQixZQUFZO0lBQ1osY0FBYztJQUNkLFdBQVc7SUFDWCxrQkFBa0I7SUFDbEIsa0JBQWtCO0lBQ2xCLHNCQUFzQjtJQUN0Qiw2Q0FBNkM7RUFDL0M7RUFDQTtJQUNFLHNCQUFzQjtJQUN0Qiw2Q0FBNkM7RUFDL0M7RUFDQTtJQUNFLGtCQUFrQjtJQUNsQixXQUFXO0lBQ1gseUJBQXlCO0lBQ3pCLFdBQVc7SUFDWCxrQkFBa0I7RUFDcEI7RUFDQTtJQUNFLGtCQUFrQjtJQUNsQixPQUFPO0lBQ1AsV0FBVztJQUNYLGtCQUFrQjtJQUNsQix5QkFBeUI7RUFDM0I7RUFDQTtJQUNFLGtCQUFrQjtJQUNsQixXQUFXO0lBQ1gsWUFBWTtJQUNaLGVBQWU7SUFDZixvQkFBb0I7SUFDcEIsZ0JBQWdCO0lBQ2hCLFlBQVk7SUFDWixrQkFBa0I7SUFDbEIseUJBQXlCO0lBQ3pCLHNCQUFzQjtJQUN0QixtQkFBbUI7RUFDckI7RUFDQTtJQUNFLHFCQUFxQjtJQUNyQiw2QkFBNkI7RUFDL0I7RUFDQTtJQUNFLGFBQWE7RUFDZjtFQUNBO0lBQ0UscUJBQXFCO0lBQ3JCLGlCQUFpQjtFQUNuQjtFQUNBO0lBQ0UscUJBQXFCO0VBQ3ZCO0VBQ0E7SUFDRSxxQkFBcUI7SUFDckIsMkJBQTJCO0lBRTNCLGdCQUFnQjtFQUNsQjtFQUNBO0lBQ0Usa0JBQWtCO0lBQ2xCLFNBQVM7SUFDVCxPQUFPO0lBQ1AsV0FBVztJQUNYLGVBQWU7RUFDakI7RUFDQTtJQUNFLGtCQUFrQjtJQUNsQixxQkFBcUI7SUFDckIsc0JBQXNCO0lBQ3RCLGtCQUFrQjtJQUNsQixlQUFlO0lBQ2YsV0FBVztFQUNiO0VBQ0E7SUFDRSxXQUFXO0VBQ2I7RUFDQTtJQUNFLGtCQUFrQjtJQUNsQixXQUFXO0lBQ1gsV0FBVztJQUNYLHVCQUF1QjtFQUN6QjtFQUNBO0lBQ0Usa0JBQWtCO0lBQ2xCLFlBQVk7SUFDWixpQkFBaUI7SUFDakIsVUFBVTtJQUNWLFdBQVc7SUFDWCx5QkFBeUI7SUFDekIsc0JBQXNCO0lBQ3RCLGVBQWU7SUFDZixrQkFBa0I7SUFDbEIsc0JBQXNCO0VBQ3hCO0VBQ0E7SUFDRSxxQkFBcUI7RUFDdkI7RUFDQTtJQUNFLGtCQUFrQjtFQUNwQjtFQUNBO0lBQ0UseUJBQXlCO0VBQzNCO0VBQ0E7SUFDRSxzQkFBc0I7RUFDeEI7RUFDQTs7SUFFRSxrQkFBa0I7SUFDbEIsZ0JBQWdCO0lBQ2hCLHNCQUFzQjtJQUN0QixtQkFBbUI7RUFDckI7RUFDQTs7SUFFRSw4QkFBOEI7RUFDaEM7RUFDQTtJQUNFLFdBQVc7SUFDWCxZQUFZO0lBQ1osY0FBYztFQUNoQjtFQUNBO0lBQ0UsWUFBWTtJQUNaLFVBQVU7RUFDWjtFQUNBO0lBQ0UsU0FBUztJQUNULFNBQVM7SUFDVCxVQUFVO0VBQ1o7RUFDQTtJQUNFLGlCQUFpQjtJQUNqQixtQkFBbUI7RUFDckI7RUFDQTtJQUNFLE1BQU07SUFDTixVQUFVO0lBQ1YsWUFBWTtFQUNkO0VBQ0E7SUFDRSxZQUFZO0lBQ1osVUFBVTtFQUNaO0VBQ0E7SUFDRSxTQUFTO0lBQ1QsbUJBQW1CO0VBQ3JCO0VBQ0E7SUFDRSxtQkFBbUI7RUFDckI7RUFDQTtJQUNFLG1CQUFtQjtFQUNyQjtFQUNBOztJQUVFLHdCQUF3QjtJQUN4Qix5QkFBeUI7SUFDekIseUJBQXlCO0lBQ3pCLDRCQUE0QjtFQUM5QjtFQUNBO0lBQ0Usd0JBQXdCO0lBQ3hCLHlCQUF5QjtJQUN6Qix5QkFBeUI7SUFDekIsNEJBQTRCO0VBQzlCO0VBQ0E7O0lBRUUseUNBQXlDO0lBQ3pDLDZCQUE2QjtFQUMvQjtFQUNBO0lBQ0UsMENBQTBDO0lBQzFDLDZCQUE2QjtFQUMvQjtFQUNBOztJQUVFLHNCQUFzQjtJQUN0Qix5REFBeUQ7RUFDM0Q7RUFDQTtJQUNFLGlFQUFpRTtFQUNuRTtFQUNBO0lBQ0U7TUFDRSxVQUFVO01BQ1YsMEJBQTBCO01BQzFCLHNCQUFzQjtJQUN4QjtJQUNBO01BQ0UsMEJBQTBCO01BQzFCLHNCQUFzQjtJQUN4QjtFQUNGO0VBQ0E7SUFDRTtNQUNFLDBCQUEwQjtNQUMxQixzQkFBc0I7SUFDeEI7SUFDQTtNQUNFLFVBQVU7TUFDViwwQkFBMEI7TUFDMUIsc0JBQXNCO0lBQ3hCO0VBQ0Y7RUFDQTtJQUNFLGtCQUFrQjtJQUNsQixhQUFhO0lBQ2IsWUFBWTtJQUNaLG1CQUFtQjtJQUNuQixzQkFBc0I7SUFDdEIsNkNBQTZDO0VBQy9DO0VBQ0E7SUFDRSxzQkFBc0I7SUFDdEIsNkNBQTZDO0VBQy9DO0VBQ0E7SUFDRSxhQUFhO0VBQ2Y7RUFDQTtJQUNFLG9CQUFvQjtFQUN0QjtFQUNBO0lBQ0UsZ0JBQWdCO0lBQ2hCLGVBQWU7SUFDZixZQUFZO0lBQ1osZUFBZTtJQUNmLGNBQWM7SUFDZCxXQUFXO0lBQ1gsa0JBQWtCO0lBQ2xCLHFCQUFxQjtJQUNyQix5QkFBeUI7SUFDekIsa0JBQWtCO0lBQ2xCLDJCQUEyQjtFQUM3QjtFQUNBO0lBQ0Usa0JBQWtCO0lBQ2xCLFFBQVE7SUFDUixTQUFTO0lBQ1QseUJBQXlCO0lBQ3pCLG1CQUFtQjtFQUNyQjtFQUNBO0lBQ0UsV0FBVztJQUNYLFNBQVM7SUFDVCxpQkFBaUI7SUFDakIsdUJBQXVCO0lBQ3ZCLHlCQUF5QjtFQUMzQiIsImZpbGUiOiJpbmRleC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIucmMtc2xpZGVyIHtcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgaGVpZ2h0OiAxNHB4O1xuICAgIHBhZGRpbmc6IDVweCAwO1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGJvcmRlci1yYWRpdXM6IDZweDtcbiAgICB0b3VjaC1hY3Rpb246IG5vbmU7XG4gICAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgICAtd2Via2l0LXRhcC1oaWdobGlnaHQtY29sb3I6IHJnYmEoMCwgMCwgMCwgMCk7XG4gIH1cbiAgLnJjLXNsaWRlciAqIHtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICAgIC13ZWJraXQtdGFwLWhpZ2hsaWdodC1jb2xvcjogcmdiYSgwLCAwLCAwLCAwKTtcbiAgfVxuICAucmMtc2xpZGVyLXJhaWwge1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZTllOWU5O1xuICAgIGhlaWdodDogNHB4O1xuICAgIGJvcmRlci1yYWRpdXM6IDZweDtcbiAgfVxuICAucmMtc2xpZGVyLXRyYWNrIHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgbGVmdDogMDtcbiAgICBoZWlnaHQ6IDRweDtcbiAgICBib3JkZXItcmFkaXVzOiA2cHg7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogI2FiZTJmYjtcbiAgfVxuICAucmMtc2xpZGVyLWhhbmRsZSB7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHdpZHRoOiAxNHB4O1xuICAgIGhlaWdodDogMTRweDtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgY3Vyc29yOiAtd2Via2l0LWdyYWI7XG4gICAgbWFyZ2luLXRvcDogLTVweDtcbiAgICBjdXJzb3I6IGdyYWI7XG4gICAgYm9yZGVyLXJhZGl1czogNTAlO1xuICAgIGJvcmRlcjogc29saWQgMnB4ICM5NmRiZmE7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogI2ZmZjtcbiAgICB0b3VjaC1hY3Rpb246IHBhbi14O1xuICB9XG4gIC5yYy1zbGlkZXItaGFuZGxlLWRyYWdnaW5nLnJjLXNsaWRlci1oYW5kbGUtZHJhZ2dpbmcucmMtc2xpZGVyLWhhbmRsZS1kcmFnZ2luZyB7XG4gICAgYm9yZGVyLWNvbG9yOiAjNTdjNWY3O1xuICAgIGJveC1zaGFkb3c6IDAgMCAwIDVweCAjOTZkYmZhO1xuICB9XG4gIC5yYy1zbGlkZXItaGFuZGxlOmZvY3VzIHtcbiAgICBvdXRsaW5lOiBub25lO1xuICB9XG4gIC5yYy1zbGlkZXItaGFuZGxlLWNsaWNrLWZvY3VzZWQ6Zm9jdXMge1xuICAgIGJvcmRlci1jb2xvcjogIzk2ZGJmYTtcbiAgICBib3gtc2hhZG93OiB1bnNldDtcbiAgfVxuICAucmMtc2xpZGVyLWhhbmRsZTpob3ZlciB7XG4gICAgYm9yZGVyLWNvbG9yOiAjNTdjNWY3O1xuICB9XG4gIC5yYy1zbGlkZXItaGFuZGxlOmFjdGl2ZSB7XG4gICAgYm9yZGVyLWNvbG9yOiAjNTdjNWY3O1xuICAgIGJveC1zaGFkb3c6IDAgMCA1cHggIzU3YzVmNztcbiAgICBjdXJzb3I6IC13ZWJraXQtZ3JhYmJpbmc7XG4gICAgY3Vyc29yOiBncmFiYmluZztcbiAgfVxuICAucmMtc2xpZGVyLW1hcmsge1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB0b3A6IDE4cHg7XG4gICAgbGVmdDogMDtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBmb250LXNpemU6IDEycHg7XG4gIH1cbiAgLnJjLXNsaWRlci1tYXJrLXRleHQge1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gICAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICAgIGNvbG9yOiAjOTk5O1xuICB9XG4gIC5yYy1zbGlkZXItbWFyay10ZXh0LWFjdGl2ZSB7XG4gICAgY29sb3I6ICM2NjY7XG4gIH1cbiAgLnJjLXNsaWRlci1zdGVwIHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgaGVpZ2h0OiA0cHg7XG4gICAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7XG4gIH1cbiAgLnJjLXNsaWRlci1kb3Qge1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICBib3R0b206IC0ycHg7XG4gICAgbWFyZ2luLWxlZnQ6IC00cHg7XG4gICAgd2lkdGg6IDhweDtcbiAgICBoZWlnaHQ6IDhweDtcbiAgICBib3JkZXI6IDJweCBzb2xpZCAjZTllOWU5O1xuICAgIGJhY2tncm91bmQtY29sb3I6ICNmZmY7XG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICAgIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlO1xuICB9XG4gIC5yYy1zbGlkZXItZG90LWFjdGl2ZSB7XG4gICAgYm9yZGVyLWNvbG9yOiAjOTZkYmZhO1xuICB9XG4gIC5yYy1zbGlkZXItZG90LXJldmVyc2Uge1xuICAgIG1hcmdpbi1yaWdodDogLTRweDtcbiAgfVxuICAucmMtc2xpZGVyLWRpc2FibGVkIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZTllOWU5O1xuICB9XG4gIC5yYy1zbGlkZXItZGlzYWJsZWQgLnJjLXNsaWRlci10cmFjayB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogI2NjYztcbiAgfVxuICAucmMtc2xpZGVyLWRpc2FibGVkIC5yYy1zbGlkZXItaGFuZGxlLFxuICAucmMtc2xpZGVyLWRpc2FibGVkIC5yYy1zbGlkZXItZG90IHtcbiAgICBib3JkZXItY29sb3I6ICNjY2M7XG4gICAgYm94LXNoYWRvdzogbm9uZTtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmO1xuICAgIGN1cnNvcjogbm90LWFsbG93ZWQ7XG4gIH1cbiAgLnJjLXNsaWRlci1kaXNhYmxlZCAucmMtc2xpZGVyLW1hcmstdGV4dCxcbiAgLnJjLXNsaWRlci1kaXNhYmxlZCAucmMtc2xpZGVyLWRvdCB7XG4gICAgY3Vyc29yOiBub3QtYWxsb3dlZCAhaW1wb3J0YW50O1xuICB9XG4gIC5yYy1zbGlkZXItdmVydGljYWwge1xuICAgIHdpZHRoOiAxNHB4O1xuICAgIGhlaWdodDogMTAwJTtcbiAgICBwYWRkaW5nOiAwIDVweDtcbiAgfVxuICAucmMtc2xpZGVyLXZlcnRpY2FsIC5yYy1zbGlkZXItcmFpbCB7XG4gICAgaGVpZ2h0OiAxMDAlO1xuICAgIHdpZHRoOiA0cHg7XG4gIH1cbiAgLnJjLXNsaWRlci12ZXJ0aWNhbCAucmMtc2xpZGVyLXRyYWNrIHtcbiAgICBsZWZ0OiA1cHg7XG4gICAgYm90dG9tOiAwO1xuICAgIHdpZHRoOiA0cHg7XG4gIH1cbiAgLnJjLXNsaWRlci12ZXJ0aWNhbCAucmMtc2xpZGVyLWhhbmRsZSB7XG4gICAgbWFyZ2luLWxlZnQ6IC01cHg7XG4gICAgdG91Y2gtYWN0aW9uOiBwYW4teTtcbiAgfVxuICAucmMtc2xpZGVyLXZlcnRpY2FsIC5yYy1zbGlkZXItbWFyayB7XG4gICAgdG9wOiAwO1xuICAgIGxlZnQ6IDE4cHg7XG4gICAgaGVpZ2h0OiAxMDAlO1xuICB9XG4gIC5yYy1zbGlkZXItdmVydGljYWwgLnJjLXNsaWRlci1zdGVwIHtcbiAgICBoZWlnaHQ6IDEwMCU7XG4gICAgd2lkdGg6IDRweDtcbiAgfVxuICAucmMtc2xpZGVyLXZlcnRpY2FsIC5yYy1zbGlkZXItZG90IHtcbiAgICBsZWZ0OiAycHg7XG4gICAgbWFyZ2luLWJvdHRvbTogLTRweDtcbiAgfVxuICAucmMtc2xpZGVyLXZlcnRpY2FsIC5yYy1zbGlkZXItZG90OmZpcnN0LWNoaWxkIHtcbiAgICBtYXJnaW4tYm90dG9tOiAtNHB4O1xuICB9XG4gIC5yYy1zbGlkZXItdmVydGljYWwgLnJjLXNsaWRlci1kb3Q6bGFzdC1jaGlsZCB7XG4gICAgbWFyZ2luLWJvdHRvbTogLTRweDtcbiAgfVxuICAucmMtc2xpZGVyLXRvb2x0aXAtem9vbS1kb3duLWVudGVyLFxuICAucmMtc2xpZGVyLXRvb2x0aXAtem9vbS1kb3duLWFwcGVhciB7XG4gICAgYW5pbWF0aW9uLWR1cmF0aW9uOiAwLjNzO1xuICAgIGFuaW1hdGlvbi1maWxsLW1vZGU6IGJvdGg7XG4gICAgZGlzcGxheTogYmxvY2sgIWltcG9ydGFudDtcbiAgICBhbmltYXRpb24tcGxheS1zdGF0ZTogcGF1c2VkO1xuICB9XG4gIC5yYy1zbGlkZXItdG9vbHRpcC16b29tLWRvd24tbGVhdmUge1xuICAgIGFuaW1hdGlvbi1kdXJhdGlvbjogMC4zcztcbiAgICBhbmltYXRpb24tZmlsbC1tb2RlOiBib3RoO1xuICAgIGRpc3BsYXk6IGJsb2NrICFpbXBvcnRhbnQ7XG4gICAgYW5pbWF0aW9uLXBsYXktc3RhdGU6IHBhdXNlZDtcbiAgfVxuICAucmMtc2xpZGVyLXRvb2x0aXAtem9vbS1kb3duLWVudGVyLnJjLXNsaWRlci10b29sdGlwLXpvb20tZG93bi1lbnRlci1hY3RpdmUsXG4gIC5yYy1zbGlkZXItdG9vbHRpcC16b29tLWRvd24tYXBwZWFyLnJjLXNsaWRlci10b29sdGlwLXpvb20tZG93bi1hcHBlYXItYWN0aXZlIHtcbiAgICBhbmltYXRpb24tbmFtZTogcmNTbGlkZXJUb29sdGlwWm9vbURvd25JbjtcbiAgICBhbmltYXRpb24tcGxheS1zdGF0ZTogcnVubmluZztcbiAgfVxuICAucmMtc2xpZGVyLXRvb2x0aXAtem9vbS1kb3duLWxlYXZlLnJjLXNsaWRlci10b29sdGlwLXpvb20tZG93bi1sZWF2ZS1hY3RpdmUge1xuICAgIGFuaW1hdGlvbi1uYW1lOiByY1NsaWRlclRvb2x0aXBab29tRG93bk91dDtcbiAgICBhbmltYXRpb24tcGxheS1zdGF0ZTogcnVubmluZztcbiAgfVxuICAucmMtc2xpZGVyLXRvb2x0aXAtem9vbS1kb3duLWVudGVyLFxuICAucmMtc2xpZGVyLXRvb2x0aXAtem9vbS1kb3duLWFwcGVhciB7XG4gICAgdHJhbnNmb3JtOiBzY2FsZSgwLCAwKTtcbiAgICBhbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOiBjdWJpYy1iZXppZXIoMC4yMywgMSwgMC4zMiwgMSk7XG4gIH1cbiAgLnJjLXNsaWRlci10b29sdGlwLXpvb20tZG93bi1sZWF2ZSB7XG4gICAgYW5pbWF0aW9uLXRpbWluZy1mdW5jdGlvbjogY3ViaWMtYmV6aWVyKDAuNzU1LCAwLjA1LCAwLjg1NSwgMC4wNik7XG4gIH1cbiAgQGtleWZyYW1lcyByY1NsaWRlclRvb2x0aXBab29tRG93bkluIHtcbiAgICAwJSB7XG4gICAgICBvcGFjaXR5OiAwO1xuICAgICAgdHJhbnNmb3JtLW9yaWdpbjogNTAlIDEwMCU7XG4gICAgICB0cmFuc2Zvcm06IHNjYWxlKDAsIDApO1xuICAgIH1cbiAgICAxMDAlIHtcbiAgICAgIHRyYW5zZm9ybS1vcmlnaW46IDUwJSAxMDAlO1xuICAgICAgdHJhbnNmb3JtOiBzY2FsZSgxLCAxKTtcbiAgICB9XG4gIH1cbiAgQGtleWZyYW1lcyByY1NsaWRlclRvb2x0aXBab29tRG93bk91dCB7XG4gICAgMCUge1xuICAgICAgdHJhbnNmb3JtLW9yaWdpbjogNTAlIDEwMCU7XG4gICAgICB0cmFuc2Zvcm06IHNjYWxlKDEsIDEpO1xuICAgIH1cbiAgICAxMDAlIHtcbiAgICAgIG9wYWNpdHk6IDA7XG4gICAgICB0cmFuc2Zvcm0tb3JpZ2luOiA1MCUgMTAwJTtcbiAgICAgIHRyYW5zZm9ybTogc2NhbGUoMCwgMCk7XG4gICAgfVxuICB9XG4gIC5yYy1zbGlkZXItdG9vbHRpcCB7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIGxlZnQ6IC05OTk5cHg7XG4gICAgdG9wOiAtOTk5OXB4O1xuICAgIHZpc2liaWxpdHk6IHZpc2libGU7XG4gICAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgICAtd2Via2l0LXRhcC1oaWdobGlnaHQtY29sb3I6IHJnYmEoMCwgMCwgMCwgMCk7XG4gIH1cbiAgLnJjLXNsaWRlci10b29sdGlwICoge1xuICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gICAgLXdlYmtpdC10YXAtaGlnaGxpZ2h0LWNvbG9yOiByZ2JhKDAsIDAsIDAsIDApO1xuICB9XG4gIC5yYy1zbGlkZXItdG9vbHRpcC1oaWRkZW4ge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbiAgLnJjLXNsaWRlci10b29sdGlwLXBsYWNlbWVudC10b3Age1xuICAgIHBhZGRpbmc6IDRweCAwIDhweCAwO1xuICB9XG4gIC5yYy1zbGlkZXItdG9vbHRpcC1pbm5lciB7XG4gICAgcGFkZGluZzogNnB4IDJweDtcbiAgICBtaW4td2lkdGg6IDI0cHg7XG4gICAgaGVpZ2h0OiAyNHB4O1xuICAgIGZvbnQtc2l6ZTogMTJweDtcbiAgICBsaW5lLWhlaWdodDogMTtcbiAgICBjb2xvcjogI2ZmZjtcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuICAgIGJhY2tncm91bmQtY29sb3I6ICM2YzZjNmM7XG4gICAgYm9yZGVyLXJhZGl1czogNnB4O1xuICAgIGJveC1zaGFkb3c6IDAgMCA0cHggI2Q5ZDlkOTtcbiAgfVxuICAucmMtc2xpZGVyLXRvb2x0aXAtYXJyb3cge1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB3aWR0aDogMDtcbiAgICBoZWlnaHQ6IDA7XG4gICAgYm9yZGVyLWNvbG9yOiB0cmFuc3BhcmVudDtcbiAgICBib3JkZXItc3R5bGU6IHNvbGlkO1xuICB9XG4gIC5yYy1zbGlkZXItdG9vbHRpcC1wbGFjZW1lbnQtdG9wIC5yYy1zbGlkZXItdG9vbHRpcC1hcnJvdyB7XG4gICAgYm90dG9tOiA0cHg7XG4gICAgbGVmdDogNTAlO1xuICAgIG1hcmdpbi1sZWZ0OiAtNHB4O1xuICAgIGJvcmRlci13aWR0aDogNHB4IDRweCAwO1xuICAgIGJvcmRlci10b3AtY29sb3I6ICM2YzZjNmM7XG4gIH1cbiAgIl19 */";
styleInject(css_248z);

var RangeWrapper = customStyled.div(templateObject_1$B || (templateObject_1$B = __makeTemplateObject(["\n    width: 100%;\n    position : relative;\n\n    .rc-slider-handle.rc-slider-handle-dragging {\n        box-shadow: 0 0 0 5px rgba(14, 90, 167, 0.15);\n    }\n"], ["\n    width: 100%;\n    position : relative;\n\n    .rc-slider-handle.rc-slider-handle-dragging {\n        box-shadow: 0 0 0 5px rgba(14, 90, 167, 0.15);\n    }\n"])));
var RangeInput = styled.input(templateObject_2$t || (templateObject_2$t = __makeTemplateObject(["\n  pointer-events: none;\n  position: absolute;\n  height: 0;\n  width: 100%;\n  outline: none;\n  -webkit-appearance: none;\n  -webkit-tap-highlight-color: transparent;\n  -moz-appearance: none;\n  z-index: ", ";\n\n  &::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    -webkit-tap-highlight-color: transparent;\n    background-color: rgb(14, 90, 167);\n    border: none;\n    border-radius: 50%;\n    box-shadow: 0 0 1px 1px #ced4da;\n    cursor: pointer;\n    height: 18px;\n    width: 18px;\n    margin-top: 4px;\n    pointer-events: all;\n    position: relative;\n  }\n  &::-moz-range-thumb {\n    background-color: rgb(14, 90, 167);\n    border: none;\n    border-radius: 50%;\n    box-shadow: 0 0 1px 1px #ced4da;\n    cursor: pointer;\n    height: 16px;\n    width: 16px;\n    margin-top: 4px;\n    pointer-events: all;\n    position: relative;\n  }\n"], ["\n  pointer-events: none;\n  position: absolute;\n  height: 0;\n  width: 100%;\n  outline: none;\n  -webkit-appearance: none;\n  -webkit-tap-highlight-color: transparent;\n  -moz-appearance: none;\n  z-index: ", ";\n\n  &::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    -webkit-tap-highlight-color: transparent;\n    background-color: rgb(14, 90, 167);\n    border: none;\n    border-radius: 50%;\n    box-shadow: 0 0 1px 1px #ced4da;\n    cursor: pointer;\n    height: 18px;\n    width: 18px;\n    margin-top: 4px;\n    pointer-events: all;\n    position: relative;\n  }\n  &::-moz-range-thumb {\n    background-color: rgb(14, 90, 167);\n    border: none;\n    border-radius: 50%;\n    box-shadow: 0 0 1px 1px #ced4da;\n    cursor: pointer;\n    height: 16px;\n    width: 16px;\n    margin-top: 4px;\n    pointer-events: all;\n    position: relative;\n  }\n"])), function (props) { return (props.isLeft ? 3 : 4); });
var Slider = customStyled(Box)(templateObject_3$p || (templateObject_3$p = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n"])));
var SliderTrack = customStyled(Box)(templateObject_4$j || (templateObject_4$j = __makeTemplateObject(["\n  position: absolute;\n  border-radius: 3px;\n  height: 4px;\n  background-color: #ced4da;\n  width: 100%;\n  z-index: 1;\n"], ["\n  position: absolute;\n  border-radius: 3px;\n  height: 4px;\n  background-color: #ced4da;\n  width: 100%;\n  z-index: 1;\n"])));
var SliderRange = customStyled(Box)(templateObject_5$f || (templateObject_5$f = __makeTemplateObject(["\n  position: absolute;\n  border-radius: 3px;\n  height: 4px;\n  background-color: rgb(14, 90, 167);\n  z-index: 2;\n"], ["\n  position: absolute;\n  border-radius: 3px;\n  height: 4px;\n  background-color: rgb(14, 90, 167);\n  z-index: 2;\n"])));
var templateObject_1$B, templateObject_2$t, templateObject_3$p, templateObject_4$j, templateObject_5$f;

var Range = function (_a) {
    var _b = _a.min, min = _b === void 0 ? 1 : _b, _c = _a.max, max = _c === void 0 ? 10 : _c, _d = _a.step, step = _d === void 0 ? 0 : _d, _e = _a.value, value = _e === void 0 ? [] : _e, onChange = _a.onChange, rest = __rest(_a, ["min", "max", "step", "value", "onChange"]);
    var range = useRef(null);
    var getPercent = useCallback(function (value) { return Math.round(((value - min) / (max - min)) * 100); }, [min, max]);
    useEffect(function () {
        var minPercent = value[0] < min ? 1 : getPercent(value[0]);
        var maxPercent = value[1] > max ? 100 : getPercent(value[1]);
        if (range.current) {
            range.current.style.left = minPercent + "%";
            range.current.style.width = maxPercent - minPercent + "%";
        }
    }, [value, getPercent, max, min]);
    return (React__default.createElement(RangeWrapper, null,
        React__default.createElement(RangeInput, __assign({ type: "range", "data-testid": "range-min", min: min, max: max, step: step, value: value[0], onChange: function (e) { return onChange(e.target.value, 'min'); } }, rest)),
        React__default.createElement(RangeInput, __assign({ type: "range", "data-testid": "range-max", min: min, max: max, step: step, value: value[1], onChange: function (e) { return onChange(e.target.value, 'max'); } }, rest)),
        React__default.createElement(Slider, null,
            React__default.createElement(SliderTrack, null),
            React__default.createElement(SliderRange, { ref: range }))));
};

var TabWrapper = customStyled(Flex)(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n  flex-direction: column;\n  width: 100%;\n"], ["\n  flex-direction: column;\n  width: 100%;\n"])));
var TabLabel = customStyled(Card)(templateObject_2$u || (templateObject_2$u = __makeTemplateObject(["\n  border-bottom: ", ";\n  margin-bottom: 20px;\n  border-radius: 0px;\n  cursor: pointer;\n  flex: 1;\n"], ["\n  border-bottom: ",
    ";\n  margin-bottom: 20px;\n  border-radius: 0px;\n  cursor: pointer;\n  flex: 1;\n"])), function (_a) {
    var selected = _a.selected, theme = _a.theme;
    return selected ? "2px solid " + theme.colors.blue : "2px solid " + theme.colors.silver;
});
TabLabel.defaultProps = {
    elevation: 0,
    as: 'div',
};
var templateObject_1$C, templateObject_2$u;

var Tabs = function (_a) {
    var children = _a.children, _b = _a.selectedIndex, propsIndex = _b === void 0 ? 0 : _b, labels = _a.labels, onLabelClick = _a.onLabelClick;
    var _c = useState(propsIndex), selectedIndex = _c[0], setSelectedIndex = _c[1];
    var onClickHandler = useCallback(function (index) { return function () {
        setSelectedIndex(index);
        if (onLabelClick) {
            onLabelClick(index);
        }
    }; }, [onLabelClick]);
    return (React__default.createElement(Flex, { width: "100%", flexDirection: "row", justifyContent: "flex-start" },
        React__default.createElement(TabWrapper, null,
            React__default.createElement(Flex, null, labels.map(function (__child, index) {
                var selected = index === selectedIndex;
                var labelText = labels[index];
                return (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(TabLabel, { key: labelText, "data-testid": labelText, onClick: onClickHandler(index), selected: selected },
                        React__default.createElement(Text, { textAlign: "center", paddingY: "5px", fontWeight: selected ? theme.fontWeights[5] : theme.fontWeights[4], fontSize: [theme.fontSizes[3], theme.fontSizes[4], theme.fontSizes[5]], color: selected ? theme.colors.blue : theme.colors.copy }, labelText))));
            })),
            React__default.createElement(Flex, { "data-testid": "tab-content-" + selectedIndex }, children[selectedIndex]))));
};



var index$2 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

export { Accordion, theme as BASE_THEME, ModalBackdrop as Backdrop, Banner, Brands, Breadcrumb, Button, ButtonGroup, ButtonGroupItem, Capsule, Capsules, Card, Carousel, Checkbox, CoachMark, Drawer, FeaturedLinks, Image, ImageCircle, ImageCircleContainer, Input, LazyImage, LinearProgress$2 as LinearProgress, Modal, NewBanner, Notification, Palette, RadioButton, RadioGroup, Range, ScrollableListView, SearchableListView, Select, SlideNavigation, Sticker, Switch, Tabs, Text, MemoizedTheme as ThemeProvider, Tooltip, index$2 as Types, customStyled };
